/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.chart || ($protobuf.roots.chart = {});

export const quotestore = ($root.quotestore = (() => {
  /**
   * Namespace quotestore.
   * @exports quotestore
   * @namespace
   */
  const quotestore = {};

  quotestore.Request = (function () {
    /**
     * Properties of a Request.
     * @memberof quotestore
     * @interface IRequest
     * @property {number|null} [id] Request id
     * @property {quotestore.ICandlesSubRequest|null} [candlesSubRequest] Request candlesSubRequest
     * @property {quotestore.ICandlesUnsubRequest|null} [candlesUnsubRequest] Request candlesUnsubRequest
     * @property {quotestore.IGetBarsRequest|null} [getBarsRequest] Request getBarsRequest
     * @property {quotestore.IResolveSymbolRequest|null} [resolveSymbolRequest] Request resolveSymbolRequest
     * @property {quotestore.ISubscribeBarsRequest|null} [subscribeBarsRequest] Request subscribeBarsRequest
     * @property {quotestore.ISearchSymbolsRequest|null} [searchSymbolsRequest] Request searchSymbolsRequest
     * @property {quotestore.IUnsubscribeBarsRequest|null} [unsubscribeBarsRequest] Request unsubscribeBarsRequest
     * @property {quotestore.IAuthRequest|null} [authRequest] Request authRequest
     */

    /**
     * Constructs a new Request.
     * @memberof quotestore
     * @classdesc Represents a Request.
     * @implements IRequest
     * @constructor
     * @param {quotestore.IRequest=} [properties] Properties to set
     */
    function Request(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Request id.
     * @member {number} id
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.id = 0;

    /**
     * Request candlesSubRequest.
     * @member {quotestore.ICandlesSubRequest|null|undefined} candlesSubRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.candlesSubRequest = null;

    /**
     * Request candlesUnsubRequest.
     * @member {quotestore.ICandlesUnsubRequest|null|undefined} candlesUnsubRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.candlesUnsubRequest = null;

    /**
     * Request getBarsRequest.
     * @member {quotestore.IGetBarsRequest|null|undefined} getBarsRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.getBarsRequest = null;

    /**
     * Request resolveSymbolRequest.
     * @member {quotestore.IResolveSymbolRequest|null|undefined} resolveSymbolRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.resolveSymbolRequest = null;

    /**
     * Request subscribeBarsRequest.
     * @member {quotestore.ISubscribeBarsRequest|null|undefined} subscribeBarsRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.subscribeBarsRequest = null;

    /**
     * Request searchSymbolsRequest.
     * @member {quotestore.ISearchSymbolsRequest|null|undefined} searchSymbolsRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.searchSymbolsRequest = null;

    /**
     * Request unsubscribeBarsRequest.
     * @member {quotestore.IUnsubscribeBarsRequest|null|undefined} unsubscribeBarsRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.unsubscribeBarsRequest = null;

    /**
     * Request authRequest.
     * @member {quotestore.IAuthRequest|null|undefined} authRequest
     * @memberof quotestore.Request
     * @instance
     */
    Request.prototype.authRequest = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Request type.
     * @member {"candlesSubRequest"|"candlesUnsubRequest"|"getBarsRequest"|"resolveSymbolRequest"|"subscribeBarsRequest"|"searchSymbolsRequest"|"unsubscribeBarsRequest"|"authRequest"|undefined} type
     * @memberof quotestore.Request
     * @instance
     */
    Object.defineProperty(Request.prototype, 'type', {
      get: $util.oneOfGetter(
        ($oneOfFields = [
          'candlesSubRequest',
          'candlesUnsubRequest',
          'getBarsRequest',
          'resolveSymbolRequest',
          'subscribeBarsRequest',
          'searchSymbolsRequest',
          'unsubscribeBarsRequest',
          'authRequest',
        ]),
      ),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Request instance using the specified properties.
     * @function create
     * @memberof quotestore.Request
     * @static
     * @param {quotestore.IRequest=} [properties] Properties to set
     * @returns {quotestore.Request} Request instance
     */
    Request.create = function create(properties) {
      return new Request(properties);
    };

    /**
     * Encodes the specified Request message. Does not implicitly {@link quotestore.Request.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Request
     * @static
     * @param {quotestore.IRequest} message Request message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Request.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, 'id'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.id);
      if (message.candlesSubRequest != null && Object.hasOwnProperty.call(message, 'candlesSubRequest'))
        $root.quotestore.CandlesSubRequest.encode(
          message.candlesSubRequest,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
        ).ldelim();
      if (message.candlesUnsubRequest != null && Object.hasOwnProperty.call(message, 'candlesUnsubRequest'))
        $root.quotestore.CandlesUnsubRequest.encode(
          message.candlesUnsubRequest,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
        ).ldelim();
      if (message.getBarsRequest != null && Object.hasOwnProperty.call(message, 'getBarsRequest'))
        $root.quotestore.GetBarsRequest.encode(
          message.getBarsRequest,
          writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
        ).ldelim();
      if (message.resolveSymbolRequest != null && Object.hasOwnProperty.call(message, 'resolveSymbolRequest'))
        $root.quotestore.ResolveSymbolRequest.encode(
          message.resolveSymbolRequest,
          writer.uint32(/* id 5, wireType 2 =*/ 42).fork(),
        ).ldelim();
      if (message.subscribeBarsRequest != null && Object.hasOwnProperty.call(message, 'subscribeBarsRequest'))
        $root.quotestore.SubscribeBarsRequest.encode(
          message.subscribeBarsRequest,
          writer.uint32(/* id 6, wireType 2 =*/ 50).fork(),
        ).ldelim();
      if (message.searchSymbolsRequest != null && Object.hasOwnProperty.call(message, 'searchSymbolsRequest'))
        $root.quotestore.SearchSymbolsRequest.encode(
          message.searchSymbolsRequest,
          writer.uint32(/* id 7, wireType 2 =*/ 58).fork(),
        ).ldelim();
      if (message.unsubscribeBarsRequest != null && Object.hasOwnProperty.call(message, 'unsubscribeBarsRequest'))
        $root.quotestore.UnsubscribeBarsRequest.encode(
          message.unsubscribeBarsRequest,
          writer.uint32(/* id 8, wireType 2 =*/ 66).fork(),
        ).ldelim();
      if (message.authRequest != null && Object.hasOwnProperty.call(message, 'authRequest'))
        $root.quotestore.AuthRequest.encode(
          message.authRequest,
          writer.uint32(/* id 9, wireType 2 =*/ 74).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Request message, length delimited. Does not implicitly {@link quotestore.Request.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Request
     * @static
     * @param {quotestore.IRequest} message Request message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Request.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Request message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Request
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Request} Request
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Request.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Request();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.id = reader.int32();
            break;
          }
          case 2: {
            message.candlesSubRequest = $root.quotestore.CandlesSubRequest.decode(reader, reader.uint32());
            break;
          }
          case 3: {
            message.candlesUnsubRequest = $root.quotestore.CandlesUnsubRequest.decode(reader, reader.uint32());
            break;
          }
          case 4: {
            message.getBarsRequest = $root.quotestore.GetBarsRequest.decode(reader, reader.uint32());
            break;
          }
          case 5: {
            message.resolveSymbolRequest = $root.quotestore.ResolveSymbolRequest.decode(reader, reader.uint32());
            break;
          }
          case 6: {
            message.subscribeBarsRequest = $root.quotestore.SubscribeBarsRequest.decode(reader, reader.uint32());
            break;
          }
          case 7: {
            message.searchSymbolsRequest = $root.quotestore.SearchSymbolsRequest.decode(reader, reader.uint32());
            break;
          }
          case 8: {
            message.unsubscribeBarsRequest = $root.quotestore.UnsubscribeBarsRequest.decode(reader, reader.uint32());
            break;
          }
          case 9: {
            message.authRequest = $root.quotestore.AuthRequest.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Request message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Request
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Request} Request
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Request.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Request message.
     * @function verify
     * @memberof quotestore.Request
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Request.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.id != null && message.hasOwnProperty('id'))
        if (!$util.isInteger(message.id)) return 'id: integer expected';
      if (message.candlesSubRequest != null && message.hasOwnProperty('candlesSubRequest')) {
        properties.type = 1;
        {
          let error = $root.quotestore.CandlesSubRequest.verify(message.candlesSubRequest);
          if (error) return 'candlesSubRequest.' + error;
        }
      }
      if (message.candlesUnsubRequest != null && message.hasOwnProperty('candlesUnsubRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.CandlesUnsubRequest.verify(message.candlesUnsubRequest);
          if (error) return 'candlesUnsubRequest.' + error;
        }
      }
      if (message.getBarsRequest != null && message.hasOwnProperty('getBarsRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.GetBarsRequest.verify(message.getBarsRequest);
          if (error) return 'getBarsRequest.' + error;
        }
      }
      if (message.resolveSymbolRequest != null && message.hasOwnProperty('resolveSymbolRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.ResolveSymbolRequest.verify(message.resolveSymbolRequest);
          if (error) return 'resolveSymbolRequest.' + error;
        }
      }
      if (message.subscribeBarsRequest != null && message.hasOwnProperty('subscribeBarsRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.SubscribeBarsRequest.verify(message.subscribeBarsRequest);
          if (error) return 'subscribeBarsRequest.' + error;
        }
      }
      if (message.searchSymbolsRequest != null && message.hasOwnProperty('searchSymbolsRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.SearchSymbolsRequest.verify(message.searchSymbolsRequest);
          if (error) return 'searchSymbolsRequest.' + error;
        }
      }
      if (message.unsubscribeBarsRequest != null && message.hasOwnProperty('unsubscribeBarsRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.UnsubscribeBarsRequest.verify(message.unsubscribeBarsRequest);
          if (error) return 'unsubscribeBarsRequest.' + error;
        }
      }
      if (message.authRequest != null && message.hasOwnProperty('authRequest')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.AuthRequest.verify(message.authRequest);
          if (error) return 'authRequest.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Request message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Request
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Request} Request
     */
    Request.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Request) return object;
      let message = new $root.quotestore.Request();
      if (object.id != null) message.id = object.id | 0;
      if (object.candlesSubRequest != null) {
        if (typeof object.candlesSubRequest !== 'object')
          throw TypeError('.quotestore.Request.candlesSubRequest: object expected');
        message.candlesSubRequest = $root.quotestore.CandlesSubRequest.fromObject(object.candlesSubRequest);
      }
      if (object.candlesUnsubRequest != null) {
        if (typeof object.candlesUnsubRequest !== 'object')
          throw TypeError('.quotestore.Request.candlesUnsubRequest: object expected');
        message.candlesUnsubRequest = $root.quotestore.CandlesUnsubRequest.fromObject(object.candlesUnsubRequest);
      }
      if (object.getBarsRequest != null) {
        if (typeof object.getBarsRequest !== 'object')
          throw TypeError('.quotestore.Request.getBarsRequest: object expected');
        message.getBarsRequest = $root.quotestore.GetBarsRequest.fromObject(object.getBarsRequest);
      }
      if (object.resolveSymbolRequest != null) {
        if (typeof object.resolveSymbolRequest !== 'object')
          throw TypeError('.quotestore.Request.resolveSymbolRequest: object expected');
        message.resolveSymbolRequest = $root.quotestore.ResolveSymbolRequest.fromObject(object.resolveSymbolRequest);
      }
      if (object.subscribeBarsRequest != null) {
        if (typeof object.subscribeBarsRequest !== 'object')
          throw TypeError('.quotestore.Request.subscribeBarsRequest: object expected');
        message.subscribeBarsRequest = $root.quotestore.SubscribeBarsRequest.fromObject(object.subscribeBarsRequest);
      }
      if (object.searchSymbolsRequest != null) {
        if (typeof object.searchSymbolsRequest !== 'object')
          throw TypeError('.quotestore.Request.searchSymbolsRequest: object expected');
        message.searchSymbolsRequest = $root.quotestore.SearchSymbolsRequest.fromObject(object.searchSymbolsRequest);
      }
      if (object.unsubscribeBarsRequest != null) {
        if (typeof object.unsubscribeBarsRequest !== 'object')
          throw TypeError('.quotestore.Request.unsubscribeBarsRequest: object expected');
        message.unsubscribeBarsRequest = $root.quotestore.UnsubscribeBarsRequest.fromObject(
          object.unsubscribeBarsRequest,
        );
      }
      if (object.authRequest != null) {
        if (typeof object.authRequest !== 'object') throw TypeError('.quotestore.Request.authRequest: object expected');
        message.authRequest = $root.quotestore.AuthRequest.fromObject(object.authRequest);
      }
      return message;
    };

    /**
     * Creates a plain object from a Request message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Request
     * @static
     * @param {quotestore.Request} message Request
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Request.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.id = 0;
      if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
      if (message.candlesSubRequest != null && message.hasOwnProperty('candlesSubRequest')) {
        object.candlesSubRequest = $root.quotestore.CandlesSubRequest.toObject(message.candlesSubRequest, options);
        if (options.oneofs) object.type = 'candlesSubRequest';
      }
      if (message.candlesUnsubRequest != null && message.hasOwnProperty('candlesUnsubRequest')) {
        object.candlesUnsubRequest = $root.quotestore.CandlesUnsubRequest.toObject(
          message.candlesUnsubRequest,
          options,
        );
        if (options.oneofs) object.type = 'candlesUnsubRequest';
      }
      if (message.getBarsRequest != null && message.hasOwnProperty('getBarsRequest')) {
        object.getBarsRequest = $root.quotestore.GetBarsRequest.toObject(message.getBarsRequest, options);
        if (options.oneofs) object.type = 'getBarsRequest';
      }
      if (message.resolveSymbolRequest != null && message.hasOwnProperty('resolveSymbolRequest')) {
        object.resolveSymbolRequest = $root.quotestore.ResolveSymbolRequest.toObject(
          message.resolveSymbolRequest,
          options,
        );
        if (options.oneofs) object.type = 'resolveSymbolRequest';
      }
      if (message.subscribeBarsRequest != null && message.hasOwnProperty('subscribeBarsRequest')) {
        object.subscribeBarsRequest = $root.quotestore.SubscribeBarsRequest.toObject(
          message.subscribeBarsRequest,
          options,
        );
        if (options.oneofs) object.type = 'subscribeBarsRequest';
      }
      if (message.searchSymbolsRequest != null && message.hasOwnProperty('searchSymbolsRequest')) {
        object.searchSymbolsRequest = $root.quotestore.SearchSymbolsRequest.toObject(
          message.searchSymbolsRequest,
          options,
        );
        if (options.oneofs) object.type = 'searchSymbolsRequest';
      }
      if (message.unsubscribeBarsRequest != null && message.hasOwnProperty('unsubscribeBarsRequest')) {
        object.unsubscribeBarsRequest = $root.quotestore.UnsubscribeBarsRequest.toObject(
          message.unsubscribeBarsRequest,
          options,
        );
        if (options.oneofs) object.type = 'unsubscribeBarsRequest';
      }
      if (message.authRequest != null && message.hasOwnProperty('authRequest')) {
        object.authRequest = $root.quotestore.AuthRequest.toObject(message.authRequest, options);
        if (options.oneofs) object.type = 'authRequest';
      }
      return object;
    };

    /**
     * Converts this Request to JSON.
     * @function toJSON
     * @memberof quotestore.Request
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Request.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Request;
  })();

  quotestore.Response = (function () {
    /**
     * Properties of a Response.
     * @memberof quotestore
     * @interface IResponse
     * @property {number|null} [requestId] Response requestId
     * @property {quotestore.IError|null} [error] Response error
     * @property {quotestore.ICandlesResponse|null} [candles] Response candles
     * @property {quotestore.IHeartbeat|null} [heartbeat] Response heartbeat
     * @property {quotestore.IGetBarsResponse|null} [getBarsResponse] Response getBarsResponse
     * @property {quotestore.IResolveSymbolResponse|null} [resolveSymbolResponse] Response resolveSymbolResponse
     * @property {quotestore.ISubscribeBarsResponse|null} [subscribeBarsResponse] Response subscribeBarsResponse
     * @property {quotestore.ISearchSymbolsResponse|null} [searchSymbolsResponse] Response searchSymbolsResponse
     * @property {quotestore.IUnsubscribeBarsResponse|null} [unsubscribeBarsResponse] Response unsubscribeBarsResponse
     * @property {quotestore.ICandleTick|null} [candleTick] Response candleTick
     * @property {quotestore.IAuthResponse|null} [authResponse] Response authResponse
     */

    /**
     * Constructs a new Response.
     * @memberof quotestore
     * @classdesc Represents a Response.
     * @implements IResponse
     * @constructor
     * @param {quotestore.IResponse=} [properties] Properties to set
     */
    function Response(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Response requestId.
     * @member {number} requestId
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.requestId = 0;

    /**
     * Response error.
     * @member {quotestore.IError|null|undefined} error
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.error = null;

    /**
     * Response candles.
     * @member {quotestore.ICandlesResponse|null|undefined} candles
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.candles = null;

    /**
     * Response heartbeat.
     * @member {quotestore.IHeartbeat|null|undefined} heartbeat
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.heartbeat = null;

    /**
     * Response getBarsResponse.
     * @member {quotestore.IGetBarsResponse|null|undefined} getBarsResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.getBarsResponse = null;

    /**
     * Response resolveSymbolResponse.
     * @member {quotestore.IResolveSymbolResponse|null|undefined} resolveSymbolResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.resolveSymbolResponse = null;

    /**
     * Response subscribeBarsResponse.
     * @member {quotestore.ISubscribeBarsResponse|null|undefined} subscribeBarsResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.subscribeBarsResponse = null;

    /**
     * Response searchSymbolsResponse.
     * @member {quotestore.ISearchSymbolsResponse|null|undefined} searchSymbolsResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.searchSymbolsResponse = null;

    /**
     * Response unsubscribeBarsResponse.
     * @member {quotestore.IUnsubscribeBarsResponse|null|undefined} unsubscribeBarsResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.unsubscribeBarsResponse = null;

    /**
     * Response candleTick.
     * @member {quotestore.ICandleTick|null|undefined} candleTick
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.candleTick = null;

    /**
     * Response authResponse.
     * @member {quotestore.IAuthResponse|null|undefined} authResponse
     * @memberof quotestore.Response
     * @instance
     */
    Response.prototype.authResponse = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Response type.
     * @member {"candles"|"heartbeat"|"getBarsResponse"|"resolveSymbolResponse"|"subscribeBarsResponse"|"searchSymbolsResponse"|"unsubscribeBarsResponse"|"candleTick"|"authResponse"|undefined} type
     * @memberof quotestore.Response
     * @instance
     */
    Object.defineProperty(Response.prototype, 'type', {
      get: $util.oneOfGetter(
        ($oneOfFields = [
          'candles',
          'heartbeat',
          'getBarsResponse',
          'resolveSymbolResponse',
          'subscribeBarsResponse',
          'searchSymbolsResponse',
          'unsubscribeBarsResponse',
          'candleTick',
          'authResponse',
        ]),
      ),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Response instance using the specified properties.
     * @function create
     * @memberof quotestore.Response
     * @static
     * @param {quotestore.IResponse=} [properties] Properties to set
     * @returns {quotestore.Response} Response instance
     */
    Response.create = function create(properties) {
      return new Response(properties);
    };

    /**
     * Encodes the specified Response message. Does not implicitly {@link quotestore.Response.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Response
     * @static
     * @param {quotestore.IResponse} message Response message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Response.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.requestId != null && Object.hasOwnProperty.call(message, 'requestId'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.requestId);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.quotestore.Error.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      if (message.candles != null && Object.hasOwnProperty.call(message, 'candles'))
        $root.quotestore.CandlesResponse.encode(
          message.candles,
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
        ).ldelim();
      if (message.heartbeat != null && Object.hasOwnProperty.call(message, 'heartbeat'))
        $root.quotestore.Heartbeat.encode(
          message.heartbeat,
          writer.uint32(/* id 11, wireType 2 =*/ 90).fork(),
        ).ldelim();
      if (message.getBarsResponse != null && Object.hasOwnProperty.call(message, 'getBarsResponse'))
        $root.quotestore.GetBarsResponse.encode(
          message.getBarsResponse,
          writer.uint32(/* id 12, wireType 2 =*/ 98).fork(),
        ).ldelim();
      if (message.resolveSymbolResponse != null && Object.hasOwnProperty.call(message, 'resolveSymbolResponse'))
        $root.quotestore.ResolveSymbolResponse.encode(
          message.resolveSymbolResponse,
          writer.uint32(/* id 13, wireType 2 =*/ 106).fork(),
        ).ldelim();
      if (message.subscribeBarsResponse != null && Object.hasOwnProperty.call(message, 'subscribeBarsResponse'))
        $root.quotestore.SubscribeBarsResponse.encode(
          message.subscribeBarsResponse,
          writer.uint32(/* id 14, wireType 2 =*/ 114).fork(),
        ).ldelim();
      if (message.searchSymbolsResponse != null && Object.hasOwnProperty.call(message, 'searchSymbolsResponse'))
        $root.quotestore.SearchSymbolsResponse.encode(
          message.searchSymbolsResponse,
          writer.uint32(/* id 15, wireType 2 =*/ 122).fork(),
        ).ldelim();
      if (message.unsubscribeBarsResponse != null && Object.hasOwnProperty.call(message, 'unsubscribeBarsResponse'))
        $root.quotestore.UnsubscribeBarsResponse.encode(
          message.unsubscribeBarsResponse,
          writer.uint32(/* id 16, wireType 2 =*/ 130).fork(),
        ).ldelim();
      if (message.candleTick != null && Object.hasOwnProperty.call(message, 'candleTick'))
        $root.quotestore.CandleTick.encode(
          message.candleTick,
          writer.uint32(/* id 17, wireType 2 =*/ 138).fork(),
        ).ldelim();
      if (message.authResponse != null && Object.hasOwnProperty.call(message, 'authResponse'))
        $root.quotestore.AuthResponse.encode(
          message.authResponse,
          writer.uint32(/* id 18, wireType 2 =*/ 146).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Response message, length delimited. Does not implicitly {@link quotestore.Response.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Response
     * @static
     * @param {quotestore.IResponse} message Response message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Response.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Response message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Response
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Response} Response
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Response.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Response();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.requestId = reader.int32();
            break;
          }
          case 2: {
            message.error = $root.quotestore.Error.decode(reader, reader.uint32());
            break;
          }
          case 10: {
            message.candles = $root.quotestore.CandlesResponse.decode(reader, reader.uint32());
            break;
          }
          case 11: {
            message.heartbeat = $root.quotestore.Heartbeat.decode(reader, reader.uint32());
            break;
          }
          case 12: {
            message.getBarsResponse = $root.quotestore.GetBarsResponse.decode(reader, reader.uint32());
            break;
          }
          case 13: {
            message.resolveSymbolResponse = $root.quotestore.ResolveSymbolResponse.decode(reader, reader.uint32());
            break;
          }
          case 14: {
            message.subscribeBarsResponse = $root.quotestore.SubscribeBarsResponse.decode(reader, reader.uint32());
            break;
          }
          case 15: {
            message.searchSymbolsResponse = $root.quotestore.SearchSymbolsResponse.decode(reader, reader.uint32());
            break;
          }
          case 16: {
            message.unsubscribeBarsResponse = $root.quotestore.UnsubscribeBarsResponse.decode(reader, reader.uint32());
            break;
          }
          case 17: {
            message.candleTick = $root.quotestore.CandleTick.decode(reader, reader.uint32());
            break;
          }
          case 18: {
            message.authResponse = $root.quotestore.AuthResponse.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Response message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Response
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Response} Response
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Response.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Response message.
     * @function verify
     * @memberof quotestore.Response
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Response.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.requestId != null && message.hasOwnProperty('requestId'))
        if (!$util.isInteger(message.requestId)) return 'requestId: integer expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.quotestore.Error.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.candles != null && message.hasOwnProperty('candles')) {
        properties.type = 1;
        {
          let error = $root.quotestore.CandlesResponse.verify(message.candles);
          if (error) return 'candles.' + error;
        }
      }
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.Heartbeat.verify(message.heartbeat);
          if (error) return 'heartbeat.' + error;
        }
      }
      if (message.getBarsResponse != null && message.hasOwnProperty('getBarsResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.GetBarsResponse.verify(message.getBarsResponse);
          if (error) return 'getBarsResponse.' + error;
        }
      }
      if (message.resolveSymbolResponse != null && message.hasOwnProperty('resolveSymbolResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.ResolveSymbolResponse.verify(message.resolveSymbolResponse);
          if (error) return 'resolveSymbolResponse.' + error;
        }
      }
      if (message.subscribeBarsResponse != null && message.hasOwnProperty('subscribeBarsResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.SubscribeBarsResponse.verify(message.subscribeBarsResponse);
          if (error) return 'subscribeBarsResponse.' + error;
        }
      }
      if (message.searchSymbolsResponse != null && message.hasOwnProperty('searchSymbolsResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.SearchSymbolsResponse.verify(message.searchSymbolsResponse);
          if (error) return 'searchSymbolsResponse.' + error;
        }
      }
      if (message.unsubscribeBarsResponse != null && message.hasOwnProperty('unsubscribeBarsResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.UnsubscribeBarsResponse.verify(message.unsubscribeBarsResponse);
          if (error) return 'unsubscribeBarsResponse.' + error;
        }
      }
      if (message.candleTick != null && message.hasOwnProperty('candleTick')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.CandleTick.verify(message.candleTick);
          if (error) return 'candleTick.' + error;
        }
      }
      if (message.authResponse != null && message.hasOwnProperty('authResponse')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.quotestore.AuthResponse.verify(message.authResponse);
          if (error) return 'authResponse.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Response message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Response
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Response} Response
     */
    Response.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Response) return object;
      let message = new $root.quotestore.Response();
      if (object.requestId != null) message.requestId = object.requestId | 0;
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.quotestore.Response.error: object expected');
        message.error = $root.quotestore.Error.fromObject(object.error);
      }
      if (object.candles != null) {
        if (typeof object.candles !== 'object') throw TypeError('.quotestore.Response.candles: object expected');
        message.candles = $root.quotestore.CandlesResponse.fromObject(object.candles);
      }
      if (object.heartbeat != null) {
        if (typeof object.heartbeat !== 'object') throw TypeError('.quotestore.Response.heartbeat: object expected');
        message.heartbeat = $root.quotestore.Heartbeat.fromObject(object.heartbeat);
      }
      if (object.getBarsResponse != null) {
        if (typeof object.getBarsResponse !== 'object')
          throw TypeError('.quotestore.Response.getBarsResponse: object expected');
        message.getBarsResponse = $root.quotestore.GetBarsResponse.fromObject(object.getBarsResponse);
      }
      if (object.resolveSymbolResponse != null) {
        if (typeof object.resolveSymbolResponse !== 'object')
          throw TypeError('.quotestore.Response.resolveSymbolResponse: object expected');
        message.resolveSymbolResponse = $root.quotestore.ResolveSymbolResponse.fromObject(object.resolveSymbolResponse);
      }
      if (object.subscribeBarsResponse != null) {
        if (typeof object.subscribeBarsResponse !== 'object')
          throw TypeError('.quotestore.Response.subscribeBarsResponse: object expected');
        message.subscribeBarsResponse = $root.quotestore.SubscribeBarsResponse.fromObject(object.subscribeBarsResponse);
      }
      if (object.searchSymbolsResponse != null) {
        if (typeof object.searchSymbolsResponse !== 'object')
          throw TypeError('.quotestore.Response.searchSymbolsResponse: object expected');
        message.searchSymbolsResponse = $root.quotestore.SearchSymbolsResponse.fromObject(object.searchSymbolsResponse);
      }
      if (object.unsubscribeBarsResponse != null) {
        if (typeof object.unsubscribeBarsResponse !== 'object')
          throw TypeError('.quotestore.Response.unsubscribeBarsResponse: object expected');
        message.unsubscribeBarsResponse = $root.quotestore.UnsubscribeBarsResponse.fromObject(
          object.unsubscribeBarsResponse,
        );
      }
      if (object.candleTick != null) {
        if (typeof object.candleTick !== 'object') throw TypeError('.quotestore.Response.candleTick: object expected');
        message.candleTick = $root.quotestore.CandleTick.fromObject(object.candleTick);
      }
      if (object.authResponse != null) {
        if (typeof object.authResponse !== 'object')
          throw TypeError('.quotestore.Response.authResponse: object expected');
        message.authResponse = $root.quotestore.AuthResponse.fromObject(object.authResponse);
      }
      return message;
    };

    /**
     * Creates a plain object from a Response message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Response
     * @static
     * @param {quotestore.Response} message Response
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Response.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.requestId = 0;
        object.error = null;
      }
      if (message.requestId != null && message.hasOwnProperty('requestId')) object.requestId = message.requestId;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.quotestore.Error.toObject(message.error, options);
      if (message.candles != null && message.hasOwnProperty('candles')) {
        object.candles = $root.quotestore.CandlesResponse.toObject(message.candles, options);
        if (options.oneofs) object.type = 'candles';
      }
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        object.heartbeat = $root.quotestore.Heartbeat.toObject(message.heartbeat, options);
        if (options.oneofs) object.type = 'heartbeat';
      }
      if (message.getBarsResponse != null && message.hasOwnProperty('getBarsResponse')) {
        object.getBarsResponse = $root.quotestore.GetBarsResponse.toObject(message.getBarsResponse, options);
        if (options.oneofs) object.type = 'getBarsResponse';
      }
      if (message.resolveSymbolResponse != null && message.hasOwnProperty('resolveSymbolResponse')) {
        object.resolveSymbolResponse = $root.quotestore.ResolveSymbolResponse.toObject(
          message.resolveSymbolResponse,
          options,
        );
        if (options.oneofs) object.type = 'resolveSymbolResponse';
      }
      if (message.subscribeBarsResponse != null && message.hasOwnProperty('subscribeBarsResponse')) {
        object.subscribeBarsResponse = $root.quotestore.SubscribeBarsResponse.toObject(
          message.subscribeBarsResponse,
          options,
        );
        if (options.oneofs) object.type = 'subscribeBarsResponse';
      }
      if (message.searchSymbolsResponse != null && message.hasOwnProperty('searchSymbolsResponse')) {
        object.searchSymbolsResponse = $root.quotestore.SearchSymbolsResponse.toObject(
          message.searchSymbolsResponse,
          options,
        );
        if (options.oneofs) object.type = 'searchSymbolsResponse';
      }
      if (message.unsubscribeBarsResponse != null && message.hasOwnProperty('unsubscribeBarsResponse')) {
        object.unsubscribeBarsResponse = $root.quotestore.UnsubscribeBarsResponse.toObject(
          message.unsubscribeBarsResponse,
          options,
        );
        if (options.oneofs) object.type = 'unsubscribeBarsResponse';
      }
      if (message.candleTick != null && message.hasOwnProperty('candleTick')) {
        object.candleTick = $root.quotestore.CandleTick.toObject(message.candleTick, options);
        if (options.oneofs) object.type = 'candleTick';
      }
      if (message.authResponse != null && message.hasOwnProperty('authResponse')) {
        object.authResponse = $root.quotestore.AuthResponse.toObject(message.authResponse, options);
        if (options.oneofs) object.type = 'authResponse';
      }
      return object;
    };

    /**
     * Converts this Response to JSON.
     * @function toJSON
     * @memberof quotestore.Response
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Response.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Response;
  })();

  quotestore.AuthRequest = (function () {
    /**
     * Properties of an AuthRequest.
     * @memberof quotestore
     * @interface IAuthRequest
     * @property {string|null} [secret] AuthRequest secret
     * @property {string|null} [iamSessionId] AuthRequest iamSessionId
     */

    /**
     * Constructs a new AuthRequest.
     * @memberof quotestore
     * @classdesc Represents an AuthRequest.
     * @implements IAuthRequest
     * @constructor
     * @param {quotestore.IAuthRequest=} [properties] Properties to set
     */
    function AuthRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AuthRequest secret.
     * @member {string} secret
     * @memberof quotestore.AuthRequest
     * @instance
     */
    AuthRequest.prototype.secret = '';

    /**
     * AuthRequest iamSessionId.
     * @member {string} iamSessionId
     * @memberof quotestore.AuthRequest
     * @instance
     */
    AuthRequest.prototype.iamSessionId = '';

    /**
     * Creates a new AuthRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.AuthRequest
     * @static
     * @param {quotestore.IAuthRequest=} [properties] Properties to set
     * @returns {quotestore.AuthRequest} AuthRequest instance
     */
    AuthRequest.create = function create(properties) {
      return new AuthRequest(properties);
    };

    /**
     * Encodes the specified AuthRequest message. Does not implicitly {@link quotestore.AuthRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.AuthRequest
     * @static
     * @param {quotestore.IAuthRequest} message AuthRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.secret != null && Object.hasOwnProperty.call(message, 'secret'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.secret);
      if (message.iamSessionId != null && Object.hasOwnProperty.call(message, 'iamSessionId'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.iamSessionId);
      return writer;
    };

    /**
     * Encodes the specified AuthRequest message, length delimited. Does not implicitly {@link quotestore.AuthRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.AuthRequest
     * @static
     * @param {quotestore.IAuthRequest} message AuthRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AuthRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.AuthRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.AuthRequest} AuthRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.AuthRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.secret = reader.string();
            break;
          }
          case 2: {
            message.iamSessionId = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AuthRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.AuthRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.AuthRequest} AuthRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AuthRequest message.
     * @function verify
     * @memberof quotestore.AuthRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AuthRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.secret != null && message.hasOwnProperty('secret'))
        if (!$util.isString(message.secret)) return 'secret: string expected';
      if (message.iamSessionId != null && message.hasOwnProperty('iamSessionId'))
        if (!$util.isString(message.iamSessionId)) return 'iamSessionId: string expected';
      return null;
    };

    /**
     * Creates an AuthRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.AuthRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.AuthRequest} AuthRequest
     */
    AuthRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.AuthRequest) return object;
      let message = new $root.quotestore.AuthRequest();
      if (object.secret != null) message.secret = String(object.secret);
      if (object.iamSessionId != null) message.iamSessionId = String(object.iamSessionId);
      return message;
    };

    /**
     * Creates a plain object from an AuthRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.AuthRequest
     * @static
     * @param {quotestore.AuthRequest} message AuthRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AuthRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.secret = '';
        object.iamSessionId = '';
      }
      if (message.secret != null && message.hasOwnProperty('secret')) object.secret = message.secret;
      if (message.iamSessionId != null && message.hasOwnProperty('iamSessionId'))
        object.iamSessionId = message.iamSessionId;
      return object;
    };

    /**
     * Converts this AuthRequest to JSON.
     * @function toJSON
     * @memberof quotestore.AuthRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AuthRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthRequest;
  })();

  quotestore.AuthResponse = (function () {
    /**
     * Properties of an AuthResponse.
     * @memberof quotestore
     * @interface IAuthResponse
     */

    /**
     * Constructs a new AuthResponse.
     * @memberof quotestore
     * @classdesc Represents an AuthResponse.
     * @implements IAuthResponse
     * @constructor
     * @param {quotestore.IAuthResponse=} [properties] Properties to set
     */
    function AuthResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new AuthResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.AuthResponse
     * @static
     * @param {quotestore.IAuthResponse=} [properties] Properties to set
     * @returns {quotestore.AuthResponse} AuthResponse instance
     */
    AuthResponse.create = function create(properties) {
      return new AuthResponse(properties);
    };

    /**
     * Encodes the specified AuthResponse message. Does not implicitly {@link quotestore.AuthResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.AuthResponse
     * @static
     * @param {quotestore.IAuthResponse} message AuthResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      return writer;
    };

    /**
     * Encodes the specified AuthResponse message, length delimited. Does not implicitly {@link quotestore.AuthResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.AuthResponse
     * @static
     * @param {quotestore.IAuthResponse} message AuthResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AuthResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.AuthResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.AuthResponse} AuthResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.AuthResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AuthResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.AuthResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.AuthResponse} AuthResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AuthResponse message.
     * @function verify
     * @memberof quotestore.AuthResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AuthResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      return null;
    };

    /**
     * Creates an AuthResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.AuthResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.AuthResponse} AuthResponse
     */
    AuthResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.AuthResponse) return object;
      return new $root.quotestore.AuthResponse();
    };

    /**
     * Creates a plain object from an AuthResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.AuthResponse
     * @static
     * @param {quotestore.AuthResponse} message AuthResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AuthResponse.toObject = function toObject() {
      return {};
    };

    /**
     * Converts this AuthResponse to JSON.
     * @function toJSON
     * @memberof quotestore.AuthResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AuthResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthResponse;
  })();

  quotestore.Heartbeat = (function () {
    /**
     * Properties of a Heartbeat.
     * @memberof quotestore
     * @interface IHeartbeat
     * @property {number|null} [time] Heartbeat time
     */

    /**
     * Constructs a new Heartbeat.
     * @memberof quotestore
     * @classdesc Represents a Heartbeat.
     * @implements IHeartbeat
     * @constructor
     * @param {quotestore.IHeartbeat=} [properties] Properties to set
     */
    function Heartbeat(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Heartbeat time.
     * @member {number} time
     * @memberof quotestore.Heartbeat
     * @instance
     */
    Heartbeat.prototype.time = 0;

    /**
     * Creates a new Heartbeat instance using the specified properties.
     * @function create
     * @memberof quotestore.Heartbeat
     * @static
     * @param {quotestore.IHeartbeat=} [properties] Properties to set
     * @returns {quotestore.Heartbeat} Heartbeat instance
     */
    Heartbeat.create = function create(properties) {
      return new Heartbeat(properties);
    };

    /**
     * Encodes the specified Heartbeat message. Does not implicitly {@link quotestore.Heartbeat.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Heartbeat
     * @static
     * @param {quotestore.IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.time);
      return writer;
    };

    /**
     * Encodes the specified Heartbeat message, length delimited. Does not implicitly {@link quotestore.Heartbeat.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Heartbeat
     * @static
     * @param {quotestore.IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Heartbeat();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.time = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Heartbeat message.
     * @function verify
     * @memberof quotestore.Heartbeat
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Heartbeat.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (!$util.isInteger(message.time)) return 'time: integer expected';
      return null;
    };

    /**
     * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Heartbeat
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Heartbeat} Heartbeat
     */
    Heartbeat.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Heartbeat) return object;
      let message = new $root.quotestore.Heartbeat();
      if (object.time != null) message.time = object.time | 0;
      return message;
    };

    /**
     * Creates a plain object from a Heartbeat message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Heartbeat
     * @static
     * @param {quotestore.Heartbeat} message Heartbeat
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Heartbeat.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.time = 0;
      if (message.time != null && message.hasOwnProperty('time')) object.time = message.time;
      return object;
    };

    /**
     * Converts this Heartbeat to JSON.
     * @function toJSON
     * @memberof quotestore.Heartbeat
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Heartbeat.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Heartbeat;
  })();

  quotestore.GetBarsRequest = (function () {
    /**
     * Properties of a GetBarsRequest.
     * @memberof quotestore
     * @interface IGetBarsRequest
     * @property {string|null} [symbol] GetBarsRequest symbol
     * @property {string|null} [resolution] GetBarsRequest resolution
     * @property {number|null} [from] GetBarsRequest from
     * @property {number|null} [to] GetBarsRequest to
     * @property {string|null} [fromInterval] GetBarsRequest fromInterval
     * @property {boolean|null} [anySession] GetBarsRequest anySession
     * @property {number|null} [countBack] GetBarsRequest countBack
     */

    /**
     * Constructs a new GetBarsRequest.
     * @memberof quotestore
     * @classdesc Represents a GetBarsRequest.
     * @implements IGetBarsRequest
     * @constructor
     * @param {quotestore.IGetBarsRequest=} [properties] Properties to set
     */
    function GetBarsRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBarsRequest symbol.
     * @member {string} symbol
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.symbol = '';

    /**
     * GetBarsRequest resolution.
     * @member {string} resolution
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.resolution = '';

    /**
     * GetBarsRequest from.
     * @member {number} from
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.from = 0;

    /**
     * GetBarsRequest to.
     * @member {number} to
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.to = 0;

    /**
     * GetBarsRequest fromInterval.
     * @member {string} fromInterval
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.fromInterval = '';

    /**
     * GetBarsRequest anySession.
     * @member {boolean} anySession
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.anySession = false;

    /**
     * GetBarsRequest countBack.
     * @member {number} countBack
     * @memberof quotestore.GetBarsRequest
     * @instance
     */
    GetBarsRequest.prototype.countBack = 0;

    /**
     * Creates a new GetBarsRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {quotestore.IGetBarsRequest=} [properties] Properties to set
     * @returns {quotestore.GetBarsRequest} GetBarsRequest instance
     */
    GetBarsRequest.create = function create(properties) {
      return new GetBarsRequest(properties);
    };

    /**
     * Encodes the specified GetBarsRequest message. Does not implicitly {@link quotestore.GetBarsRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {quotestore.IGetBarsRequest} message GetBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBarsRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.resolution != null && Object.hasOwnProperty.call(message, 'resolution'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.resolution);
      if (message.from != null && Object.hasOwnProperty.call(message, 'from'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.from);
      if (message.to != null && Object.hasOwnProperty.call(message, 'to'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.to);
      if (message.fromInterval != null && Object.hasOwnProperty.call(message, 'fromInterval'))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.fromInterval);
      if (message.anySession != null && Object.hasOwnProperty.call(message, 'anySession'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.anySession);
      if (message.countBack != null && Object.hasOwnProperty.call(message, 'countBack'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.countBack);
      return writer;
    };

    /**
     * Encodes the specified GetBarsRequest message, length delimited. Does not implicitly {@link quotestore.GetBarsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {quotestore.IGetBarsRequest} message GetBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBarsRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBarsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.GetBarsRequest} GetBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBarsRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.GetBarsRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.resolution = reader.string();
            break;
          }
          case 3: {
            message.from = reader.int32();
            break;
          }
          case 4: {
            message.to = reader.int32();
            break;
          }
          case 5: {
            message.fromInterval = reader.string();
            break;
          }
          case 6: {
            message.anySession = reader.bool();
            break;
          }
          case 7: {
            message.countBack = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetBarsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.GetBarsRequest} GetBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBarsRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBarsRequest message.
     * @function verify
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBarsRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.resolution != null && message.hasOwnProperty('resolution'))
        if (!$util.isString(message.resolution)) return 'resolution: string expected';
      if (message.from != null && message.hasOwnProperty('from'))
        if (!$util.isInteger(message.from)) return 'from: integer expected';
      if (message.to != null && message.hasOwnProperty('to'))
        if (!$util.isInteger(message.to)) return 'to: integer expected';
      if (message.fromInterval != null && message.hasOwnProperty('fromInterval'))
        if (!$util.isString(message.fromInterval)) return 'fromInterval: string expected';
      if (message.anySession != null && message.hasOwnProperty('anySession'))
        if (typeof message.anySession !== 'boolean') return 'anySession: boolean expected';
      if (message.countBack != null && message.hasOwnProperty('countBack'))
        if (!$util.isInteger(message.countBack)) return 'countBack: integer expected';
      return null;
    };

    /**
     * Creates a GetBarsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.GetBarsRequest} GetBarsRequest
     */
    GetBarsRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.GetBarsRequest) return object;
      let message = new $root.quotestore.GetBarsRequest();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.resolution != null) message.resolution = String(object.resolution);
      if (object.from != null) message.from = object.from | 0;
      if (object.to != null) message.to = object.to | 0;
      if (object.fromInterval != null) message.fromInterval = String(object.fromInterval);
      if (object.anySession != null) message.anySession = Boolean(object.anySession);
      if (object.countBack != null) message.countBack = object.countBack | 0;
      return message;
    };

    /**
     * Creates a plain object from a GetBarsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.GetBarsRequest
     * @static
     * @param {quotestore.GetBarsRequest} message GetBarsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBarsRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.resolution = '';
        object.from = 0;
        object.to = 0;
        object.fromInterval = '';
        object.anySession = false;
        object.countBack = 0;
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.resolution != null && message.hasOwnProperty('resolution')) object.resolution = message.resolution;
      if (message.from != null && message.hasOwnProperty('from')) object.from = message.from;
      if (message.to != null && message.hasOwnProperty('to')) object.to = message.to;
      if (message.fromInterval != null && message.hasOwnProperty('fromInterval'))
        object.fromInterval = message.fromInterval;
      if (message.anySession != null && message.hasOwnProperty('anySession')) object.anySession = message.anySession;
      if (message.countBack != null && message.hasOwnProperty('countBack')) object.countBack = message.countBack;
      return object;
    };

    /**
     * Converts this GetBarsRequest to JSON.
     * @function toJSON
     * @memberof quotestore.GetBarsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBarsRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetBarsRequest;
  })();

  quotestore.SearchSymbolsRequest = (function () {
    /**
     * Properties of a SearchSymbolsRequest.
     * @memberof quotestore
     * @interface ISearchSymbolsRequest
     * @property {string|null} [userInput] SearchSymbolsRequest userInput
     * @property {string|null} [exchange] SearchSymbolsRequest exchange
     * @property {string|null} [symbolType] SearchSymbolsRequest symbolType
     */

    /**
     * Constructs a new SearchSymbolsRequest.
     * @memberof quotestore
     * @classdesc Represents a SearchSymbolsRequest.
     * @implements ISearchSymbolsRequest
     * @constructor
     * @param {quotestore.ISearchSymbolsRequest=} [properties] Properties to set
     */
    function SearchSymbolsRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchSymbolsRequest userInput.
     * @member {string} userInput
     * @memberof quotestore.SearchSymbolsRequest
     * @instance
     */
    SearchSymbolsRequest.prototype.userInput = '';

    /**
     * SearchSymbolsRequest exchange.
     * @member {string} exchange
     * @memberof quotestore.SearchSymbolsRequest
     * @instance
     */
    SearchSymbolsRequest.prototype.exchange = '';

    /**
     * SearchSymbolsRequest symbolType.
     * @member {string} symbolType
     * @memberof quotestore.SearchSymbolsRequest
     * @instance
     */
    SearchSymbolsRequest.prototype.symbolType = '';

    /**
     * Creates a new SearchSymbolsRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {quotestore.ISearchSymbolsRequest=} [properties] Properties to set
     * @returns {quotestore.SearchSymbolsRequest} SearchSymbolsRequest instance
     */
    SearchSymbolsRequest.create = function create(properties) {
      return new SearchSymbolsRequest(properties);
    };

    /**
     * Encodes the specified SearchSymbolsRequest message. Does not implicitly {@link quotestore.SearchSymbolsRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {quotestore.ISearchSymbolsRequest} message SearchSymbolsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchSymbolsRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.userInput != null && Object.hasOwnProperty.call(message, 'userInput'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.userInput);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.exchange);
      if (message.symbolType != null && Object.hasOwnProperty.call(message, 'symbolType'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.symbolType);
      return writer;
    };

    /**
     * Encodes the specified SearchSymbolsRequest message, length delimited. Does not implicitly {@link quotestore.SearchSymbolsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {quotestore.ISearchSymbolsRequest} message SearchSymbolsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchSymbolsRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchSymbolsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.SearchSymbolsRequest} SearchSymbolsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchSymbolsRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.SearchSymbolsRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.userInput = reader.string();
            break;
          }
          case 2: {
            message.exchange = reader.string();
            break;
          }
          case 3: {
            message.symbolType = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SearchSymbolsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.SearchSymbolsRequest} SearchSymbolsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchSymbolsRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchSymbolsRequest message.
     * @function verify
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchSymbolsRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.userInput != null && message.hasOwnProperty('userInput'))
        if (!$util.isString(message.userInput)) return 'userInput: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.symbolType != null && message.hasOwnProperty('symbolType'))
        if (!$util.isString(message.symbolType)) return 'symbolType: string expected';
      return null;
    };

    /**
     * Creates a SearchSymbolsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.SearchSymbolsRequest} SearchSymbolsRequest
     */
    SearchSymbolsRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.SearchSymbolsRequest) return object;
      let message = new $root.quotestore.SearchSymbolsRequest();
      if (object.userInput != null) message.userInput = String(object.userInput);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.symbolType != null) message.symbolType = String(object.symbolType);
      return message;
    };

    /**
     * Creates a plain object from a SearchSymbolsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.SearchSymbolsRequest
     * @static
     * @param {quotestore.SearchSymbolsRequest} message SearchSymbolsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchSymbolsRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.userInput = '';
        object.exchange = '';
        object.symbolType = '';
      }
      if (message.userInput != null && message.hasOwnProperty('userInput')) object.userInput = message.userInput;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.symbolType != null && message.hasOwnProperty('symbolType')) object.symbolType = message.symbolType;
      return object;
    };

    /**
     * Converts this SearchSymbolsRequest to JSON.
     * @function toJSON
     * @memberof quotestore.SearchSymbolsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchSymbolsRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SearchSymbolsRequest;
  })();

  quotestore.SearchSymbolsResponse = (function () {
    /**
     * Properties of a SearchSymbolsResponse.
     * @memberof quotestore
     * @interface ISearchSymbolsResponse
     * @property {Array.<quotestore.SearchSymbolsResponse.IRecord>|null} [records] SearchSymbolsResponse records
     */

    /**
     * Constructs a new SearchSymbolsResponse.
     * @memberof quotestore
     * @classdesc Represents a SearchSymbolsResponse.
     * @implements ISearchSymbolsResponse
     * @constructor
     * @param {quotestore.ISearchSymbolsResponse=} [properties] Properties to set
     */
    function SearchSymbolsResponse(properties) {
      this.records = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SearchSymbolsResponse records.
     * @member {Array.<quotestore.SearchSymbolsResponse.IRecord>} records
     * @memberof quotestore.SearchSymbolsResponse
     * @instance
     */
    SearchSymbolsResponse.prototype.records = $util.emptyArray;

    /**
     * Creates a new SearchSymbolsResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {quotestore.ISearchSymbolsResponse=} [properties] Properties to set
     * @returns {quotestore.SearchSymbolsResponse} SearchSymbolsResponse instance
     */
    SearchSymbolsResponse.create = function create(properties) {
      return new SearchSymbolsResponse(properties);
    };

    /**
     * Encodes the specified SearchSymbolsResponse message. Does not implicitly {@link quotestore.SearchSymbolsResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {quotestore.ISearchSymbolsResponse} message SearchSymbolsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchSymbolsResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.records != null && message.records.length)
        for (let i = 0; i < message.records.length; ++i)
          $root.quotestore.SearchSymbolsResponse.Record.encode(
            message.records[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SearchSymbolsResponse message, length delimited. Does not implicitly {@link quotestore.SearchSymbolsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {quotestore.ISearchSymbolsResponse} message SearchSymbolsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SearchSymbolsResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SearchSymbolsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.SearchSymbolsResponse} SearchSymbolsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchSymbolsResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.SearchSymbolsResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.records && message.records.length)) message.records = [];
            message.records.push($root.quotestore.SearchSymbolsResponse.Record.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SearchSymbolsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.SearchSymbolsResponse} SearchSymbolsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SearchSymbolsResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SearchSymbolsResponse message.
     * @function verify
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SearchSymbolsResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.records != null && message.hasOwnProperty('records')) {
        if (!Array.isArray(message.records)) return 'records: array expected';
        for (let i = 0; i < message.records.length; ++i) {
          let error = $root.quotestore.SearchSymbolsResponse.Record.verify(message.records[i]);
          if (error) return 'records.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a SearchSymbolsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.SearchSymbolsResponse} SearchSymbolsResponse
     */
    SearchSymbolsResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.SearchSymbolsResponse) return object;
      let message = new $root.quotestore.SearchSymbolsResponse();
      if (object.records) {
        if (!Array.isArray(object.records))
          throw TypeError('.quotestore.SearchSymbolsResponse.records: array expected');
        message.records = [];
        for (let i = 0; i < object.records.length; ++i) {
          if (typeof object.records[i] !== 'object')
            throw TypeError('.quotestore.SearchSymbolsResponse.records: object expected');
          message.records[i] = $root.quotestore.SearchSymbolsResponse.Record.fromObject(object.records[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a SearchSymbolsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.SearchSymbolsResponse
     * @static
     * @param {quotestore.SearchSymbolsResponse} message SearchSymbolsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SearchSymbolsResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.records = [];
      if (message.records && message.records.length) {
        object.records = [];
        for (let j = 0; j < message.records.length; ++j)
          object.records[j] = $root.quotestore.SearchSymbolsResponse.Record.toObject(message.records[j], options);
      }
      return object;
    };

    /**
     * Converts this SearchSymbolsResponse to JSON.
     * @function toJSON
     * @memberof quotestore.SearchSymbolsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SearchSymbolsResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SearchSymbolsResponse.Record = (function () {
      /**
       * Properties of a Record.
       * @memberof quotestore.SearchSymbolsResponse
       * @interface IRecord
       * @property {string|null} [symbol] Record symbol
       * @property {string|null} [fullName] Record fullName
       * @property {string|null} [description] Record description
       * @property {string|null} [exchange] Record exchange
       * @property {string|null} [ticker] Record ticker
       * @property {string|null} [type] Record type
       */

      /**
       * Constructs a new Record.
       * @memberof quotestore.SearchSymbolsResponse
       * @classdesc Represents a Record.
       * @implements IRecord
       * @constructor
       * @param {quotestore.SearchSymbolsResponse.IRecord=} [properties] Properties to set
       */
      function Record(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Record symbol.
       * @member {string} symbol
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.symbol = '';

      /**
       * Record fullName.
       * @member {string} fullName
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.fullName = '';

      /**
       * Record description.
       * @member {string} description
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.description = '';

      /**
       * Record exchange.
       * @member {string} exchange
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.exchange = '';

      /**
       * Record ticker.
       * @member {string} ticker
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.ticker = '';

      /**
       * Record type.
       * @member {string} type
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       */
      Record.prototype.type = '';

      /**
       * Creates a new Record instance using the specified properties.
       * @function create
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {quotestore.SearchSymbolsResponse.IRecord=} [properties] Properties to set
       * @returns {quotestore.SearchSymbolsResponse.Record} Record instance
       */
      Record.create = function create(properties) {
        return new Record(properties);
      };

      /**
       * Encodes the specified Record message. Does not implicitly {@link quotestore.SearchSymbolsResponse.Record.verify|verify} messages.
       * @function encode
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {quotestore.SearchSymbolsResponse.IRecord} message Record message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Record.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
        if (message.fullName != null && Object.hasOwnProperty.call(message, 'fullName'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.fullName);
        if (message.description != null && Object.hasOwnProperty.call(message, 'description'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.description);
        if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.exchange);
        if (message.ticker != null && Object.hasOwnProperty.call(message, 'ticker'))
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.ticker);
        if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.type);
        return writer;
      };

      /**
       * Encodes the specified Record message, length delimited. Does not implicitly {@link quotestore.SearchSymbolsResponse.Record.verify|verify} messages.
       * @function encodeDelimited
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {quotestore.SearchSymbolsResponse.IRecord} message Record message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Record.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Record message from the specified reader or buffer.
       * @function decode
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {quotestore.SearchSymbolsResponse.Record} Record
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Record.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.quotestore.SearchSymbolsResponse.Record();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.symbol = reader.string();
              break;
            }
            case 2: {
              message.fullName = reader.string();
              break;
            }
            case 3: {
              message.description = reader.string();
              break;
            }
            case 4: {
              message.exchange = reader.string();
              break;
            }
            case 5: {
              message.ticker = reader.string();
              break;
            }
            case 6: {
              message.type = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Record message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {quotestore.SearchSymbolsResponse.Record} Record
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Record.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Record message.
       * @function verify
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Record.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.symbol != null && message.hasOwnProperty('symbol'))
          if (!$util.isString(message.symbol)) return 'symbol: string expected';
        if (message.fullName != null && message.hasOwnProperty('fullName'))
          if (!$util.isString(message.fullName)) return 'fullName: string expected';
        if (message.description != null && message.hasOwnProperty('description'))
          if (!$util.isString(message.description)) return 'description: string expected';
        if (message.exchange != null && message.hasOwnProperty('exchange'))
          if (!$util.isString(message.exchange)) return 'exchange: string expected';
        if (message.ticker != null && message.hasOwnProperty('ticker'))
          if (!$util.isString(message.ticker)) return 'ticker: string expected';
        if (message.type != null && message.hasOwnProperty('type'))
          if (!$util.isString(message.type)) return 'type: string expected';
        return null;
      };

      /**
       * Creates a Record message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {quotestore.SearchSymbolsResponse.Record} Record
       */
      Record.fromObject = function fromObject(object) {
        if (object instanceof $root.quotestore.SearchSymbolsResponse.Record) return object;
        let message = new $root.quotestore.SearchSymbolsResponse.Record();
        if (object.symbol != null) message.symbol = String(object.symbol);
        if (object.fullName != null) message.fullName = String(object.fullName);
        if (object.description != null) message.description = String(object.description);
        if (object.exchange != null) message.exchange = String(object.exchange);
        if (object.ticker != null) message.ticker = String(object.ticker);
        if (object.type != null) message.type = String(object.type);
        return message;
      };

      /**
       * Creates a plain object from a Record message. Also converts values to other types if specified.
       * @function toObject
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @static
       * @param {quotestore.SearchSymbolsResponse.Record} message Record
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Record.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = '';
          object.fullName = '';
          object.description = '';
          object.exchange = '';
          object.ticker = '';
          object.type = '';
        }
        if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
        if (message.fullName != null && message.hasOwnProperty('fullName')) object.fullName = message.fullName;
        if (message.description != null && message.hasOwnProperty('description'))
          object.description = message.description;
        if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
        if (message.ticker != null && message.hasOwnProperty('ticker')) object.ticker = message.ticker;
        if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
        return object;
      };

      /**
       * Converts this Record to JSON.
       * @function toJSON
       * @memberof quotestore.SearchSymbolsResponse.Record
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Record.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Record;
    })();

    return SearchSymbolsResponse;
  })();

  quotestore.ResolveSymbolRequest = (function () {
    /**
     * Properties of a ResolveSymbolRequest.
     * @memberof quotestore
     * @interface IResolveSymbolRequest
     * @property {string|null} [symbolName] ResolveSymbolRequest symbolName
     */

    /**
     * Constructs a new ResolveSymbolRequest.
     * @memberof quotestore
     * @classdesc Represents a ResolveSymbolRequest.
     * @implements IResolveSymbolRequest
     * @constructor
     * @param {quotestore.IResolveSymbolRequest=} [properties] Properties to set
     */
    function ResolveSymbolRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ResolveSymbolRequest symbolName.
     * @member {string} symbolName
     * @memberof quotestore.ResolveSymbolRequest
     * @instance
     */
    ResolveSymbolRequest.prototype.symbolName = '';

    /**
     * Creates a new ResolveSymbolRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {quotestore.IResolveSymbolRequest=} [properties] Properties to set
     * @returns {quotestore.ResolveSymbolRequest} ResolveSymbolRequest instance
     */
    ResolveSymbolRequest.create = function create(properties) {
      return new ResolveSymbolRequest(properties);
    };

    /**
     * Encodes the specified ResolveSymbolRequest message. Does not implicitly {@link quotestore.ResolveSymbolRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {quotestore.IResolveSymbolRequest} message ResolveSymbolRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResolveSymbolRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbolName != null && Object.hasOwnProperty.call(message, 'symbolName'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbolName);
      return writer;
    };

    /**
     * Encodes the specified ResolveSymbolRequest message, length delimited. Does not implicitly {@link quotestore.ResolveSymbolRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {quotestore.IResolveSymbolRequest} message ResolveSymbolRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResolveSymbolRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ResolveSymbolRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.ResolveSymbolRequest} ResolveSymbolRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResolveSymbolRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.ResolveSymbolRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbolName = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ResolveSymbolRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.ResolveSymbolRequest} ResolveSymbolRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResolveSymbolRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResolveSymbolRequest message.
     * @function verify
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResolveSymbolRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbolName != null && message.hasOwnProperty('symbolName'))
        if (!$util.isString(message.symbolName)) return 'symbolName: string expected';
      return null;
    };

    /**
     * Creates a ResolveSymbolRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.ResolveSymbolRequest} ResolveSymbolRequest
     */
    ResolveSymbolRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.ResolveSymbolRequest) return object;
      let message = new $root.quotestore.ResolveSymbolRequest();
      if (object.symbolName != null) message.symbolName = String(object.symbolName);
      return message;
    };

    /**
     * Creates a plain object from a ResolveSymbolRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.ResolveSymbolRequest
     * @static
     * @param {quotestore.ResolveSymbolRequest} message ResolveSymbolRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResolveSymbolRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.symbolName = '';
      if (message.symbolName != null && message.hasOwnProperty('symbolName')) object.symbolName = message.symbolName;
      return object;
    };

    /**
     * Converts this ResolveSymbolRequest to JSON.
     * @function toJSON
     * @memberof quotestore.ResolveSymbolRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResolveSymbolRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResolveSymbolRequest;
  })();

  quotestore.ResolveSymbolResponse = (function () {
    /**
     * Properties of a ResolveSymbolResponse.
     * @memberof quotestore
     * @interface IResolveSymbolResponse
     * @property {string|null} [name] ResolveSymbolResponse name
     * @property {string|null} [fullName] ResolveSymbolResponse fullName
     * @property {string|null} [description] ResolveSymbolResponse description
     * @property {string|null} [type] ResolveSymbolResponse type
     * @property {string|null} [session] ResolveSymbolResponse session
     * @property {string|null} [timezone] ResolveSymbolResponse timezone
     * @property {string|null} [exchange] ResolveSymbolResponse exchange
     * @property {number|null} [pricescale] ResolveSymbolResponse pricescale
     * @property {number|null} [minmov] ResolveSymbolResponse minmov
     * @property {boolean|null} [hasIntraday] ResolveSymbolResponse hasIntraday
     * @property {Array.<string>|null} [supportedResolutions] ResolveSymbolResponse supportedResolutions
     * @property {string|null} [sector] ResolveSymbolResponse sector
     * @property {string|null} [industry] ResolveSymbolResponse industry
     */

    /**
     * Constructs a new ResolveSymbolResponse.
     * @memberof quotestore
     * @classdesc Represents a ResolveSymbolResponse.
     * @implements IResolveSymbolResponse
     * @constructor
     * @param {quotestore.IResolveSymbolResponse=} [properties] Properties to set
     */
    function ResolveSymbolResponse(properties) {
      this.supportedResolutions = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ResolveSymbolResponse name.
     * @member {string} name
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.name = '';

    /**
     * ResolveSymbolResponse fullName.
     * @member {string} fullName
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.fullName = '';

    /**
     * ResolveSymbolResponse description.
     * @member {string} description
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.description = '';

    /**
     * ResolveSymbolResponse type.
     * @member {string} type
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.type = '';

    /**
     * ResolveSymbolResponse session.
     * @member {string} session
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.session = '';

    /**
     * ResolveSymbolResponse timezone.
     * @member {string} timezone
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.timezone = '';

    /**
     * ResolveSymbolResponse exchange.
     * @member {string} exchange
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.exchange = '';

    /**
     * ResolveSymbolResponse pricescale.
     * @member {number} pricescale
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.pricescale = 0;

    /**
     * ResolveSymbolResponse minmov.
     * @member {number} minmov
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.minmov = 0;

    /**
     * ResolveSymbolResponse hasIntraday.
     * @member {boolean} hasIntraday
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.hasIntraday = false;

    /**
     * ResolveSymbolResponse supportedResolutions.
     * @member {Array.<string>} supportedResolutions
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.supportedResolutions = $util.emptyArray;

    /**
     * ResolveSymbolResponse sector.
     * @member {string} sector
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.sector = '';

    /**
     * ResolveSymbolResponse industry.
     * @member {string} industry
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     */
    ResolveSymbolResponse.prototype.industry = '';

    /**
     * Creates a new ResolveSymbolResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {quotestore.IResolveSymbolResponse=} [properties] Properties to set
     * @returns {quotestore.ResolveSymbolResponse} ResolveSymbolResponse instance
     */
    ResolveSymbolResponse.create = function create(properties) {
      return new ResolveSymbolResponse(properties);
    };

    /**
     * Encodes the specified ResolveSymbolResponse message. Does not implicitly {@link quotestore.ResolveSymbolResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {quotestore.IResolveSymbolResponse} message ResolveSymbolResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResolveSymbolResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.fullName != null && Object.hasOwnProperty.call(message, 'fullName'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.fullName);
      if (message.description != null && Object.hasOwnProperty.call(message, 'description'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.description);
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.type);
      if (message.session != null && Object.hasOwnProperty.call(message, 'session'))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.session);
      if (message.timezone != null && Object.hasOwnProperty.call(message, 'timezone'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.timezone);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.exchange);
      if (message.pricescale != null && Object.hasOwnProperty.call(message, 'pricescale'))
        writer.uint32(/* id 8, wireType 1 =*/ 65).double(message.pricescale);
      if (message.minmov != null && Object.hasOwnProperty.call(message, 'minmov'))
        writer.uint32(/* id 9, wireType 1 =*/ 73).double(message.minmov);
      if (message.hasIntraday != null && Object.hasOwnProperty.call(message, 'hasIntraday'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).bool(message.hasIntraday);
      if (message.supportedResolutions != null && message.supportedResolutions.length)
        for (let i = 0; i < message.supportedResolutions.length; ++i)
          writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.supportedResolutions[i]);
      if (message.sector != null && Object.hasOwnProperty.call(message, 'sector'))
        writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.sector);
      if (message.industry != null && Object.hasOwnProperty.call(message, 'industry'))
        writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.industry);
      return writer;
    };

    /**
     * Encodes the specified ResolveSymbolResponse message, length delimited. Does not implicitly {@link quotestore.ResolveSymbolResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {quotestore.IResolveSymbolResponse} message ResolveSymbolResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResolveSymbolResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ResolveSymbolResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.ResolveSymbolResponse} ResolveSymbolResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResolveSymbolResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.ResolveSymbolResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            message.fullName = reader.string();
            break;
          }
          case 3: {
            message.description = reader.string();
            break;
          }
          case 4: {
            message.type = reader.string();
            break;
          }
          case 5: {
            message.session = reader.string();
            break;
          }
          case 6: {
            message.timezone = reader.string();
            break;
          }
          case 7: {
            message.exchange = reader.string();
            break;
          }
          case 8: {
            message.pricescale = reader.double();
            break;
          }
          case 9: {
            message.minmov = reader.double();
            break;
          }
          case 10: {
            message.hasIntraday = reader.bool();
            break;
          }
          case 11: {
            if (!(message.supportedResolutions && message.supportedResolutions.length))
              message.supportedResolutions = [];
            message.supportedResolutions.push(reader.string());
            break;
          }
          case 12: {
            message.sector = reader.string();
            break;
          }
          case 13: {
            message.industry = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ResolveSymbolResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.ResolveSymbolResponse} ResolveSymbolResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResolveSymbolResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResolveSymbolResponse message.
     * @function verify
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResolveSymbolResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.fullName != null && message.hasOwnProperty('fullName'))
        if (!$util.isString(message.fullName)) return 'fullName: string expected';
      if (message.description != null && message.hasOwnProperty('description'))
        if (!$util.isString(message.description)) return 'description: string expected';
      if (message.type != null && message.hasOwnProperty('type'))
        if (!$util.isString(message.type)) return 'type: string expected';
      if (message.session != null && message.hasOwnProperty('session'))
        if (!$util.isString(message.session)) return 'session: string expected';
      if (message.timezone != null && message.hasOwnProperty('timezone'))
        if (!$util.isString(message.timezone)) return 'timezone: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.pricescale != null && message.hasOwnProperty('pricescale'))
        if (typeof message.pricescale !== 'number') return 'pricescale: number expected';
      if (message.minmov != null && message.hasOwnProperty('minmov'))
        if (typeof message.minmov !== 'number') return 'minmov: number expected';
      if (message.hasIntraday != null && message.hasOwnProperty('hasIntraday'))
        if (typeof message.hasIntraday !== 'boolean') return 'hasIntraday: boolean expected';
      if (message.supportedResolutions != null && message.hasOwnProperty('supportedResolutions')) {
        if (!Array.isArray(message.supportedResolutions)) return 'supportedResolutions: array expected';
        for (let i = 0; i < message.supportedResolutions.length; ++i)
          if (!$util.isString(message.supportedResolutions[i])) return 'supportedResolutions: string[] expected';
      }
      if (message.sector != null && message.hasOwnProperty('sector'))
        if (!$util.isString(message.sector)) return 'sector: string expected';
      if (message.industry != null && message.hasOwnProperty('industry'))
        if (!$util.isString(message.industry)) return 'industry: string expected';
      return null;
    };

    /**
     * Creates a ResolveSymbolResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.ResolveSymbolResponse} ResolveSymbolResponse
     */
    ResolveSymbolResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.ResolveSymbolResponse) return object;
      let message = new $root.quotestore.ResolveSymbolResponse();
      if (object.name != null) message.name = String(object.name);
      if (object.fullName != null) message.fullName = String(object.fullName);
      if (object.description != null) message.description = String(object.description);
      if (object.type != null) message.type = String(object.type);
      if (object.session != null) message.session = String(object.session);
      if (object.timezone != null) message.timezone = String(object.timezone);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.pricescale != null) message.pricescale = Number(object.pricescale);
      if (object.minmov != null) message.minmov = Number(object.minmov);
      if (object.hasIntraday != null) message.hasIntraday = Boolean(object.hasIntraday);
      if (object.supportedResolutions) {
        if (!Array.isArray(object.supportedResolutions))
          throw TypeError('.quotestore.ResolveSymbolResponse.supportedResolutions: array expected');
        message.supportedResolutions = [];
        for (let i = 0; i < object.supportedResolutions.length; ++i)
          message.supportedResolutions[i] = String(object.supportedResolutions[i]);
      }
      if (object.sector != null) message.sector = String(object.sector);
      if (object.industry != null) message.industry = String(object.industry);
      return message;
    };

    /**
     * Creates a plain object from a ResolveSymbolResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.ResolveSymbolResponse
     * @static
     * @param {quotestore.ResolveSymbolResponse} message ResolveSymbolResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResolveSymbolResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.supportedResolutions = [];
      if (options.defaults) {
        object.name = '';
        object.fullName = '';
        object.description = '';
        object.type = '';
        object.session = '';
        object.timezone = '';
        object.exchange = '';
        object.pricescale = 0;
        object.minmov = 0;
        object.hasIntraday = false;
        object.sector = '';
        object.industry = '';
      }
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.fullName != null && message.hasOwnProperty('fullName')) object.fullName = message.fullName;
      if (message.description != null && message.hasOwnProperty('description'))
        object.description = message.description;
      if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
      if (message.session != null && message.hasOwnProperty('session')) object.session = message.session;
      if (message.timezone != null && message.hasOwnProperty('timezone')) object.timezone = message.timezone;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.pricescale != null && message.hasOwnProperty('pricescale'))
        object.pricescale =
          options.json && !isFinite(message.pricescale) ? String(message.pricescale) : message.pricescale;
      if (message.minmov != null && message.hasOwnProperty('minmov'))
        object.minmov = options.json && !isFinite(message.minmov) ? String(message.minmov) : message.minmov;
      if (message.hasIntraday != null && message.hasOwnProperty('hasIntraday'))
        object.hasIntraday = message.hasIntraday;
      if (message.supportedResolutions && message.supportedResolutions.length) {
        object.supportedResolutions = [];
        for (let j = 0; j < message.supportedResolutions.length; ++j)
          object.supportedResolutions[j] = message.supportedResolutions[j];
      }
      if (message.sector != null && message.hasOwnProperty('sector')) object.sector = message.sector;
      if (message.industry != null && message.hasOwnProperty('industry')) object.industry = message.industry;
      return object;
    };

    /**
     * Converts this ResolveSymbolResponse to JSON.
     * @function toJSON
     * @memberof quotestore.ResolveSymbolResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResolveSymbolResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResolveSymbolResponse;
  })();

  quotestore.SubscribeBarsRequest = (function () {
    /**
     * Properties of a SubscribeBarsRequest.
     * @memberof quotestore
     * @interface ISubscribeBarsRequest
     * @property {string|null} [symbol] SubscribeBarsRequest symbol
     * @property {string|null} [resolution] SubscribeBarsRequest resolution
     */

    /**
     * Constructs a new SubscribeBarsRequest.
     * @memberof quotestore
     * @classdesc Represents a SubscribeBarsRequest.
     * @implements ISubscribeBarsRequest
     * @constructor
     * @param {quotestore.ISubscribeBarsRequest=} [properties] Properties to set
     */
    function SubscribeBarsRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubscribeBarsRequest symbol.
     * @member {string} symbol
     * @memberof quotestore.SubscribeBarsRequest
     * @instance
     */
    SubscribeBarsRequest.prototype.symbol = '';

    /**
     * SubscribeBarsRequest resolution.
     * @member {string} resolution
     * @memberof quotestore.SubscribeBarsRequest
     * @instance
     */
    SubscribeBarsRequest.prototype.resolution = '';

    /**
     * Creates a new SubscribeBarsRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {quotestore.ISubscribeBarsRequest=} [properties] Properties to set
     * @returns {quotestore.SubscribeBarsRequest} SubscribeBarsRequest instance
     */
    SubscribeBarsRequest.create = function create(properties) {
      return new SubscribeBarsRequest(properties);
    };

    /**
     * Encodes the specified SubscribeBarsRequest message. Does not implicitly {@link quotestore.SubscribeBarsRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {quotestore.ISubscribeBarsRequest} message SubscribeBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeBarsRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.resolution != null && Object.hasOwnProperty.call(message, 'resolution'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.resolution);
      return writer;
    };

    /**
     * Encodes the specified SubscribeBarsRequest message, length delimited. Does not implicitly {@link quotestore.SubscribeBarsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {quotestore.ISubscribeBarsRequest} message SubscribeBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeBarsRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubscribeBarsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.SubscribeBarsRequest} SubscribeBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeBarsRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.SubscribeBarsRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.resolution = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubscribeBarsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.SubscribeBarsRequest} SubscribeBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeBarsRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubscribeBarsRequest message.
     * @function verify
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubscribeBarsRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.resolution != null && message.hasOwnProperty('resolution'))
        if (!$util.isString(message.resolution)) return 'resolution: string expected';
      return null;
    };

    /**
     * Creates a SubscribeBarsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.SubscribeBarsRequest} SubscribeBarsRequest
     */
    SubscribeBarsRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.SubscribeBarsRequest) return object;
      let message = new $root.quotestore.SubscribeBarsRequest();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.resolution != null) message.resolution = String(object.resolution);
      return message;
    };

    /**
     * Creates a plain object from a SubscribeBarsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.SubscribeBarsRequest
     * @static
     * @param {quotestore.SubscribeBarsRequest} message SubscribeBarsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubscribeBarsRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.resolution = '';
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.resolution != null && message.hasOwnProperty('resolution')) object.resolution = message.resolution;
      return object;
    };

    /**
     * Converts this SubscribeBarsRequest to JSON.
     * @function toJSON
     * @memberof quotestore.SubscribeBarsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubscribeBarsRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubscribeBarsRequest;
  })();

  quotestore.SubscribeBarsResponse = (function () {
    /**
     * Properties of a SubscribeBarsResponse.
     * @memberof quotestore
     * @interface ISubscribeBarsResponse
     */

    /**
     * Constructs a new SubscribeBarsResponse.
     * @memberof quotestore
     * @classdesc Represents a SubscribeBarsResponse.
     * @implements ISubscribeBarsResponse
     * @constructor
     * @param {quotestore.ISubscribeBarsResponse=} [properties] Properties to set
     */
    function SubscribeBarsResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SubscribeBarsResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {quotestore.ISubscribeBarsResponse=} [properties] Properties to set
     * @returns {quotestore.SubscribeBarsResponse} SubscribeBarsResponse instance
     */
    SubscribeBarsResponse.create = function create(properties) {
      return new SubscribeBarsResponse(properties);
    };

    /**
     * Encodes the specified SubscribeBarsResponse message. Does not implicitly {@link quotestore.SubscribeBarsResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {quotestore.ISubscribeBarsResponse} message SubscribeBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeBarsResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      return writer;
    };

    /**
     * Encodes the specified SubscribeBarsResponse message, length delimited. Does not implicitly {@link quotestore.SubscribeBarsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {quotestore.ISubscribeBarsResponse} message SubscribeBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeBarsResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubscribeBarsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.SubscribeBarsResponse} SubscribeBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeBarsResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.SubscribeBarsResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubscribeBarsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.SubscribeBarsResponse} SubscribeBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeBarsResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubscribeBarsResponse message.
     * @function verify
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubscribeBarsResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      return null;
    };

    /**
     * Creates a SubscribeBarsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.SubscribeBarsResponse} SubscribeBarsResponse
     */
    SubscribeBarsResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.SubscribeBarsResponse) return object;
      return new $root.quotestore.SubscribeBarsResponse();
    };

    /**
     * Creates a plain object from a SubscribeBarsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.SubscribeBarsResponse
     * @static
     * @param {quotestore.SubscribeBarsResponse} message SubscribeBarsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubscribeBarsResponse.toObject = function toObject() {
      return {};
    };

    /**
     * Converts this SubscribeBarsResponse to JSON.
     * @function toJSON
     * @memberof quotestore.SubscribeBarsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubscribeBarsResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubscribeBarsResponse;
  })();

  quotestore.UnsubscribeBarsRequest = (function () {
    /**
     * Properties of an UnsubscribeBarsRequest.
     * @memberof quotestore
     * @interface IUnsubscribeBarsRequest
     * @property {string|null} [listenerGuid] UnsubscribeBarsRequest listenerGuid
     */

    /**
     * Constructs a new UnsubscribeBarsRequest.
     * @memberof quotestore
     * @classdesc Represents an UnsubscribeBarsRequest.
     * @implements IUnsubscribeBarsRequest
     * @constructor
     * @param {quotestore.IUnsubscribeBarsRequest=} [properties] Properties to set
     */
    function UnsubscribeBarsRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnsubscribeBarsRequest listenerGuid.
     * @member {string} listenerGuid
     * @memberof quotestore.UnsubscribeBarsRequest
     * @instance
     */
    UnsubscribeBarsRequest.prototype.listenerGuid = '';

    /**
     * Creates a new UnsubscribeBarsRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {quotestore.IUnsubscribeBarsRequest=} [properties] Properties to set
     * @returns {quotestore.UnsubscribeBarsRequest} UnsubscribeBarsRequest instance
     */
    UnsubscribeBarsRequest.create = function create(properties) {
      return new UnsubscribeBarsRequest(properties);
    };

    /**
     * Encodes the specified UnsubscribeBarsRequest message. Does not implicitly {@link quotestore.UnsubscribeBarsRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {quotestore.IUnsubscribeBarsRequest} message UnsubscribeBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeBarsRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.listenerGuid != null && Object.hasOwnProperty.call(message, 'listenerGuid'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.listenerGuid);
      return writer;
    };

    /**
     * Encodes the specified UnsubscribeBarsRequest message, length delimited. Does not implicitly {@link quotestore.UnsubscribeBarsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {quotestore.IUnsubscribeBarsRequest} message UnsubscribeBarsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeBarsRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnsubscribeBarsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.UnsubscribeBarsRequest} UnsubscribeBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeBarsRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.UnsubscribeBarsRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.listenerGuid = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an UnsubscribeBarsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.UnsubscribeBarsRequest} UnsubscribeBarsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeBarsRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnsubscribeBarsRequest message.
     * @function verify
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnsubscribeBarsRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.listenerGuid != null && message.hasOwnProperty('listenerGuid'))
        if (!$util.isString(message.listenerGuid)) return 'listenerGuid: string expected';
      return null;
    };

    /**
     * Creates an UnsubscribeBarsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.UnsubscribeBarsRequest} UnsubscribeBarsRequest
     */
    UnsubscribeBarsRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.UnsubscribeBarsRequest) return object;
      let message = new $root.quotestore.UnsubscribeBarsRequest();
      if (object.listenerGuid != null) message.listenerGuid = String(object.listenerGuid);
      return message;
    };

    /**
     * Creates a plain object from an UnsubscribeBarsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.UnsubscribeBarsRequest
     * @static
     * @param {quotestore.UnsubscribeBarsRequest} message UnsubscribeBarsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnsubscribeBarsRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.listenerGuid = '';
      if (message.listenerGuid != null && message.hasOwnProperty('listenerGuid'))
        object.listenerGuid = message.listenerGuid;
      return object;
    };

    /**
     * Converts this UnsubscribeBarsRequest to JSON.
     * @function toJSON
     * @memberof quotestore.UnsubscribeBarsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnsubscribeBarsRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnsubscribeBarsRequest;
  })();

  quotestore.UnsubscribeBarsResponse = (function () {
    /**
     * Properties of an UnsubscribeBarsResponse.
     * @memberof quotestore
     * @interface IUnsubscribeBarsResponse
     */

    /**
     * Constructs a new UnsubscribeBarsResponse.
     * @memberof quotestore
     * @classdesc Represents an UnsubscribeBarsResponse.
     * @implements IUnsubscribeBarsResponse
     * @constructor
     * @param {quotestore.IUnsubscribeBarsResponse=} [properties] Properties to set
     */
    function UnsubscribeBarsResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new UnsubscribeBarsResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {quotestore.IUnsubscribeBarsResponse=} [properties] Properties to set
     * @returns {quotestore.UnsubscribeBarsResponse} UnsubscribeBarsResponse instance
     */
    UnsubscribeBarsResponse.create = function create(properties) {
      return new UnsubscribeBarsResponse(properties);
    };

    /**
     * Encodes the specified UnsubscribeBarsResponse message. Does not implicitly {@link quotestore.UnsubscribeBarsResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {quotestore.IUnsubscribeBarsResponse} message UnsubscribeBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeBarsResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      return writer;
    };

    /**
     * Encodes the specified UnsubscribeBarsResponse message, length delimited. Does not implicitly {@link quotestore.UnsubscribeBarsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {quotestore.IUnsubscribeBarsResponse} message UnsubscribeBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnsubscribeBarsResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UnsubscribeBarsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.UnsubscribeBarsResponse} UnsubscribeBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeBarsResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.UnsubscribeBarsResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an UnsubscribeBarsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.UnsubscribeBarsResponse} UnsubscribeBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnsubscribeBarsResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UnsubscribeBarsResponse message.
     * @function verify
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UnsubscribeBarsResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      return null;
    };

    /**
     * Creates an UnsubscribeBarsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.UnsubscribeBarsResponse} UnsubscribeBarsResponse
     */
    UnsubscribeBarsResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.UnsubscribeBarsResponse) return object;
      return new $root.quotestore.UnsubscribeBarsResponse();
    };

    /**
     * Creates a plain object from an UnsubscribeBarsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.UnsubscribeBarsResponse
     * @static
     * @param {quotestore.UnsubscribeBarsResponse} message UnsubscribeBarsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnsubscribeBarsResponse.toObject = function toObject() {
      return {};
    };

    /**
     * Converts this UnsubscribeBarsResponse to JSON.
     * @function toJSON
     * @memberof quotestore.UnsubscribeBarsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnsubscribeBarsResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UnsubscribeBarsResponse;
  })();

  quotestore.GetBarsResponse = (function () {
    /**
     * Properties of a GetBarsResponse.
     * @memberof quotestore
     * @interface IGetBarsResponse
     * @property {Array.<quotestore.ICandle>|null} [bars] GetBarsResponse bars
     * @property {boolean|null} [noData] GetBarsResponse noData
     */

    /**
     * Constructs a new GetBarsResponse.
     * @memberof quotestore
     * @classdesc Represents a GetBarsResponse.
     * @implements IGetBarsResponse
     * @constructor
     * @param {quotestore.IGetBarsResponse=} [properties] Properties to set
     */
    function GetBarsResponse(properties) {
      this.bars = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBarsResponse bars.
     * @member {Array.<quotestore.ICandle>} bars
     * @memberof quotestore.GetBarsResponse
     * @instance
     */
    GetBarsResponse.prototype.bars = $util.emptyArray;

    /**
     * GetBarsResponse noData.
     * @member {boolean} noData
     * @memberof quotestore.GetBarsResponse
     * @instance
     */
    GetBarsResponse.prototype.noData = false;

    /**
     * Creates a new GetBarsResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {quotestore.IGetBarsResponse=} [properties] Properties to set
     * @returns {quotestore.GetBarsResponse} GetBarsResponse instance
     */
    GetBarsResponse.create = function create(properties) {
      return new GetBarsResponse(properties);
    };

    /**
     * Encodes the specified GetBarsResponse message. Does not implicitly {@link quotestore.GetBarsResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {quotestore.IGetBarsResponse} message GetBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBarsResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.bars != null && message.bars.length)
        for (let i = 0; i < message.bars.length; ++i)
          $root.quotestore.Candle.encode(message.bars[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      if (message.noData != null && Object.hasOwnProperty.call(message, 'noData'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.noData);
      return writer;
    };

    /**
     * Encodes the specified GetBarsResponse message, length delimited. Does not implicitly {@link quotestore.GetBarsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {quotestore.IGetBarsResponse} message GetBarsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBarsResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBarsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.GetBarsResponse} GetBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBarsResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.GetBarsResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.bars && message.bars.length)) message.bars = [];
            message.bars.push($root.quotestore.Candle.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            message.noData = reader.bool();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetBarsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.GetBarsResponse} GetBarsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBarsResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBarsResponse message.
     * @function verify
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBarsResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.bars != null && message.hasOwnProperty('bars')) {
        if (!Array.isArray(message.bars)) return 'bars: array expected';
        for (let i = 0; i < message.bars.length; ++i) {
          let error = $root.quotestore.Candle.verify(message.bars[i]);
          if (error) return 'bars.' + error;
        }
      }
      if (message.noData != null && message.hasOwnProperty('noData'))
        if (typeof message.noData !== 'boolean') return 'noData: boolean expected';
      return null;
    };

    /**
     * Creates a GetBarsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.GetBarsResponse} GetBarsResponse
     */
    GetBarsResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.GetBarsResponse) return object;
      let message = new $root.quotestore.GetBarsResponse();
      if (object.bars) {
        if (!Array.isArray(object.bars)) throw TypeError('.quotestore.GetBarsResponse.bars: array expected');
        message.bars = [];
        for (let i = 0; i < object.bars.length; ++i) {
          if (typeof object.bars[i] !== 'object') throw TypeError('.quotestore.GetBarsResponse.bars: object expected');
          message.bars[i] = $root.quotestore.Candle.fromObject(object.bars[i]);
        }
      }
      if (object.noData != null) message.noData = Boolean(object.noData);
      return message;
    };

    /**
     * Creates a plain object from a GetBarsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.GetBarsResponse
     * @static
     * @param {quotestore.GetBarsResponse} message GetBarsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBarsResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.bars = [];
      if (options.defaults) object.noData = false;
      if (message.bars && message.bars.length) {
        object.bars = [];
        for (let j = 0; j < message.bars.length; ++j)
          object.bars[j] = $root.quotestore.Candle.toObject(message.bars[j], options);
      }
      if (message.noData != null && message.hasOwnProperty('noData')) object.noData = message.noData;
      return object;
    };

    /**
     * Converts this GetBarsResponse to JSON.
     * @function toJSON
     * @memberof quotestore.GetBarsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBarsResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetBarsResponse;
  })();

  quotestore.CandlesSubRequest = (function () {
    /**
     * Properties of a CandlesSubRequest.
     * @memberof quotestore
     * @interface ICandlesSubRequest
     * @property {string|null} [symbol] CandlesSubRequest symbol
     * @property {string|null} [resolution] CandlesSubRequest resolution
     */

    /**
     * Constructs a new CandlesSubRequest.
     * @memberof quotestore
     * @classdesc Represents a CandlesSubRequest.
     * @implements ICandlesSubRequest
     * @constructor
     * @param {quotestore.ICandlesSubRequest=} [properties] Properties to set
     */
    function CandlesSubRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CandlesSubRequest symbol.
     * @member {string} symbol
     * @memberof quotestore.CandlesSubRequest
     * @instance
     */
    CandlesSubRequest.prototype.symbol = '';

    /**
     * CandlesSubRequest resolution.
     * @member {string} resolution
     * @memberof quotestore.CandlesSubRequest
     * @instance
     */
    CandlesSubRequest.prototype.resolution = '';

    /**
     * Creates a new CandlesSubRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {quotestore.ICandlesSubRequest=} [properties] Properties to set
     * @returns {quotestore.CandlesSubRequest} CandlesSubRequest instance
     */
    CandlesSubRequest.create = function create(properties) {
      return new CandlesSubRequest(properties);
    };

    /**
     * Encodes the specified CandlesSubRequest message. Does not implicitly {@link quotestore.CandlesSubRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {quotestore.ICandlesSubRequest} message CandlesSubRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesSubRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.resolution != null && Object.hasOwnProperty.call(message, 'resolution'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.resolution);
      return writer;
    };

    /**
     * Encodes the specified CandlesSubRequest message, length delimited. Does not implicitly {@link quotestore.CandlesSubRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {quotestore.ICandlesSubRequest} message CandlesSubRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesSubRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CandlesSubRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.CandlesSubRequest} CandlesSubRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesSubRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.CandlesSubRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.resolution = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CandlesSubRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.CandlesSubRequest} CandlesSubRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesSubRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CandlesSubRequest message.
     * @function verify
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CandlesSubRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.resolution != null && message.hasOwnProperty('resolution'))
        if (!$util.isString(message.resolution)) return 'resolution: string expected';
      return null;
    };

    /**
     * Creates a CandlesSubRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.CandlesSubRequest} CandlesSubRequest
     */
    CandlesSubRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.CandlesSubRequest) return object;
      let message = new $root.quotestore.CandlesSubRequest();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.resolution != null) message.resolution = String(object.resolution);
      return message;
    };

    /**
     * Creates a plain object from a CandlesSubRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.CandlesSubRequest
     * @static
     * @param {quotestore.CandlesSubRequest} message CandlesSubRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CandlesSubRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.resolution = '';
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.resolution != null && message.hasOwnProperty('resolution')) object.resolution = message.resolution;
      return object;
    };

    /**
     * Converts this CandlesSubRequest to JSON.
     * @function toJSON
     * @memberof quotestore.CandlesSubRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CandlesSubRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CandlesSubRequest;
  })();

  quotestore.CandlesUnsubRequest = (function () {
    /**
     * Properties of a CandlesUnsubRequest.
     * @memberof quotestore
     * @interface ICandlesUnsubRequest
     * @property {string|null} [symbol] CandlesUnsubRequest symbol
     * @property {number|null} [interval] CandlesUnsubRequest interval
     */

    /**
     * Constructs a new CandlesUnsubRequest.
     * @memberof quotestore
     * @classdesc Represents a CandlesUnsubRequest.
     * @implements ICandlesUnsubRequest
     * @constructor
     * @param {quotestore.ICandlesUnsubRequest=} [properties] Properties to set
     */
    function CandlesUnsubRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CandlesUnsubRequest symbol.
     * @member {string} symbol
     * @memberof quotestore.CandlesUnsubRequest
     * @instance
     */
    CandlesUnsubRequest.prototype.symbol = '';

    /**
     * CandlesUnsubRequest interval.
     * @member {number} interval
     * @memberof quotestore.CandlesUnsubRequest
     * @instance
     */
    CandlesUnsubRequest.prototype.interval = 0;

    /**
     * Creates a new CandlesUnsubRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {quotestore.ICandlesUnsubRequest=} [properties] Properties to set
     * @returns {quotestore.CandlesUnsubRequest} CandlesUnsubRequest instance
     */
    CandlesUnsubRequest.create = function create(properties) {
      return new CandlesUnsubRequest(properties);
    };

    /**
     * Encodes the specified CandlesUnsubRequest message. Does not implicitly {@link quotestore.CandlesUnsubRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {quotestore.ICandlesUnsubRequest} message CandlesUnsubRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesUnsubRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.interval != null && Object.hasOwnProperty.call(message, 'interval'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.interval);
      return writer;
    };

    /**
     * Encodes the specified CandlesUnsubRequest message, length delimited. Does not implicitly {@link quotestore.CandlesUnsubRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {quotestore.ICandlesUnsubRequest} message CandlesUnsubRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesUnsubRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CandlesUnsubRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.CandlesUnsubRequest} CandlesUnsubRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesUnsubRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.CandlesUnsubRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.interval = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CandlesUnsubRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.CandlesUnsubRequest} CandlesUnsubRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesUnsubRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CandlesUnsubRequest message.
     * @function verify
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CandlesUnsubRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.interval != null && message.hasOwnProperty('interval'))
        if (!$util.isInteger(message.interval)) return 'interval: integer expected';
      return null;
    };

    /**
     * Creates a CandlesUnsubRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.CandlesUnsubRequest} CandlesUnsubRequest
     */
    CandlesUnsubRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.CandlesUnsubRequest) return object;
      let message = new $root.quotestore.CandlesUnsubRequest();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.interval != null) message.interval = object.interval | 0;
      return message;
    };

    /**
     * Creates a plain object from a CandlesUnsubRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.CandlesUnsubRequest
     * @static
     * @param {quotestore.CandlesUnsubRequest} message CandlesUnsubRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CandlesUnsubRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.interval = 0;
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.interval != null && message.hasOwnProperty('interval')) object.interval = message.interval;
      return object;
    };

    /**
     * Converts this CandlesUnsubRequest to JSON.
     * @function toJSON
     * @memberof quotestore.CandlesUnsubRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CandlesUnsubRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CandlesUnsubRequest;
  })();

  quotestore.CandlesResponse = (function () {
    /**
     * Properties of a CandlesResponse.
     * @memberof quotestore
     * @interface ICandlesResponse
     * @property {string|null} [symbol] CandlesResponse symbol
     * @property {Array.<quotestore.ICandle>|null} [candles] CandlesResponse candles
     */

    /**
     * Constructs a new CandlesResponse.
     * @memberof quotestore
     * @classdesc Represents a CandlesResponse.
     * @implements ICandlesResponse
     * @constructor
     * @param {quotestore.ICandlesResponse=} [properties] Properties to set
     */
    function CandlesResponse(properties) {
      this.candles = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CandlesResponse symbol.
     * @member {string} symbol
     * @memberof quotestore.CandlesResponse
     * @instance
     */
    CandlesResponse.prototype.symbol = '';

    /**
     * CandlesResponse candles.
     * @member {Array.<quotestore.ICandle>} candles
     * @memberof quotestore.CandlesResponse
     * @instance
     */
    CandlesResponse.prototype.candles = $util.emptyArray;

    /**
     * Creates a new CandlesResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {quotestore.ICandlesResponse=} [properties] Properties to set
     * @returns {quotestore.CandlesResponse} CandlesResponse instance
     */
    CandlesResponse.create = function create(properties) {
      return new CandlesResponse(properties);
    };

    /**
     * Encodes the specified CandlesResponse message. Does not implicitly {@link quotestore.CandlesResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {quotestore.ICandlesResponse} message CandlesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.candles != null && message.candles.length)
        for (let i = 0; i < message.candles.length; ++i)
          $root.quotestore.Candle.encode(message.candles[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified CandlesResponse message, length delimited. Does not implicitly {@link quotestore.CandlesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {quotestore.ICandlesResponse} message CandlesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandlesResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CandlesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.CandlesResponse} CandlesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.CandlesResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            if (!(message.candles && message.candles.length)) message.candles = [];
            message.candles.push($root.quotestore.Candle.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CandlesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.CandlesResponse} CandlesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandlesResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CandlesResponse message.
     * @function verify
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CandlesResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.candles != null && message.hasOwnProperty('candles')) {
        if (!Array.isArray(message.candles)) return 'candles: array expected';
        for (let i = 0; i < message.candles.length; ++i) {
          let error = $root.quotestore.Candle.verify(message.candles[i]);
          if (error) return 'candles.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a CandlesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.CandlesResponse} CandlesResponse
     */
    CandlesResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.CandlesResponse) return object;
      let message = new $root.quotestore.CandlesResponse();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.candles) {
        if (!Array.isArray(object.candles)) throw TypeError('.quotestore.CandlesResponse.candles: array expected');
        message.candles = [];
        for (let i = 0; i < object.candles.length; ++i) {
          if (typeof object.candles[i] !== 'object')
            throw TypeError('.quotestore.CandlesResponse.candles: object expected');
          message.candles[i] = $root.quotestore.Candle.fromObject(object.candles[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a CandlesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.CandlesResponse
     * @static
     * @param {quotestore.CandlesResponse} message CandlesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CandlesResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.candles = [];
      if (options.defaults) object.symbol = '';
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.candles && message.candles.length) {
        object.candles = [];
        for (let j = 0; j < message.candles.length; ++j)
          object.candles[j] = $root.quotestore.Candle.toObject(message.candles[j], options);
      }
      return object;
    };

    /**
     * Converts this CandlesResponse to JSON.
     * @function toJSON
     * @memberof quotestore.CandlesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CandlesResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CandlesResponse;
  })();

  quotestore.CandleTick = (function () {
    /**
     * Properties of a CandleTick.
     * @memberof quotestore
     * @interface ICandleTick
     * @property {string|null} [subscriptionId] CandleTick subscriptionId
     * @property {quotestore.ICandle|null} [candle] CandleTick candle
     */

    /**
     * Constructs a new CandleTick.
     * @memberof quotestore
     * @classdesc Represents a CandleTick.
     * @implements ICandleTick
     * @constructor
     * @param {quotestore.ICandleTick=} [properties] Properties to set
     */
    function CandleTick(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CandleTick subscriptionId.
     * @member {string} subscriptionId
     * @memberof quotestore.CandleTick
     * @instance
     */
    CandleTick.prototype.subscriptionId = '';

    /**
     * CandleTick candle.
     * @member {quotestore.ICandle|null|undefined} candle
     * @memberof quotestore.CandleTick
     * @instance
     */
    CandleTick.prototype.candle = null;

    /**
     * Creates a new CandleTick instance using the specified properties.
     * @function create
     * @memberof quotestore.CandleTick
     * @static
     * @param {quotestore.ICandleTick=} [properties] Properties to set
     * @returns {quotestore.CandleTick} CandleTick instance
     */
    CandleTick.create = function create(properties) {
      return new CandleTick(properties);
    };

    /**
     * Encodes the specified CandleTick message. Does not implicitly {@link quotestore.CandleTick.verify|verify} messages.
     * @function encode
     * @memberof quotestore.CandleTick
     * @static
     * @param {quotestore.ICandleTick} message CandleTick message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandleTick.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.subscriptionId != null && Object.hasOwnProperty.call(message, 'subscriptionId'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.subscriptionId);
      if (message.candle != null && Object.hasOwnProperty.call(message, 'candle'))
        $root.quotestore.Candle.encode(message.candle, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified CandleTick message, length delimited. Does not implicitly {@link quotestore.CandleTick.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.CandleTick
     * @static
     * @param {quotestore.ICandleTick} message CandleTick message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CandleTick.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CandleTick message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.CandleTick
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.CandleTick} CandleTick
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandleTick.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.CandleTick();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.subscriptionId = reader.string();
            break;
          }
          case 2: {
            message.candle = $root.quotestore.Candle.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CandleTick message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.CandleTick
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.CandleTick} CandleTick
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CandleTick.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CandleTick message.
     * @function verify
     * @memberof quotestore.CandleTick
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CandleTick.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.subscriptionId != null && message.hasOwnProperty('subscriptionId'))
        if (!$util.isString(message.subscriptionId)) return 'subscriptionId: string expected';
      if (message.candle != null && message.hasOwnProperty('candle')) {
        let error = $root.quotestore.Candle.verify(message.candle);
        if (error) return 'candle.' + error;
      }
      return null;
    };

    /**
     * Creates a CandleTick message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.CandleTick
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.CandleTick} CandleTick
     */
    CandleTick.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.CandleTick) return object;
      let message = new $root.quotestore.CandleTick();
      if (object.subscriptionId != null) message.subscriptionId = String(object.subscriptionId);
      if (object.candle != null) {
        if (typeof object.candle !== 'object') throw TypeError('.quotestore.CandleTick.candle: object expected');
        message.candle = $root.quotestore.Candle.fromObject(object.candle);
      }
      return message;
    };

    /**
     * Creates a plain object from a CandleTick message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.CandleTick
     * @static
     * @param {quotestore.CandleTick} message CandleTick
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CandleTick.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.subscriptionId = '';
        object.candle = null;
      }
      if (message.subscriptionId != null && message.hasOwnProperty('subscriptionId'))
        object.subscriptionId = message.subscriptionId;
      if (message.candle != null && message.hasOwnProperty('candle'))
        object.candle = $root.quotestore.Candle.toObject(message.candle, options);
      return object;
    };

    /**
     * Converts this CandleTick to JSON.
     * @function toJSON
     * @memberof quotestore.CandleTick
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CandleTick.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CandleTick;
  })();

  quotestore.Candle = (function () {
    /**
     * Properties of a Candle.
     * @memberof quotestore
     * @interface ICandle
     * @property {number|null} [time] Candle time
     * @property {string|null} [symbol] Candle symbol
     * @property {number|null} [open] Candle open
     * @property {number|null} [high] Candle high
     * @property {number|null} [low] Candle low
     * @property {number|null} [close] Candle close
     * @property {number|Long|null} [volume] Candle volume
     * @property {string|null} [dateTime] Candle dateTime
     * @property {number|null} [volumeAsDouble] Candle volumeAsDouble
     */

    /**
     * Constructs a new Candle.
     * @memberof quotestore
     * @classdesc Represents a Candle.
     * @implements ICandle
     * @constructor
     * @param {quotestore.ICandle=} [properties] Properties to set
     */
    function Candle(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Candle time.
     * @member {number} time
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.time = 0;

    /**
     * Candle symbol.
     * @member {string} symbol
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.symbol = '';

    /**
     * Candle open.
     * @member {number} open
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.open = 0;

    /**
     * Candle high.
     * @member {number} high
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.high = 0;

    /**
     * Candle low.
     * @member {number} low
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.low = 0;

    /**
     * Candle close.
     * @member {number} close
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.close = 0;

    /**
     * Candle volume.
     * @member {number|Long} volume
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.volume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Candle dateTime.
     * @member {string} dateTime
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.dateTime = '';

    /**
     * Candle volumeAsDouble.
     * @member {number} volumeAsDouble
     * @memberof quotestore.Candle
     * @instance
     */
    Candle.prototype.volumeAsDouble = 0;

    /**
     * Creates a new Candle instance using the specified properties.
     * @function create
     * @memberof quotestore.Candle
     * @static
     * @param {quotestore.ICandle=} [properties] Properties to set
     * @returns {quotestore.Candle} Candle instance
     */
    Candle.create = function create(properties) {
      return new Candle(properties);
    };

    /**
     * Encodes the specified Candle message. Does not implicitly {@link quotestore.Candle.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Candle
     * @static
     * @param {quotestore.ICandle} message Candle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Candle.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.time);
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.symbol);
      if (message.open != null && Object.hasOwnProperty.call(message, 'open'))
        writer.uint32(/* id 3, wireType 1 =*/ 25).double(message.open);
      if (message.high != null && Object.hasOwnProperty.call(message, 'high'))
        writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, 'low'))
        writer.uint32(/* id 5, wireType 1 =*/ 41).double(message.low);
      if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
        writer.uint32(/* id 6, wireType 1 =*/ 49).double(message.close);
      if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).int64(message.volume);
      if (message.dateTime != null && Object.hasOwnProperty.call(message, 'dateTime'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.dateTime);
      if (message.volumeAsDouble != null && Object.hasOwnProperty.call(message, 'volumeAsDouble'))
        writer.uint32(/* id 9, wireType 1 =*/ 73).double(message.volumeAsDouble);
      return writer;
    };

    /**
     * Encodes the specified Candle message, length delimited. Does not implicitly {@link quotestore.Candle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Candle
     * @static
     * @param {quotestore.ICandle} message Candle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Candle.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Candle message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Candle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Candle} Candle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Candle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Candle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.time = reader.int32();
            break;
          }
          case 2: {
            message.symbol = reader.string();
            break;
          }
          case 3: {
            message.open = reader.double();
            break;
          }
          case 4: {
            message.high = reader.double();
            break;
          }
          case 5: {
            message.low = reader.double();
            break;
          }
          case 6: {
            message.close = reader.double();
            break;
          }
          case 7: {
            message.volume = reader.int64();
            break;
          }
          case 8: {
            message.dateTime = reader.string();
            break;
          }
          case 9: {
            message.volumeAsDouble = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Candle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Candle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Candle} Candle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Candle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Candle message.
     * @function verify
     * @memberof quotestore.Candle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Candle.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (!$util.isInteger(message.time)) return 'time: integer expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.open != null && message.hasOwnProperty('open'))
        if (typeof message.open !== 'number') return 'open: number expected';
      if (message.high != null && message.hasOwnProperty('high'))
        if (typeof message.high !== 'number') return 'high: number expected';
      if (message.low != null && message.hasOwnProperty('low'))
        if (typeof message.low !== 'number') return 'low: number expected';
      if (message.close != null && message.hasOwnProperty('close'))
        if (typeof message.close !== 'number') return 'close: number expected';
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (
          !$util.isInteger(message.volume) &&
          !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high))
        )
          return 'volume: integer|Long expected';
      if (message.dateTime != null && message.hasOwnProperty('dateTime'))
        if (!$util.isString(message.dateTime)) return 'dateTime: string expected';
      if (message.volumeAsDouble != null && message.hasOwnProperty('volumeAsDouble'))
        if (typeof message.volumeAsDouble !== 'number') return 'volumeAsDouble: number expected';
      return null;
    };

    /**
     * Creates a Candle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Candle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Candle} Candle
     */
    Candle.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Candle) return object;
      let message = new $root.quotestore.Candle();
      if (object.time != null) message.time = object.time | 0;
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.open != null) message.open = Number(object.open);
      if (object.high != null) message.high = Number(object.high);
      if (object.low != null) message.low = Number(object.low);
      if (object.close != null) message.close = Number(object.close);
      if (object.volume != null)
        if ($util.Long) (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
        else if (typeof object.volume === 'string') message.volume = parseInt(object.volume, 10);
        else if (typeof object.volume === 'number') message.volume = object.volume;
        else if (typeof object.volume === 'object')
          message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
      if (object.dateTime != null) message.dateTime = String(object.dateTime);
      if (object.volumeAsDouble != null) message.volumeAsDouble = Number(object.volumeAsDouble);
      return message;
    };

    /**
     * Creates a plain object from a Candle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Candle
     * @static
     * @param {quotestore.Candle} message Candle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Candle.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.time = 0;
        object.symbol = '';
        object.open = 0;
        object.high = 0;
        object.low = 0;
        object.close = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume = options.longs === String ? '0' : 0;
        object.dateTime = '';
        object.volumeAsDouble = 0;
      }
      if (message.time != null && message.hasOwnProperty('time')) object.time = message.time;
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.open != null && message.hasOwnProperty('open'))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.high != null && message.hasOwnProperty('high'))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty('low'))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.close != null && message.hasOwnProperty('close'))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (typeof message.volume === 'number')
          object.volume = options.longs === String ? String(message.volume) : message.volume;
        else
          object.volume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume)
              : options.longs === Number
                ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber()
                : message.volume;
      if (message.dateTime != null && message.hasOwnProperty('dateTime')) object.dateTime = message.dateTime;
      if (message.volumeAsDouble != null && message.hasOwnProperty('volumeAsDouble'))
        object.volumeAsDouble =
          options.json && !isFinite(message.volumeAsDouble) ? String(message.volumeAsDouble) : message.volumeAsDouble;
      return object;
    };

    /**
     * Converts this Candle to JSON.
     * @function toJSON
     * @memberof quotestore.Candle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Candle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Candle;
  })();

  quotestore.ChartRequest = (function () {
    /**
     * Properties of a ChartRequest.
     * @memberof quotestore
     * @interface IChartRequest
     */

    /**
     * Constructs a new ChartRequest.
     * @memberof quotestore
     * @classdesc Represents a ChartRequest.
     * @implements IChartRequest
     * @constructor
     * @param {quotestore.IChartRequest=} [properties] Properties to set
     */
    function ChartRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ChartRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.ChartRequest
     * @static
     * @param {quotestore.IChartRequest=} [properties] Properties to set
     * @returns {quotestore.ChartRequest} ChartRequest instance
     */
    ChartRequest.create = function create(properties) {
      return new ChartRequest(properties);
    };

    /**
     * Encodes the specified ChartRequest message. Does not implicitly {@link quotestore.ChartRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.ChartRequest
     * @static
     * @param {quotestore.IChartRequest} message ChartRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChartRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      return writer;
    };

    /**
     * Encodes the specified ChartRequest message, length delimited. Does not implicitly {@link quotestore.ChartRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.ChartRequest
     * @static
     * @param {quotestore.IChartRequest} message ChartRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChartRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChartRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.ChartRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.ChartRequest} ChartRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChartRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.ChartRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ChartRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.ChartRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.ChartRequest} ChartRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChartRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChartRequest message.
     * @function verify
     * @memberof quotestore.ChartRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChartRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      return null;
    };

    /**
     * Creates a ChartRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.ChartRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.ChartRequest} ChartRequest
     */
    ChartRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.ChartRequest) return object;
      return new $root.quotestore.ChartRequest();
    };

    /**
     * Creates a plain object from a ChartRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.ChartRequest
     * @static
     * @param {quotestore.ChartRequest} message ChartRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChartRequest.toObject = function toObject() {
      return {};
    };

    /**
     * Converts this ChartRequest to JSON.
     * @function toJSON
     * @memberof quotestore.ChartRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChartRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChartRequest;
  })();

  quotestore.QuotesResponse = (function () {
    /**
     * Properties of a QuotesResponse.
     * @memberof quotestore
     * @interface IQuotesResponse
     * @property {Array.<quotestore.ILastQuote>|null} [quotes] QuotesResponse quotes
     * @property {number|null} [processTimeMillis] QuotesResponse processTimeMillis
     */

    /**
     * Constructs a new QuotesResponse.
     * @memberof quotestore
     * @classdesc Represents a QuotesResponse.
     * @implements IQuotesResponse
     * @constructor
     * @param {quotestore.IQuotesResponse=} [properties] Properties to set
     */
    function QuotesResponse(properties) {
      this.quotes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QuotesResponse quotes.
     * @member {Array.<quotestore.ILastQuote>} quotes
     * @memberof quotestore.QuotesResponse
     * @instance
     */
    QuotesResponse.prototype.quotes = $util.emptyArray;

    /**
     * QuotesResponse processTimeMillis.
     * @member {number} processTimeMillis
     * @memberof quotestore.QuotesResponse
     * @instance
     */
    QuotesResponse.prototype.processTimeMillis = 0;

    /**
     * Creates a new QuotesResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {quotestore.IQuotesResponse=} [properties] Properties to set
     * @returns {quotestore.QuotesResponse} QuotesResponse instance
     */
    QuotesResponse.create = function create(properties) {
      return new QuotesResponse(properties);
    };

    /**
     * Encodes the specified QuotesResponse message. Does not implicitly {@link quotestore.QuotesResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {quotestore.IQuotesResponse} message QuotesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuotesResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.quotes != null && message.quotes.length)
        for (let i = 0; i < message.quotes.length; ++i)
          $root.quotestore.LastQuote.encode(
            message.quotes[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      if (message.processTimeMillis != null && Object.hasOwnProperty.call(message, 'processTimeMillis'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.processTimeMillis);
      return writer;
    };

    /**
     * Encodes the specified QuotesResponse message, length delimited. Does not implicitly {@link quotestore.QuotesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {quotestore.IQuotesResponse} message QuotesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuotesResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QuotesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.QuotesResponse} QuotesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuotesResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.QuotesResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.quotes && message.quotes.length)) message.quotes = [];
            message.quotes.push($root.quotestore.LastQuote.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            message.processTimeMillis = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QuotesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.QuotesResponse} QuotesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuotesResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QuotesResponse message.
     * @function verify
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QuotesResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.quotes != null && message.hasOwnProperty('quotes')) {
        if (!Array.isArray(message.quotes)) return 'quotes: array expected';
        for (let i = 0; i < message.quotes.length; ++i) {
          let error = $root.quotestore.LastQuote.verify(message.quotes[i]);
          if (error) return 'quotes.' + error;
        }
      }
      if (message.processTimeMillis != null && message.hasOwnProperty('processTimeMillis'))
        if (!$util.isInteger(message.processTimeMillis)) return 'processTimeMillis: integer expected';
      return null;
    };

    /**
     * Creates a QuotesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.QuotesResponse} QuotesResponse
     */
    QuotesResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.QuotesResponse) return object;
      let message = new $root.quotestore.QuotesResponse();
      if (object.quotes) {
        if (!Array.isArray(object.quotes)) throw TypeError('.quotestore.QuotesResponse.quotes: array expected');
        message.quotes = [];
        for (let i = 0; i < object.quotes.length; ++i) {
          if (typeof object.quotes[i] !== 'object')
            throw TypeError('.quotestore.QuotesResponse.quotes: object expected');
          message.quotes[i] = $root.quotestore.LastQuote.fromObject(object.quotes[i]);
        }
      }
      if (object.processTimeMillis != null) message.processTimeMillis = object.processTimeMillis | 0;
      return message;
    };

    /**
     * Creates a plain object from a QuotesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.QuotesResponse
     * @static
     * @param {quotestore.QuotesResponse} message QuotesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QuotesResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.quotes = [];
      if (options.defaults) object.processTimeMillis = 0;
      if (message.quotes && message.quotes.length) {
        object.quotes = [];
        for (let j = 0; j < message.quotes.length; ++j)
          object.quotes[j] = $root.quotestore.LastQuote.toObject(message.quotes[j], options);
      }
      if (message.processTimeMillis != null && message.hasOwnProperty('processTimeMillis'))
        object.processTimeMillis = message.processTimeMillis;
      return object;
    };

    /**
     * Converts this QuotesResponse to JSON.
     * @function toJSON
     * @memberof quotestore.QuotesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QuotesResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QuotesResponse;
  })();

  /**
   * SessionType enum.
   * @name quotestore.SessionType
   * @enum {number}
   * @property {number} NA=0 NA value
   * @property {number} PRE_MARKET=1 PRE_MARKET value
   * @property {number} REGULAR=2 REGULAR value
   * @property {number} AFTER_MARKET=3 AFTER_MARKET value
   */
  quotestore.SessionType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'NA')] = 0;
    values[(valuesById[1] = 'PRE_MARKET')] = 1;
    values[(valuesById[2] = 'REGULAR')] = 2;
    values[(valuesById[3] = 'AFTER_MARKET')] = 3;
    return values;
  })();

  quotestore.LastQuote = (function () {
    /**
     * Properties of a LastQuote.
     * @memberof quotestore
     * @interface ILastQuote
     * @property {string|null} [symbol] LastQuote symbol
     * @property {string|null} [currency] LastQuote currency
     * @property {number|null} [delayedMinutes] LastQuote delayedMinutes
     * @property {quotestore.SessionType|null} [sessionType] LastQuote sessionType
     * @property {quotestore.IError|null} [error] LastQuote error
     * @property {string|null} [name] LastQuote name
     * @property {string|null} [type] LastQuote type
     * @property {string|null} [exchange] LastQuote exchange
     * @property {number|null} [open] LastQuote open
     * @property {number|null} [dayHigh] LastQuote dayHigh
     * @property {number|null} [dayLow] LastQuote dayLow
     * @property {number|null} [close] LastQuote close
     * @property {number|null} [volume] LastQuote volume
     * @property {number|null} [bidPrice] LastQuote bidPrice
     * @property {number|null} [askPrice] LastQuote askPrice
     * @property {number|null} [lastTradePrice] LastQuote lastTradePrice
     * @property {number|Long|null} [lastTradeTime] LastQuote lastTradeTime
     * @property {number|null} [previousClose] LastQuote previousClose
     * @property {number|null} [change] LastQuote change
     * @property {number|null} [percentChange] LastQuote percentChange
     * @property {number|null} [fiftyTwoWeekHigh] LastQuote fiftyTwoWeekHigh
     * @property {number|null} [fiftyTwoWeekLow] LastQuote fiftyTwoWeekLow
     * @property {number|null} [preMarketPrice] LastQuote preMarketPrice
     * @property {number|null} [preMarketVolume] LastQuote preMarketVolume
     * @property {number|null} [afterMarketPrice] LastQuote afterMarketPrice
     * @property {number|null} [afterMarketVolume] LastQuote afterMarketVolume
     */

    /**
     * Constructs a new LastQuote.
     * @memberof quotestore
     * @classdesc Represents a LastQuote.
     * @implements ILastQuote
     * @constructor
     * @param {quotestore.ILastQuote=} [properties] Properties to set
     */
    function LastQuote(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * LastQuote symbol.
     * @member {string} symbol
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.symbol = '';

    /**
     * LastQuote currency.
     * @member {string} currency
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.currency = '';

    /**
     * LastQuote delayedMinutes.
     * @member {number} delayedMinutes
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.delayedMinutes = 0;

    /**
     * LastQuote sessionType.
     * @member {quotestore.SessionType} sessionType
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.sessionType = 0;

    /**
     * LastQuote error.
     * @member {quotestore.IError|null|undefined} error
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.error = null;

    /**
     * LastQuote name.
     * @member {string} name
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.name = '';

    /**
     * LastQuote type.
     * @member {string} type
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.type = '';

    /**
     * LastQuote exchange.
     * @member {string} exchange
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.exchange = '';

    /**
     * LastQuote open.
     * @member {number} open
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.open = 0;

    /**
     * LastQuote dayHigh.
     * @member {number} dayHigh
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.dayHigh = 0;

    /**
     * LastQuote dayLow.
     * @member {number} dayLow
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.dayLow = 0;

    /**
     * LastQuote close.
     * @member {number} close
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.close = 0;

    /**
     * LastQuote volume.
     * @member {number} volume
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.volume = 0;

    /**
     * LastQuote bidPrice.
     * @member {number} bidPrice
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.bidPrice = 0;

    /**
     * LastQuote askPrice.
     * @member {number} askPrice
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.askPrice = 0;

    /**
     * LastQuote lastTradePrice.
     * @member {number} lastTradePrice
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.lastTradePrice = 0;

    /**
     * LastQuote lastTradeTime.
     * @member {number|Long} lastTradeTime
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.lastTradeTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote previousClose.
     * @member {number} previousClose
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.previousClose = 0;

    /**
     * LastQuote change.
     * @member {number} change
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.change = 0;

    /**
     * LastQuote percentChange.
     * @member {number} percentChange
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.percentChange = 0;

    /**
     * LastQuote fiftyTwoWeekHigh.
     * @member {number} fiftyTwoWeekHigh
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.fiftyTwoWeekHigh = 0;

    /**
     * LastQuote fiftyTwoWeekLow.
     * @member {number} fiftyTwoWeekLow
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.fiftyTwoWeekLow = 0;

    /**
     * LastQuote preMarketPrice.
     * @member {number} preMarketPrice
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketPrice = 0;

    /**
     * LastQuote preMarketVolume.
     * @member {number} preMarketVolume
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketVolume = 0;

    /**
     * LastQuote afterMarketPrice.
     * @member {number} afterMarketPrice
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketPrice = 0;

    /**
     * LastQuote afterMarketVolume.
     * @member {number} afterMarketVolume
     * @memberof quotestore.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketVolume = 0;

    /**
     * Creates a new LastQuote instance using the specified properties.
     * @function create
     * @memberof quotestore.LastQuote
     * @static
     * @param {quotestore.ILastQuote=} [properties] Properties to set
     * @returns {quotestore.LastQuote} LastQuote instance
     */
    LastQuote.create = function create(properties) {
      return new LastQuote(properties);
    };

    /**
     * Encodes the specified LastQuote message. Does not implicitly {@link quotestore.LastQuote.verify|verify} messages.
     * @function encode
     * @memberof quotestore.LastQuote
     * @static
     * @param {quotestore.ILastQuote} message LastQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LastQuote.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.currency != null && Object.hasOwnProperty.call(message, 'currency'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.currency);
      if (message.delayedMinutes != null && Object.hasOwnProperty.call(message, 'delayedMinutes'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.delayedMinutes);
      if (message.sessionType != null && Object.hasOwnProperty.call(message, 'sessionType'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.sessionType);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.quotestore.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.name);
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.type);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.exchange);
      if (message.bidPrice != null && Object.hasOwnProperty.call(message, 'bidPrice'))
        writer.uint32(/* id 10, wireType 1 =*/ 81).double(message.bidPrice);
      if (message.askPrice != null && Object.hasOwnProperty.call(message, 'askPrice'))
        writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.askPrice);
      if (message.lastTradePrice != null && Object.hasOwnProperty.call(message, 'lastTradePrice'))
        writer.uint32(/* id 20, wireType 1 =*/ 161).double(message.lastTradePrice);
      if (message.lastTradeTime != null && Object.hasOwnProperty.call(message, 'lastTradeTime'))
        writer.uint32(/* id 21, wireType 0 =*/ 168).int64(message.lastTradeTime);
      if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
        writer.uint32(/* id 22, wireType 1 =*/ 177).double(message.previousClose);
      if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
        writer.uint32(/* id 23, wireType 1 =*/ 185).double(message.change);
      if (message.percentChange != null && Object.hasOwnProperty.call(message, 'percentChange'))
        writer.uint32(/* id 24, wireType 1 =*/ 193).double(message.percentChange);
      if (message.fiftyTwoWeekHigh != null && Object.hasOwnProperty.call(message, 'fiftyTwoWeekHigh'))
        writer.uint32(/* id 30, wireType 1 =*/ 241).double(message.fiftyTwoWeekHigh);
      if (message.fiftyTwoWeekLow != null && Object.hasOwnProperty.call(message, 'fiftyTwoWeekLow'))
        writer.uint32(/* id 31, wireType 1 =*/ 249).double(message.fiftyTwoWeekLow);
      if (message.preMarketPrice != null && Object.hasOwnProperty.call(message, 'preMarketPrice'))
        writer.uint32(/* id 40, wireType 1 =*/ 321).double(message.preMarketPrice);
      if (message.preMarketVolume != null && Object.hasOwnProperty.call(message, 'preMarketVolume'))
        writer.uint32(/* id 41, wireType 0 =*/ 328).int32(message.preMarketVolume);
      if (message.afterMarketPrice != null && Object.hasOwnProperty.call(message, 'afterMarketPrice'))
        writer.uint32(/* id 42, wireType 1 =*/ 337).double(message.afterMarketPrice);
      if (message.afterMarketVolume != null && Object.hasOwnProperty.call(message, 'afterMarketVolume'))
        writer.uint32(/* id 43, wireType 0 =*/ 344).int32(message.afterMarketVolume);
      if (message.open != null && Object.hasOwnProperty.call(message, 'open'))
        writer.uint32(/* id 50, wireType 1 =*/ 401).double(message.open);
      if (message.dayHigh != null && Object.hasOwnProperty.call(message, 'dayHigh'))
        writer.uint32(/* id 51, wireType 1 =*/ 409).double(message.dayHigh);
      if (message.dayLow != null && Object.hasOwnProperty.call(message, 'dayLow'))
        writer.uint32(/* id 52, wireType 1 =*/ 417).double(message.dayLow);
      if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
        writer.uint32(/* id 53, wireType 1 =*/ 425).double(message.close);
      if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
        writer.uint32(/* id 54, wireType 0 =*/ 432).int32(message.volume);
      return writer;
    };

    /**
     * Encodes the specified LastQuote message, length delimited. Does not implicitly {@link quotestore.LastQuote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.LastQuote
     * @static
     * @param {quotestore.ILastQuote} message LastQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LastQuote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LastQuote message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.LastQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.LastQuote} LastQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LastQuote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.LastQuote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.currency = reader.string();
            break;
          }
          case 3: {
            message.delayedMinutes = reader.int32();
            break;
          }
          case 4: {
            message.sessionType = reader.int32();
            break;
          }
          case 5: {
            message.error = $root.quotestore.Error.decode(reader, reader.uint32());
            break;
          }
          case 6: {
            message.name = reader.string();
            break;
          }
          case 7: {
            message.type = reader.string();
            break;
          }
          case 8: {
            message.exchange = reader.string();
            break;
          }
          case 50: {
            message.open = reader.double();
            break;
          }
          case 51: {
            message.dayHigh = reader.double();
            break;
          }
          case 52: {
            message.dayLow = reader.double();
            break;
          }
          case 53: {
            message.close = reader.double();
            break;
          }
          case 54: {
            message.volume = reader.int32();
            break;
          }
          case 10: {
            message.bidPrice = reader.double();
            break;
          }
          case 11: {
            message.askPrice = reader.double();
            break;
          }
          case 20: {
            message.lastTradePrice = reader.double();
            break;
          }
          case 21: {
            message.lastTradeTime = reader.int64();
            break;
          }
          case 22: {
            message.previousClose = reader.double();
            break;
          }
          case 23: {
            message.change = reader.double();
            break;
          }
          case 24: {
            message.percentChange = reader.double();
            break;
          }
          case 30: {
            message.fiftyTwoWeekHigh = reader.double();
            break;
          }
          case 31: {
            message.fiftyTwoWeekLow = reader.double();
            break;
          }
          case 40: {
            message.preMarketPrice = reader.double();
            break;
          }
          case 41: {
            message.preMarketVolume = reader.int32();
            break;
          }
          case 42: {
            message.afterMarketPrice = reader.double();
            break;
          }
          case 43: {
            message.afterMarketVolume = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a LastQuote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.LastQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.LastQuote} LastQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LastQuote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LastQuote message.
     * @function verify
     * @memberof quotestore.LastQuote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LastQuote.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.currency != null && message.hasOwnProperty('currency'))
        if (!$util.isString(message.currency)) return 'currency: string expected';
      if (message.delayedMinutes != null && message.hasOwnProperty('delayedMinutes'))
        if (!$util.isInteger(message.delayedMinutes)) return 'delayedMinutes: integer expected';
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        switch (message.sessionType) {
          default:
            return 'sessionType: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.quotestore.Error.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.type != null && message.hasOwnProperty('type'))
        if (!$util.isString(message.type)) return 'type: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.open != null && message.hasOwnProperty('open'))
        if (typeof message.open !== 'number') return 'open: number expected';
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        if (typeof message.dayHigh !== 'number') return 'dayHigh: number expected';
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        if (typeof message.dayLow !== 'number') return 'dayLow: number expected';
      if (message.close != null && message.hasOwnProperty('close'))
        if (typeof message.close !== 'number') return 'close: number expected';
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (!$util.isInteger(message.volume)) return 'volume: integer expected';
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        if (typeof message.bidPrice !== 'number') return 'bidPrice: number expected';
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        if (typeof message.askPrice !== 'number') return 'askPrice: number expected';
      if (message.lastTradePrice != null && message.hasOwnProperty('lastTradePrice'))
        if (typeof message.lastTradePrice !== 'number') return 'lastTradePrice: number expected';
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (
          !$util.isInteger(message.lastTradeTime) &&
          !(
            message.lastTradeTime &&
            $util.isInteger(message.lastTradeTime.low) &&
            $util.isInteger(message.lastTradeTime.high)
          )
        )
          return 'lastTradeTime: integer|Long expected';
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
      if (message.change != null && message.hasOwnProperty('change'))
        if (typeof message.change !== 'number') return 'change: number expected';
      if (message.percentChange != null && message.hasOwnProperty('percentChange'))
        if (typeof message.percentChange !== 'number') return 'percentChange: number expected';
      if (message.fiftyTwoWeekHigh != null && message.hasOwnProperty('fiftyTwoWeekHigh'))
        if (typeof message.fiftyTwoWeekHigh !== 'number') return 'fiftyTwoWeekHigh: number expected';
      if (message.fiftyTwoWeekLow != null && message.hasOwnProperty('fiftyTwoWeekLow'))
        if (typeof message.fiftyTwoWeekLow !== 'number') return 'fiftyTwoWeekLow: number expected';
      if (message.preMarketPrice != null && message.hasOwnProperty('preMarketPrice'))
        if (typeof message.preMarketPrice !== 'number') return 'preMarketPrice: number expected';
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        if (!$util.isInteger(message.preMarketVolume)) return 'preMarketVolume: integer expected';
      if (message.afterMarketPrice != null && message.hasOwnProperty('afterMarketPrice'))
        if (typeof message.afterMarketPrice !== 'number') return 'afterMarketPrice: number expected';
      if (message.afterMarketVolume != null && message.hasOwnProperty('afterMarketVolume'))
        if (!$util.isInteger(message.afterMarketVolume)) return 'afterMarketVolume: integer expected';
      return null;
    };

    /**
     * Creates a LastQuote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.LastQuote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.LastQuote} LastQuote
     */
    LastQuote.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.LastQuote) return object;
      let message = new $root.quotestore.LastQuote();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.currency != null) message.currency = String(object.currency);
      if (object.delayedMinutes != null) message.delayedMinutes = object.delayedMinutes | 0;
      switch (object.sessionType) {
        default:
          if (typeof object.sessionType === 'number') {
            message.sessionType = object.sessionType;
            break;
          }
          break;
        case 'NA':
        case 0:
          message.sessionType = 0;
          break;
        case 'PRE_MARKET':
        case 1:
          message.sessionType = 1;
          break;
        case 'REGULAR':
        case 2:
          message.sessionType = 2;
          break;
        case 'AFTER_MARKET':
        case 3:
          message.sessionType = 3;
          break;
      }
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.quotestore.LastQuote.error: object expected');
        message.error = $root.quotestore.Error.fromObject(object.error);
      }
      if (object.name != null) message.name = String(object.name);
      if (object.type != null) message.type = String(object.type);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.open != null) message.open = Number(object.open);
      if (object.dayHigh != null) message.dayHigh = Number(object.dayHigh);
      if (object.dayLow != null) message.dayLow = Number(object.dayLow);
      if (object.close != null) message.close = Number(object.close);
      if (object.volume != null) message.volume = object.volume | 0;
      if (object.bidPrice != null) message.bidPrice = Number(object.bidPrice);
      if (object.askPrice != null) message.askPrice = Number(object.askPrice);
      if (object.lastTradePrice != null) message.lastTradePrice = Number(object.lastTradePrice);
      if (object.lastTradeTime != null)
        if ($util.Long) (message.lastTradeTime = $util.Long.fromValue(object.lastTradeTime)).unsigned = false;
        else if (typeof object.lastTradeTime === 'string') message.lastTradeTime = parseInt(object.lastTradeTime, 10);
        else if (typeof object.lastTradeTime === 'number') message.lastTradeTime = object.lastTradeTime;
        else if (typeof object.lastTradeTime === 'object')
          message.lastTradeTime = new $util.LongBits(
            object.lastTradeTime.low >>> 0,
            object.lastTradeTime.high >>> 0,
          ).toNumber();
      if (object.previousClose != null) message.previousClose = Number(object.previousClose);
      if (object.change != null) message.change = Number(object.change);
      if (object.percentChange != null) message.percentChange = Number(object.percentChange);
      if (object.fiftyTwoWeekHigh != null) message.fiftyTwoWeekHigh = Number(object.fiftyTwoWeekHigh);
      if (object.fiftyTwoWeekLow != null) message.fiftyTwoWeekLow = Number(object.fiftyTwoWeekLow);
      if (object.preMarketPrice != null) message.preMarketPrice = Number(object.preMarketPrice);
      if (object.preMarketVolume != null) message.preMarketVolume = object.preMarketVolume | 0;
      if (object.afterMarketPrice != null) message.afterMarketPrice = Number(object.afterMarketPrice);
      if (object.afterMarketVolume != null) message.afterMarketVolume = object.afterMarketVolume | 0;
      return message;
    };

    /**
     * Creates a plain object from a LastQuote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.LastQuote
     * @static
     * @param {quotestore.LastQuote} message LastQuote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LastQuote.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.currency = '';
        object.delayedMinutes = 0;
        object.sessionType = options.enums === String ? 'NA' : 0;
        object.error = null;
        object.name = '';
        object.type = '';
        object.exchange = '';
        object.bidPrice = 0;
        object.askPrice = 0;
        object.lastTradePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastTradeTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.lastTradeTime = options.longs === String ? '0' : 0;
        object.previousClose = 0;
        object.change = 0;
        object.percentChange = 0;
        object.fiftyTwoWeekHigh = 0;
        object.fiftyTwoWeekLow = 0;
        object.preMarketPrice = 0;
        object.preMarketVolume = 0;
        object.afterMarketPrice = 0;
        object.afterMarketVolume = 0;
        object.open = 0;
        object.dayHigh = 0;
        object.dayLow = 0;
        object.close = 0;
        object.volume = 0;
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.currency != null && message.hasOwnProperty('currency')) object.currency = message.currency;
      if (message.delayedMinutes != null && message.hasOwnProperty('delayedMinutes'))
        object.delayedMinutes = message.delayedMinutes;
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        object.sessionType =
          options.enums === String
            ? $root.quotestore.SessionType[message.sessionType] === undefined
              ? message.sessionType
              : $root.quotestore.SessionType[message.sessionType]
            : message.sessionType;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.quotestore.Error.toObject(message.error, options);
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        object.bidPrice = options.json && !isFinite(message.bidPrice) ? String(message.bidPrice) : message.bidPrice;
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        object.askPrice = options.json && !isFinite(message.askPrice) ? String(message.askPrice) : message.askPrice;
      if (message.lastTradePrice != null && message.hasOwnProperty('lastTradePrice'))
        object.lastTradePrice =
          options.json && !isFinite(message.lastTradePrice) ? String(message.lastTradePrice) : message.lastTradePrice;
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (typeof message.lastTradeTime === 'number')
          object.lastTradeTime = options.longs === String ? String(message.lastTradeTime) : message.lastTradeTime;
        else
          object.lastTradeTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.lastTradeTime)
              : options.longs === Number
                ? new $util.LongBits(message.lastTradeTime.low >>> 0, message.lastTradeTime.high >>> 0).toNumber()
                : message.lastTradeTime;
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        object.previousClose =
          options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
      if (message.change != null && message.hasOwnProperty('change'))
        object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
      if (message.percentChange != null && message.hasOwnProperty('percentChange'))
        object.percentChange =
          options.json && !isFinite(message.percentChange) ? String(message.percentChange) : message.percentChange;
      if (message.fiftyTwoWeekHigh != null && message.hasOwnProperty('fiftyTwoWeekHigh'))
        object.fiftyTwoWeekHigh =
          options.json && !isFinite(message.fiftyTwoWeekHigh)
            ? String(message.fiftyTwoWeekHigh)
            : message.fiftyTwoWeekHigh;
      if (message.fiftyTwoWeekLow != null && message.hasOwnProperty('fiftyTwoWeekLow'))
        object.fiftyTwoWeekLow =
          options.json && !isFinite(message.fiftyTwoWeekLow)
            ? String(message.fiftyTwoWeekLow)
            : message.fiftyTwoWeekLow;
      if (message.preMarketPrice != null && message.hasOwnProperty('preMarketPrice'))
        object.preMarketPrice =
          options.json && !isFinite(message.preMarketPrice) ? String(message.preMarketPrice) : message.preMarketPrice;
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        object.preMarketVolume = message.preMarketVolume;
      if (message.afterMarketPrice != null && message.hasOwnProperty('afterMarketPrice'))
        object.afterMarketPrice =
          options.json && !isFinite(message.afterMarketPrice)
            ? String(message.afterMarketPrice)
            : message.afterMarketPrice;
      if (message.afterMarketVolume != null && message.hasOwnProperty('afterMarketVolume'))
        object.afterMarketVolume = message.afterMarketVolume;
      if (message.open != null && message.hasOwnProperty('open'))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        object.dayHigh = options.json && !isFinite(message.dayHigh) ? String(message.dayHigh) : message.dayHigh;
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        object.dayLow = options.json && !isFinite(message.dayLow) ? String(message.dayLow) : message.dayLow;
      if (message.close != null && message.hasOwnProperty('close'))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.volume != null && message.hasOwnProperty('volume')) object.volume = message.volume;
      return object;
    };

    /**
     * Converts this LastQuote to JSON.
     * @function toJSON
     * @memberof quotestore.LastQuote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LastQuote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LastQuote;
  })();

  quotestore.Error = (function () {
    /**
     * Properties of an Error.
     * @memberof quotestore
     * @interface IError
     * @property {quotestore.Error.Code|null} [code] Error code
     * @property {string|null} [message] Error message
     */

    /**
     * Constructs a new Error.
     * @memberof quotestore
     * @classdesc Represents an Error.
     * @implements IError
     * @constructor
     * @param {quotestore.IError=} [properties] Properties to set
     */
    function Error(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Error code.
     * @member {quotestore.Error.Code} code
     * @memberof quotestore.Error
     * @instance
     */
    Error.prototype.code = 0;

    /**
     * Error message.
     * @member {string} message
     * @memberof quotestore.Error
     * @instance
     */
    Error.prototype.message = '';

    /**
     * Creates a new Error instance using the specified properties.
     * @function create
     * @memberof quotestore.Error
     * @static
     * @param {quotestore.IError=} [properties] Properties to set
     * @returns {quotestore.Error} Error instance
     */
    Error.create = function create(properties) {
      return new Error(properties);
    };

    /**
     * Encodes the specified Error message. Does not implicitly {@link quotestore.Error.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Error
     * @static
     * @param {quotestore.IError} message Error message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Error.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.code != null && Object.hasOwnProperty.call(message, 'code'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.code);
      if (message.message != null && Object.hasOwnProperty.call(message, 'message'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
      return writer;
    };

    /**
     * Encodes the specified Error message, length delimited. Does not implicitly {@link quotestore.Error.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Error
     * @static
     * @param {quotestore.IError} message Error message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Error.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Error message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Error
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Error} Error
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Error.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Error();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.code = reader.int32();
            break;
          }
          case 2: {
            message.message = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an Error message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Error
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Error} Error
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Error.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Error message.
     * @function verify
     * @memberof quotestore.Error
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Error.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.code != null && message.hasOwnProperty('code'))
        switch (message.code) {
          default:
            return 'code: enum value expected';
          case 0:
          case 1:
            break;
        }
      if (message.message != null && message.hasOwnProperty('message'))
        if (!$util.isString(message.message)) return 'message: string expected';
      return null;
    };

    /**
     * Creates an Error message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Error
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Error} Error
     */
    Error.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Error) return object;
      let message = new $root.quotestore.Error();
      switch (object.code) {
        default:
          if (typeof object.code === 'number') {
            message.code = object.code;
            break;
          }
          break;
        case 'ERROR':
        case 0:
          message.code = 0;
          break;
        case 'UNKNOWN_SYMBOL':
        case 1:
          message.code = 1;
          break;
      }
      if (object.message != null) message.message = String(object.message);
      return message;
    };

    /**
     * Creates a plain object from an Error message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Error
     * @static
     * @param {quotestore.Error} message Error
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Error.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.code = options.enums === String ? 'ERROR' : 0;
        object.message = '';
      }
      if (message.code != null && message.hasOwnProperty('code'))
        object.code =
          options.enums === String
            ? $root.quotestore.Error.Code[message.code] === undefined
              ? message.code
              : $root.quotestore.Error.Code[message.code]
            : message.code;
      if (message.message != null && message.hasOwnProperty('message')) object.message = message.message;
      return object;
    };

    /**
     * Converts this Error to JSON.
     * @function toJSON
     * @memberof quotestore.Error
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Error.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Code enum.
     * @name quotestore.Error.Code
     * @enum {number}
     * @property {number} ERROR=0 ERROR value
     * @property {number} UNKNOWN_SYMBOL=1 UNKNOWN_SYMBOL value
     */
    Error.Code = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'ERROR')] = 0;
      values[(valuesById[1] = 'UNKNOWN_SYMBOL')] = 1;
      return values;
    })();

    return Error;
  })();

  quotestore.MoversRequest = (function () {
    /**
     * Properties of a MoversRequest.
     * @memberof quotestore
     * @interface IMoversRequest
     * @property {string|null} [from] MoversRequest from
     * @property {string|null} [to] MoversRequest to
     * @property {string|null} [asOf] MoversRequest asOf
     * @property {string|null} [session] MoversRequest session
     * @property {string|null} [indexFilter] MoversRequest indexFilter
     * @property {string|null} [screenerQuery] MoversRequest screenerQuery
     * @property {number|null} [maxResults] MoversRequest maxResults
     * @property {quotestore.MoversRequest.SortField|null} [sortField] MoversRequest sortField
     */

    /**
     * Constructs a new MoversRequest.
     * @memberof quotestore
     * @classdesc Represents a MoversRequest.
     * @implements IMoversRequest
     * @constructor
     * @param {quotestore.IMoversRequest=} [properties] Properties to set
     */
    function MoversRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversRequest from.
     * @member {string} from
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.from = '';

    /**
     * MoversRequest to.
     * @member {string} to
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.to = '';

    /**
     * MoversRequest asOf.
     * @member {string} asOf
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.asOf = '';

    /**
     * MoversRequest session.
     * @member {string} session
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.session = '';

    /**
     * MoversRequest indexFilter.
     * @member {string} indexFilter
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.indexFilter = '';

    /**
     * MoversRequest screenerQuery.
     * @member {string} screenerQuery
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.screenerQuery = '';

    /**
     * MoversRequest maxResults.
     * @member {number} maxResults
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.maxResults = 0;

    /**
     * MoversRequest sortField.
     * @member {quotestore.MoversRequest.SortField} sortField
     * @memberof quotestore.MoversRequest
     * @instance
     */
    MoversRequest.prototype.sortField = 0;

    /**
     * Creates a new MoversRequest instance using the specified properties.
     * @function create
     * @memberof quotestore.MoversRequest
     * @static
     * @param {quotestore.IMoversRequest=} [properties] Properties to set
     * @returns {quotestore.MoversRequest} MoversRequest instance
     */
    MoversRequest.create = function create(properties) {
      return new MoversRequest(properties);
    };

    /**
     * Encodes the specified MoversRequest message. Does not implicitly {@link quotestore.MoversRequest.verify|verify} messages.
     * @function encode
     * @memberof quotestore.MoversRequest
     * @static
     * @param {quotestore.IMoversRequest} message MoversRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.from != null && Object.hasOwnProperty.call(message, 'from'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.from);
      if (message.to != null && Object.hasOwnProperty.call(message, 'to'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.to);
      if (message.asOf != null && Object.hasOwnProperty.call(message, 'asOf'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.asOf);
      if (message.session != null && Object.hasOwnProperty.call(message, 'session'))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.session);
      if (message.indexFilter != null && Object.hasOwnProperty.call(message, 'indexFilter'))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.indexFilter);
      if (message.screenerQuery != null && Object.hasOwnProperty.call(message, 'screenerQuery'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.screenerQuery);
      if (message.maxResults != null && Object.hasOwnProperty.call(message, 'maxResults'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.maxResults);
      if (message.sortField != null && Object.hasOwnProperty.call(message, 'sortField'))
        writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.sortField);
      return writer;
    };

    /**
     * Encodes the specified MoversRequest message, length delimited. Does not implicitly {@link quotestore.MoversRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.MoversRequest
     * @static
     * @param {quotestore.IMoversRequest} message MoversRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversRequest message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.MoversRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.MoversRequest} MoversRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.MoversRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.from = reader.string();
            break;
          }
          case 2: {
            message.to = reader.string();
            break;
          }
          case 3: {
            message.asOf = reader.string();
            break;
          }
          case 4: {
            message.session = reader.string();
            break;
          }
          case 5: {
            message.indexFilter = reader.string();
            break;
          }
          case 6: {
            message.screenerQuery = reader.string();
            break;
          }
          case 7: {
            message.maxResults = reader.int32();
            break;
          }
          case 8: {
            message.sortField = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.MoversRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.MoversRequest} MoversRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversRequest message.
     * @function verify
     * @memberof quotestore.MoversRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.from != null && message.hasOwnProperty('from'))
        if (!$util.isString(message.from)) return 'from: string expected';
      if (message.to != null && message.hasOwnProperty('to'))
        if (!$util.isString(message.to)) return 'to: string expected';
      if (message.asOf != null && message.hasOwnProperty('asOf'))
        if (!$util.isString(message.asOf)) return 'asOf: string expected';
      if (message.session != null && message.hasOwnProperty('session'))
        if (!$util.isString(message.session)) return 'session: string expected';
      if (message.indexFilter != null && message.hasOwnProperty('indexFilter'))
        if (!$util.isString(message.indexFilter)) return 'indexFilter: string expected';
      if (message.screenerQuery != null && message.hasOwnProperty('screenerQuery'))
        if (!$util.isString(message.screenerQuery)) return 'screenerQuery: string expected';
      if (message.maxResults != null && message.hasOwnProperty('maxResults'))
        if (!$util.isInteger(message.maxResults)) return 'maxResults: integer expected';
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        switch (message.sortField) {
          default:
            return 'sortField: enum value expected';
          case 0:
          case 1:
            break;
        }
      return null;
    };

    /**
     * Creates a MoversRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.MoversRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.MoversRequest} MoversRequest
     */
    MoversRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.MoversRequest) return object;
      let message = new $root.quotestore.MoversRequest();
      if (object.from != null) message.from = String(object.from);
      if (object.to != null) message.to = String(object.to);
      if (object.asOf != null) message.asOf = String(object.asOf);
      if (object.session != null) message.session = String(object.session);
      if (object.indexFilter != null) message.indexFilter = String(object.indexFilter);
      if (object.screenerQuery != null) message.screenerQuery = String(object.screenerQuery);
      if (object.maxResults != null) message.maxResults = object.maxResults | 0;
      switch (object.sortField) {
        default:
          if (typeof object.sortField === 'number') {
            message.sortField = object.sortField;
            break;
          }
          break;
        case 'CHANGE_PERCENT':
        case 0:
          message.sortField = 0;
          break;
        case 'ATR_RATIO':
        case 1:
          message.sortField = 1;
          break;
      }
      return message;
    };

    /**
     * Creates a plain object from a MoversRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.MoversRequest
     * @static
     * @param {quotestore.MoversRequest} message MoversRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.from = '';
        object.to = '';
        object.asOf = '';
        object.session = '';
        object.indexFilter = '';
        object.screenerQuery = '';
        object.maxResults = 0;
        object.sortField = options.enums === String ? 'CHANGE_PERCENT' : 0;
      }
      if (message.from != null && message.hasOwnProperty('from')) object.from = message.from;
      if (message.to != null && message.hasOwnProperty('to')) object.to = message.to;
      if (message.asOf != null && message.hasOwnProperty('asOf')) object.asOf = message.asOf;
      if (message.session != null && message.hasOwnProperty('session')) object.session = message.session;
      if (message.indexFilter != null && message.hasOwnProperty('indexFilter'))
        object.indexFilter = message.indexFilter;
      if (message.screenerQuery != null && message.hasOwnProperty('screenerQuery'))
        object.screenerQuery = message.screenerQuery;
      if (message.maxResults != null && message.hasOwnProperty('maxResults')) object.maxResults = message.maxResults;
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        object.sortField =
          options.enums === String
            ? $root.quotestore.MoversRequest.SortField[message.sortField] === undefined
              ? message.sortField
              : $root.quotestore.MoversRequest.SortField[message.sortField]
            : message.sortField;
      return object;
    };

    /**
     * Converts this MoversRequest to JSON.
     * @function toJSON
     * @memberof quotestore.MoversRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * SortField enum.
     * @name quotestore.MoversRequest.SortField
     * @enum {number}
     * @property {number} CHANGE_PERCENT=0 CHANGE_PERCENT value
     * @property {number} ATR_RATIO=1 ATR_RATIO value
     */
    MoversRequest.SortField = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'CHANGE_PERCENT')] = 0;
      values[(valuesById[1] = 'ATR_RATIO')] = 1;
      return values;
    })();

    return MoversRequest;
  })();

  quotestore.MoversResponse = (function () {
    /**
     * Properties of a MoversResponse.
     * @memberof quotestore
     * @interface IMoversResponse
     * @property {number|null} [processingTimeMillis] MoversResponse processingTimeMillis
     * @property {quotestore.IError|null} [error] MoversResponse error
     * @property {quotestore.IMoversResult|null} [result] MoversResponse result
     */

    /**
     * Constructs a new MoversResponse.
     * @memberof quotestore
     * @classdesc Represents a MoversResponse.
     * @implements IMoversResponse
     * @constructor
     * @param {quotestore.IMoversResponse=} [properties] Properties to set
     */
    function MoversResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversResponse processingTimeMillis.
     * @member {number} processingTimeMillis
     * @memberof quotestore.MoversResponse
     * @instance
     */
    MoversResponse.prototype.processingTimeMillis = 0;

    /**
     * MoversResponse error.
     * @member {quotestore.IError|null|undefined} error
     * @memberof quotestore.MoversResponse
     * @instance
     */
    MoversResponse.prototype.error = null;

    /**
     * MoversResponse result.
     * @member {quotestore.IMoversResult|null|undefined} result
     * @memberof quotestore.MoversResponse
     * @instance
     */
    MoversResponse.prototype.result = null;

    /**
     * Creates a new MoversResponse instance using the specified properties.
     * @function create
     * @memberof quotestore.MoversResponse
     * @static
     * @param {quotestore.IMoversResponse=} [properties] Properties to set
     * @returns {quotestore.MoversResponse} MoversResponse instance
     */
    MoversResponse.create = function create(properties) {
      return new MoversResponse(properties);
    };

    /**
     * Encodes the specified MoversResponse message. Does not implicitly {@link quotestore.MoversResponse.verify|verify} messages.
     * @function encode
     * @memberof quotestore.MoversResponse
     * @static
     * @param {quotestore.IMoversResponse} message MoversResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.processingTimeMillis != null && Object.hasOwnProperty.call(message, 'processingTimeMillis'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.processingTimeMillis);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.quotestore.Error.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      if (message.result != null && Object.hasOwnProperty.call(message, 'result'))
        $root.quotestore.MoversResult.encode(message.result, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified MoversResponse message, length delimited. Does not implicitly {@link quotestore.MoversResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.MoversResponse
     * @static
     * @param {quotestore.IMoversResponse} message MoversResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversResponse message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.MoversResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.MoversResponse} MoversResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.MoversResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.processingTimeMillis = reader.int32();
            break;
          }
          case 2: {
            message.error = $root.quotestore.Error.decode(reader, reader.uint32());
            break;
          }
          case 3: {
            message.result = $root.quotestore.MoversResult.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.MoversResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.MoversResponse} MoversResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversResponse message.
     * @function verify
     * @memberof quotestore.MoversResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        if (!$util.isInteger(message.processingTimeMillis)) return 'processingTimeMillis: integer expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.quotestore.Error.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.result != null && message.hasOwnProperty('result')) {
        let error = $root.quotestore.MoversResult.verify(message.result);
        if (error) return 'result.' + error;
      }
      return null;
    };

    /**
     * Creates a MoversResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.MoversResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.MoversResponse} MoversResponse
     */
    MoversResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.MoversResponse) return object;
      let message = new $root.quotestore.MoversResponse();
      if (object.processingTimeMillis != null) message.processingTimeMillis = object.processingTimeMillis | 0;
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.quotestore.MoversResponse.error: object expected');
        message.error = $root.quotestore.Error.fromObject(object.error);
      }
      if (object.result != null) {
        if (typeof object.result !== 'object') throw TypeError('.quotestore.MoversResponse.result: object expected');
        message.result = $root.quotestore.MoversResult.fromObject(object.result);
      }
      return message;
    };

    /**
     * Creates a plain object from a MoversResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.MoversResponse
     * @static
     * @param {quotestore.MoversResponse} message MoversResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.processingTimeMillis = 0;
        object.error = null;
        object.result = null;
      }
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        object.processingTimeMillis = message.processingTimeMillis;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.quotestore.Error.toObject(message.error, options);
      if (message.result != null && message.hasOwnProperty('result'))
        object.result = $root.quotestore.MoversResult.toObject(message.result, options);
      return object;
    };

    /**
     * Converts this MoversResponse to JSON.
     * @function toJSON
     * @memberof quotestore.MoversResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoversResponse;
  })();

  quotestore.MoversResult = (function () {
    /**
     * Properties of a MoversResult.
     * @memberof quotestore
     * @interface IMoversResult
     * @property {string|null} [fromDate] MoversResult fromDate
     * @property {string|null} [toDate] MoversResult toDate
     * @property {string|null} [snapFrom] MoversResult snapFrom
     * @property {string|null} [snapTo] MoversResult snapTo
     * @property {boolean|null} [usePreviousClose] MoversResult usePreviousClose
     * @property {boolean|null} [inReset] MoversResult inReset
     * @property {Array.<quotestore.MoversResult.IMover>|null} [gainers] MoversResult gainers
     * @property {Array.<quotestore.MoversResult.IMover>|null} [losers] MoversResult losers
     */

    /**
     * Constructs a new MoversResult.
     * @memberof quotestore
     * @classdesc Represents a MoversResult.
     * @implements IMoversResult
     * @constructor
     * @param {quotestore.IMoversResult=} [properties] Properties to set
     */
    function MoversResult(properties) {
      this.gainers = [];
      this.losers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversResult fromDate.
     * @member {string} fromDate
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.fromDate = '';

    /**
     * MoversResult toDate.
     * @member {string} toDate
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.toDate = '';

    /**
     * MoversResult snapFrom.
     * @member {string} snapFrom
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.snapFrom = '';

    /**
     * MoversResult snapTo.
     * @member {string} snapTo
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.snapTo = '';

    /**
     * MoversResult usePreviousClose.
     * @member {boolean} usePreviousClose
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.usePreviousClose = false;

    /**
     * MoversResult inReset.
     * @member {boolean} inReset
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.inReset = false;

    /**
     * MoversResult gainers.
     * @member {Array.<quotestore.MoversResult.IMover>} gainers
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.gainers = $util.emptyArray;

    /**
     * MoversResult losers.
     * @member {Array.<quotestore.MoversResult.IMover>} losers
     * @memberof quotestore.MoversResult
     * @instance
     */
    MoversResult.prototype.losers = $util.emptyArray;

    /**
     * Creates a new MoversResult instance using the specified properties.
     * @function create
     * @memberof quotestore.MoversResult
     * @static
     * @param {quotestore.IMoversResult=} [properties] Properties to set
     * @returns {quotestore.MoversResult} MoversResult instance
     */
    MoversResult.create = function create(properties) {
      return new MoversResult(properties);
    };

    /**
     * Encodes the specified MoversResult message. Does not implicitly {@link quotestore.MoversResult.verify|verify} messages.
     * @function encode
     * @memberof quotestore.MoversResult
     * @static
     * @param {quotestore.IMoversResult} message MoversResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResult.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.fromDate != null && Object.hasOwnProperty.call(message, 'fromDate'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.fromDate);
      if (message.toDate != null && Object.hasOwnProperty.call(message, 'toDate'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.toDate);
      if (message.snapFrom != null && Object.hasOwnProperty.call(message, 'snapFrom'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.snapFrom);
      if (message.snapTo != null && Object.hasOwnProperty.call(message, 'snapTo'))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.snapTo);
      if (message.usePreviousClose != null && Object.hasOwnProperty.call(message, 'usePreviousClose'))
        writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.usePreviousClose);
      if (message.inReset != null && Object.hasOwnProperty.call(message, 'inReset'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.inReset);
      if (message.gainers != null && message.gainers.length)
        for (let i = 0; i < message.gainers.length; ++i)
          $root.quotestore.MoversResult.Mover.encode(
            message.gainers[i],
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork(),
          ).ldelim();
      if (message.losers != null && message.losers.length)
        for (let i = 0; i < message.losers.length; ++i)
          $root.quotestore.MoversResult.Mover.encode(
            message.losers[i],
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified MoversResult message, length delimited. Does not implicitly {@link quotestore.MoversResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.MoversResult
     * @static
     * @param {quotestore.IMoversResult} message MoversResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversResult message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.MoversResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.MoversResult} MoversResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.MoversResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.fromDate = reader.string();
            break;
          }
          case 2: {
            message.toDate = reader.string();
            break;
          }
          case 3: {
            message.snapFrom = reader.string();
            break;
          }
          case 4: {
            message.snapTo = reader.string();
            break;
          }
          case 5: {
            message.usePreviousClose = reader.bool();
            break;
          }
          case 6: {
            message.inReset = reader.bool();
            break;
          }
          case 7: {
            if (!(message.gainers && message.gainers.length)) message.gainers = [];
            message.gainers.push($root.quotestore.MoversResult.Mover.decode(reader, reader.uint32()));
            break;
          }
          case 8: {
            if (!(message.losers && message.losers.length)) message.losers = [];
            message.losers.push($root.quotestore.MoversResult.Mover.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.MoversResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.MoversResult} MoversResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversResult message.
     * @function verify
     * @memberof quotestore.MoversResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversResult.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.fromDate != null && message.hasOwnProperty('fromDate'))
        if (!$util.isString(message.fromDate)) return 'fromDate: string expected';
      if (message.toDate != null && message.hasOwnProperty('toDate'))
        if (!$util.isString(message.toDate)) return 'toDate: string expected';
      if (message.snapFrom != null && message.hasOwnProperty('snapFrom'))
        if (!$util.isString(message.snapFrom)) return 'snapFrom: string expected';
      if (message.snapTo != null && message.hasOwnProperty('snapTo'))
        if (!$util.isString(message.snapTo)) return 'snapTo: string expected';
      if (message.usePreviousClose != null && message.hasOwnProperty('usePreviousClose'))
        if (typeof message.usePreviousClose !== 'boolean') return 'usePreviousClose: boolean expected';
      if (message.inReset != null && message.hasOwnProperty('inReset'))
        if (typeof message.inReset !== 'boolean') return 'inReset: boolean expected';
      if (message.gainers != null && message.hasOwnProperty('gainers')) {
        if (!Array.isArray(message.gainers)) return 'gainers: array expected';
        for (let i = 0; i < message.gainers.length; ++i) {
          let error = $root.quotestore.MoversResult.Mover.verify(message.gainers[i]);
          if (error) return 'gainers.' + error;
        }
      }
      if (message.losers != null && message.hasOwnProperty('losers')) {
        if (!Array.isArray(message.losers)) return 'losers: array expected';
        for (let i = 0; i < message.losers.length; ++i) {
          let error = $root.quotestore.MoversResult.Mover.verify(message.losers[i]);
          if (error) return 'losers.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a MoversResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.MoversResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.MoversResult} MoversResult
     */
    MoversResult.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.MoversResult) return object;
      let message = new $root.quotestore.MoversResult();
      if (object.fromDate != null) message.fromDate = String(object.fromDate);
      if (object.toDate != null) message.toDate = String(object.toDate);
      if (object.snapFrom != null) message.snapFrom = String(object.snapFrom);
      if (object.snapTo != null) message.snapTo = String(object.snapTo);
      if (object.usePreviousClose != null) message.usePreviousClose = Boolean(object.usePreviousClose);
      if (object.inReset != null) message.inReset = Boolean(object.inReset);
      if (object.gainers) {
        if (!Array.isArray(object.gainers)) throw TypeError('.quotestore.MoversResult.gainers: array expected');
        message.gainers = [];
        for (let i = 0; i < object.gainers.length; ++i) {
          if (typeof object.gainers[i] !== 'object')
            throw TypeError('.quotestore.MoversResult.gainers: object expected');
          message.gainers[i] = $root.quotestore.MoversResult.Mover.fromObject(object.gainers[i]);
        }
      }
      if (object.losers) {
        if (!Array.isArray(object.losers)) throw TypeError('.quotestore.MoversResult.losers: array expected');
        message.losers = [];
        for (let i = 0; i < object.losers.length; ++i) {
          if (typeof object.losers[i] !== 'object') throw TypeError('.quotestore.MoversResult.losers: object expected');
          message.losers[i] = $root.quotestore.MoversResult.Mover.fromObject(object.losers[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a MoversResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.MoversResult
     * @static
     * @param {quotestore.MoversResult} message MoversResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversResult.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.gainers = [];
        object.losers = [];
      }
      if (options.defaults) {
        object.fromDate = '';
        object.toDate = '';
        object.snapFrom = '';
        object.snapTo = '';
        object.usePreviousClose = false;
        object.inReset = false;
      }
      if (message.fromDate != null && message.hasOwnProperty('fromDate')) object.fromDate = message.fromDate;
      if (message.toDate != null && message.hasOwnProperty('toDate')) object.toDate = message.toDate;
      if (message.snapFrom != null && message.hasOwnProperty('snapFrom')) object.snapFrom = message.snapFrom;
      if (message.snapTo != null && message.hasOwnProperty('snapTo')) object.snapTo = message.snapTo;
      if (message.usePreviousClose != null && message.hasOwnProperty('usePreviousClose'))
        object.usePreviousClose = message.usePreviousClose;
      if (message.inReset != null && message.hasOwnProperty('inReset')) object.inReset = message.inReset;
      if (message.gainers && message.gainers.length) {
        object.gainers = [];
        for (let j = 0; j < message.gainers.length; ++j)
          object.gainers[j] = $root.quotestore.MoversResult.Mover.toObject(message.gainers[j], options);
      }
      if (message.losers && message.losers.length) {
        object.losers = [];
        for (let j = 0; j < message.losers.length; ++j)
          object.losers[j] = $root.quotestore.MoversResult.Mover.toObject(message.losers[j], options);
      }
      return object;
    };

    /**
     * Converts this MoversResult to JSON.
     * @function toJSON
     * @memberof quotestore.MoversResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoversResult.Mover = (function () {
      /**
       * Properties of a Mover.
       * @memberof quotestore.MoversResult
       * @interface IMover
       * @property {string|null} [symbol] Mover symbol
       * @property {number|null} [price] Mover price
       * @property {number|null} [change] Mover change
       * @property {number|null} [changePercent] Mover changePercent
       * @property {number|null} [volume] Mover volume
       * @property {number|null} [close] Mover close
       * @property {number|null} [atr] Mover atr
       * @property {number|null} [atrRatio] Mover atrRatio
       * @property {string|null} [companyName] Mover companyName
       * @property {number|null} [averageVolume] Mover averageVolume
       * @property {number|null} [previousClose] Mover previousClose
       * @property {string|null} [sector] Mover sector
       * @property {number|Long|null} [marketCap] Mover marketCap
       * @property {string|null} [gicsSectorName] Mover gicsSectorName
       */

      /**
       * Constructs a new Mover.
       * @memberof quotestore.MoversResult
       * @classdesc Represents a Mover.
       * @implements IMover
       * @constructor
       * @param {quotestore.MoversResult.IMover=} [properties] Properties to set
       */
      function Mover(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Mover symbol.
       * @member {string} symbol
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.symbol = '';

      /**
       * Mover price.
       * @member {number} price
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.price = 0;

      /**
       * Mover change.
       * @member {number} change
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.change = 0;

      /**
       * Mover changePercent.
       * @member {number} changePercent
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.changePercent = 0;

      /**
       * Mover volume.
       * @member {number} volume
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.volume = 0;

      /**
       * Mover close.
       * @member {number} close
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.close = 0;

      /**
       * Mover atr.
       * @member {number} atr
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.atr = 0;

      /**
       * Mover atrRatio.
       * @member {number} atrRatio
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.atrRatio = 0;

      /**
       * Mover companyName.
       * @member {string} companyName
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.companyName = '';

      /**
       * Mover averageVolume.
       * @member {number} averageVolume
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.averageVolume = 0;

      /**
       * Mover previousClose.
       * @member {number} previousClose
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.previousClose = 0;

      /**
       * Mover sector.
       * @member {string} sector
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.sector = '';

      /**
       * Mover marketCap.
       * @member {number|Long} marketCap
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.marketCap = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * Mover gicsSectorName.
       * @member {string} gicsSectorName
       * @memberof quotestore.MoversResult.Mover
       * @instance
       */
      Mover.prototype.gicsSectorName = '';

      /**
       * Creates a new Mover instance using the specified properties.
       * @function create
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {quotestore.MoversResult.IMover=} [properties] Properties to set
       * @returns {quotestore.MoversResult.Mover} Mover instance
       */
      Mover.create = function create(properties) {
        return new Mover(properties);
      };

      /**
       * Encodes the specified Mover message. Does not implicitly {@link quotestore.MoversResult.Mover.verify|verify} messages.
       * @function encode
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {quotestore.MoversResult.IMover} message Mover message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Mover.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, 'price'))
          writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.price);
        if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
          writer.uint32(/* id 3, wireType 1 =*/ 25).double(message.change);
        if (message.changePercent != null && Object.hasOwnProperty.call(message, 'changePercent'))
          writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.changePercent);
        if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
          writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.volume);
        if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
          writer.uint32(/* id 6, wireType 1 =*/ 49).double(message.close);
        if (message.atr != null && Object.hasOwnProperty.call(message, 'atr'))
          writer.uint32(/* id 7, wireType 1 =*/ 57).double(message.atr);
        if (message.atrRatio != null && Object.hasOwnProperty.call(message, 'atrRatio'))
          writer.uint32(/* id 8, wireType 1 =*/ 65).double(message.atrRatio);
        if (message.companyName != null && Object.hasOwnProperty.call(message, 'companyName'))
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.companyName);
        if (message.averageVolume != null && Object.hasOwnProperty.call(message, 'averageVolume'))
          writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.averageVolume);
        if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
          writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.previousClose);
        if (message.sector != null && Object.hasOwnProperty.call(message, 'sector'))
          writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.sector);
        if (message.marketCap != null && Object.hasOwnProperty.call(message, 'marketCap'))
          writer.uint32(/* id 13, wireType 0 =*/ 104).int64(message.marketCap);
        if (message.gicsSectorName != null && Object.hasOwnProperty.call(message, 'gicsSectorName'))
          writer.uint32(/* id 14, wireType 2 =*/ 114).string(message.gicsSectorName);
        return writer;
      };

      /**
       * Encodes the specified Mover message, length delimited. Does not implicitly {@link quotestore.MoversResult.Mover.verify|verify} messages.
       * @function encodeDelimited
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {quotestore.MoversResult.IMover} message Mover message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Mover.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Mover message from the specified reader or buffer.
       * @function decode
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {quotestore.MoversResult.Mover} Mover
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Mover.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.quotestore.MoversResult.Mover();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.symbol = reader.string();
              break;
            }
            case 2: {
              message.price = reader.double();
              break;
            }
            case 3: {
              message.change = reader.double();
              break;
            }
            case 4: {
              message.changePercent = reader.double();
              break;
            }
            case 5: {
              message.volume = reader.int32();
              break;
            }
            case 6: {
              message.close = reader.double();
              break;
            }
            case 7: {
              message.atr = reader.double();
              break;
            }
            case 8: {
              message.atrRatio = reader.double();
              break;
            }
            case 9: {
              message.companyName = reader.string();
              break;
            }
            case 10: {
              message.averageVolume = reader.int32();
              break;
            }
            case 11: {
              message.previousClose = reader.double();
              break;
            }
            case 12: {
              message.sector = reader.string();
              break;
            }
            case 13: {
              message.marketCap = reader.int64();
              break;
            }
            case 14: {
              message.gicsSectorName = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Mover message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {quotestore.MoversResult.Mover} Mover
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Mover.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Mover message.
       * @function verify
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Mover.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.symbol != null && message.hasOwnProperty('symbol'))
          if (!$util.isString(message.symbol)) return 'symbol: string expected';
        if (message.price != null && message.hasOwnProperty('price'))
          if (typeof message.price !== 'number') return 'price: number expected';
        if (message.change != null && message.hasOwnProperty('change'))
          if (typeof message.change !== 'number') return 'change: number expected';
        if (message.changePercent != null && message.hasOwnProperty('changePercent'))
          if (typeof message.changePercent !== 'number') return 'changePercent: number expected';
        if (message.volume != null && message.hasOwnProperty('volume'))
          if (!$util.isInteger(message.volume)) return 'volume: integer expected';
        if (message.close != null && message.hasOwnProperty('close'))
          if (typeof message.close !== 'number') return 'close: number expected';
        if (message.atr != null && message.hasOwnProperty('atr'))
          if (typeof message.atr !== 'number') return 'atr: number expected';
        if (message.atrRatio != null && message.hasOwnProperty('atrRatio'))
          if (typeof message.atrRatio !== 'number') return 'atrRatio: number expected';
        if (message.companyName != null && message.hasOwnProperty('companyName'))
          if (!$util.isString(message.companyName)) return 'companyName: string expected';
        if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
          if (!$util.isInteger(message.averageVolume)) return 'averageVolume: integer expected';
        if (message.previousClose != null && message.hasOwnProperty('previousClose'))
          if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
        if (message.sector != null && message.hasOwnProperty('sector'))
          if (!$util.isString(message.sector)) return 'sector: string expected';
        if (message.marketCap != null && message.hasOwnProperty('marketCap'))
          if (
            !$util.isInteger(message.marketCap) &&
            !(message.marketCap && $util.isInteger(message.marketCap.low) && $util.isInteger(message.marketCap.high))
          )
            return 'marketCap: integer|Long expected';
        if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
          if (!$util.isString(message.gicsSectorName)) return 'gicsSectorName: string expected';
        return null;
      };

      /**
       * Creates a Mover message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {quotestore.MoversResult.Mover} Mover
       */
      Mover.fromObject = function fromObject(object) {
        if (object instanceof $root.quotestore.MoversResult.Mover) return object;
        let message = new $root.quotestore.MoversResult.Mover();
        if (object.symbol != null) message.symbol = String(object.symbol);
        if (object.price != null) message.price = Number(object.price);
        if (object.change != null) message.change = Number(object.change);
        if (object.changePercent != null) message.changePercent = Number(object.changePercent);
        if (object.volume != null) message.volume = object.volume | 0;
        if (object.close != null) message.close = Number(object.close);
        if (object.atr != null) message.atr = Number(object.atr);
        if (object.atrRatio != null) message.atrRatio = Number(object.atrRatio);
        if (object.companyName != null) message.companyName = String(object.companyName);
        if (object.averageVolume != null) message.averageVolume = object.averageVolume | 0;
        if (object.previousClose != null) message.previousClose = Number(object.previousClose);
        if (object.sector != null) message.sector = String(object.sector);
        if (object.marketCap != null)
          if ($util.Long) (message.marketCap = $util.Long.fromValue(object.marketCap)).unsigned = false;
          else if (typeof object.marketCap === 'string') message.marketCap = parseInt(object.marketCap, 10);
          else if (typeof object.marketCap === 'number') message.marketCap = object.marketCap;
          else if (typeof object.marketCap === 'object')
            message.marketCap = new $util.LongBits(object.marketCap.low >>> 0, object.marketCap.high >>> 0).toNumber();
        if (object.gicsSectorName != null) message.gicsSectorName = String(object.gicsSectorName);
        return message;
      };

      /**
       * Creates a plain object from a Mover message. Also converts values to other types if specified.
       * @function toObject
       * @memberof quotestore.MoversResult.Mover
       * @static
       * @param {quotestore.MoversResult.Mover} message Mover
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Mover.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = '';
          object.price = 0;
          object.change = 0;
          object.changePercent = 0;
          object.volume = 0;
          object.close = 0;
          object.atr = 0;
          object.atrRatio = 0;
          object.companyName = '';
          object.averageVolume = 0;
          object.previousClose = 0;
          object.sector = '';
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.marketCap =
              options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else object.marketCap = options.longs === String ? '0' : 0;
          object.gicsSectorName = '';
        }
        if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty('price'))
          object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
        if (message.change != null && message.hasOwnProperty('change'))
          object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
        if (message.changePercent != null && message.hasOwnProperty('changePercent'))
          object.changePercent =
            options.json && !isFinite(message.changePercent) ? String(message.changePercent) : message.changePercent;
        if (message.volume != null && message.hasOwnProperty('volume')) object.volume = message.volume;
        if (message.close != null && message.hasOwnProperty('close'))
          object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
        if (message.atr != null && message.hasOwnProperty('atr'))
          object.atr = options.json && !isFinite(message.atr) ? String(message.atr) : message.atr;
        if (message.atrRatio != null && message.hasOwnProperty('atrRatio'))
          object.atrRatio = options.json && !isFinite(message.atrRatio) ? String(message.atrRatio) : message.atrRatio;
        if (message.companyName != null && message.hasOwnProperty('companyName'))
          object.companyName = message.companyName;
        if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
          object.averageVolume = message.averageVolume;
        if (message.previousClose != null && message.hasOwnProperty('previousClose'))
          object.previousClose =
            options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
        if (message.sector != null && message.hasOwnProperty('sector')) object.sector = message.sector;
        if (message.marketCap != null && message.hasOwnProperty('marketCap'))
          if (typeof message.marketCap === 'number')
            object.marketCap = options.longs === String ? String(message.marketCap) : message.marketCap;
          else
            object.marketCap =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.marketCap)
                : options.longs === Number
                  ? new $util.LongBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0).toNumber()
                  : message.marketCap;
        if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
          object.gicsSectorName = message.gicsSectorName;
        return object;
      };

      /**
       * Converts this Mover to JSON.
       * @function toJSON
       * @memberof quotestore.MoversResult.Mover
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Mover.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Mover;
    })();

    return MoversResult;
  })();

  /**
   * TickType enum.
   * @name quotestore.TickType
   * @enum {number}
   * @property {number} UNKNOWN=0 UNKNOWN value
   * @property {number} VALID=1 VALID value
   * @property {number} IN_VALID=2 IN_VALID value
   */
  quotestore.TickType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN')] = 0;
    values[(valuesById[1] = 'VALID')] = 1;
    values[(valuesById[2] = 'IN_VALID')] = 2;
    return values;
  })();

  quotestore.Quote = (function () {
    /**
     * Properties of a Quote.
     * @memberof quotestore
     * @interface IQuote
     * @property {string|null} [symbol] Quote symbol
     * @property {number|null} [previousClose] Quote previousClose
     * @property {number|null} [close] Quote close
     * @property {number|null} [change] Quote change
     * @property {number|null} [changePercent] Quote changePercent
     * @property {string|null} [name] Quote name
     * @property {string|null} [ipoDate] Quote ipoDate
     * @property {string|null} [exchange] Quote exchange
     * @property {string|null} [tradeExchange] Quote tradeExchange
     * @property {number|Long|null} [marketCap] Quote marketCap
     * @property {number|null} [rsi] Quote rsi
     * @property {number|null} [atr] Quote atr
     * @property {number|null} [pe] Quote pe
     * @property {number|Long|null} [averageVolume] Quote averageVolume
     * @property {number|Long|null} [sharesOutstanding] Quote sharesOutstanding
     * @property {string|null} [sector] Quote sector
     * @property {number|null} [sectorCode] Quote sectorCode
     * @property {string|null} [industry] Quote industry
     * @property {number|null} [industryCode] Quote industryCode
     * @property {number|null} [forwardPERatio] Quote forwardPERatio
     * @property {number|null} [pricetoEBITDA] Quote pricetoEBITDA
     * @property {number|null} [trailingDividendYield] Quote trailingDividendYield
     * @property {number|null} [PBRatio] Quote PBRatio
     * @property {number|null} [PSRatio] Quote PSRatio
     * @property {number|null} [FCFPerShare] Quote FCFPerShare
     * @property {number|null} [buyBackYield] Quote buyBackYield
     * @property {number|null} [open] Quote open
     * @property {number|null} [price] Quote price
     * @property {number|null} [high] Quote high
     * @property {number|null} [low] Quote low
     * @property {number|Long|null} [time] Quote time
     * @property {number|null} [size] Quote size
     * @property {string|null} [type] Quote type
     * @property {number|Long|null} [dayVolume] Quote dayVolume
     * @property {number|null} [askPrice] Quote askPrice
     * @property {number|null} [bidPrice] Quote bidPrice
     * @property {string|null} [shareFloatDate] Quote shareFloatDate
     * @property {string|null} [sharesOutstandingDate] Quote sharesOutstandingDate
     * @property {number|Long|null} [shareFloat] Quote shareFloat
     * @property {quotestore.TickType|null} [updateType] Quote updateType
     * @property {string|null} [subtype] Stored as a list of subtypes, separated by commas.
     * - We only recognize: COMMON_SHARE, ADR, ETF, UNIT, WARRANT
     * - There are other odd subtypes, but most relevant instruments have at least the main ones above
     * @property {quotestore.SessionType|null} [sessionType] Quote sessionType
     * @property {number|Long|null} [volume] Quote volume
     * @property {number|null} [changePercent1Minute] Quote changePercent1Minute
     * @property {number|null} [changePercentClose] Quote changePercentClose
     * @property {number|null} [changePercent5Minute] Quote changePercent5Minute
     * @property {number|Long|null} [volume1Minute] Quote volume1Minute
     * @property {number|null} [relativeVolume1Minute] Quote relativeVolume1Minute
     * @property {number|null} [change15Minute] Quote change15Minute
     * @property {number|null} [changePercent15Minute] Quote changePercent15Minute
     * @property {number|null} [change30Minute] Quote change30Minute
     * @property {number|null} [changePercent30Minute] Quote changePercent30Minute
     * @property {number|null} [change60Minute] Quote change60Minute
     * @property {number|null} [changePercent60Minute] Quote changePercent60Minute
     * @property {number|null} [changePercentOpen] Quote changePercentOpen
     * @property {number|null} [gics] Quote gics
     * @property {number|null} [gicsSector] Quote gicsSector
     * @property {string|null} [gicsSectorName] Quote gicsSectorName
     * @property {number|null} [gicsIndustryGroup] Quote gicsIndustryGroup
     * @property {string|null} [gicsIndustryGroupName] Quote gicsIndustryGroupName
     * @property {number|null} [gicsIndustry] Quote gicsIndustry
     * @property {string|null} [gicsIndustryName] Quote gicsIndustryName
     * @property {number|null} [gicsSubIndustry] Quote gicsSubIndustry
     * @property {string|null} [gicsSubIndustryName] Quote gicsSubIndustryName
     * @property {number|null} [cik] Quote cik
     * @property {string|null} [signalName] Quote signalName
     */

    /**
     * Constructs a new Quote.
     * @memberof quotestore
     * @classdesc Represents a Quote.
     * @implements IQuote
     * @constructor
     * @param {quotestore.IQuote=} [properties] Properties to set
     */
    function Quote(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Quote symbol.
     * @member {string} symbol
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.symbol = '';

    /**
     * Quote previousClose.
     * @member {number} previousClose
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.previousClose = 0;

    /**
     * Quote close.
     * @member {number} close
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.close = 0;

    /**
     * Quote change.
     * @member {number} change
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.change = 0;

    /**
     * Quote changePercent.
     * @member {number} changePercent
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent = 0;

    /**
     * Quote name.
     * @member {string} name
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.name = '';

    /**
     * Quote ipoDate.
     * @member {string} ipoDate
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.ipoDate = '';

    /**
     * Quote exchange.
     * @member {string} exchange
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.exchange = '';

    /**
     * Quote tradeExchange.
     * @member {string} tradeExchange
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.tradeExchange = '';

    /**
     * Quote marketCap.
     * @member {number|Long} marketCap
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.marketCap = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote rsi.
     * @member {number} rsi
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.rsi = 0;

    /**
     * Quote atr.
     * @member {number} atr
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.atr = 0;

    /**
     * Quote pe.
     * @member {number} pe
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.pe = 0;

    /**
     * Quote averageVolume.
     * @member {number|Long} averageVolume
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.averageVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sharesOutstanding.
     * @member {number|Long} sharesOutstanding
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.sharesOutstanding = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sector.
     * @member {string} sector
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.sector = '';

    /**
     * Quote sectorCode.
     * @member {number} sectorCode
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.sectorCode = 0;

    /**
     * Quote industry.
     * @member {string} industry
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.industry = '';

    /**
     * Quote industryCode.
     * @member {number} industryCode
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.industryCode = 0;

    /**
     * Quote forwardPERatio.
     * @member {number} forwardPERatio
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.forwardPERatio = 0;

    /**
     * Quote pricetoEBITDA.
     * @member {number} pricetoEBITDA
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.pricetoEBITDA = 0;

    /**
     * Quote trailingDividendYield.
     * @member {number} trailingDividendYield
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.trailingDividendYield = 0;

    /**
     * Quote PBRatio.
     * @member {number} PBRatio
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.PBRatio = 0;

    /**
     * Quote PSRatio.
     * @member {number} PSRatio
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.PSRatio = 0;

    /**
     * Quote FCFPerShare.
     * @member {number} FCFPerShare
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.FCFPerShare = 0;

    /**
     * Quote buyBackYield.
     * @member {number} buyBackYield
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.buyBackYield = 0;

    /**
     * Quote open.
     * @member {number} open
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.open = 0;

    /**
     * Quote price.
     * @member {number} price
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.price = 0;

    /**
     * Quote high.
     * @member {number} high
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.high = 0;

    /**
     * Quote low.
     * @member {number} low
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.low = 0;

    /**
     * Quote time.
     * @member {number|Long} time
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote size.
     * @member {number} size
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.size = 0;

    /**
     * Quote type.
     * @member {string} type
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.type = '';

    /**
     * Quote dayVolume.
     * @member {number|Long} dayVolume
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.dayVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote askPrice.
     * @member {number} askPrice
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.askPrice = 0;

    /**
     * Quote bidPrice.
     * @member {number} bidPrice
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.bidPrice = 0;

    /**
     * Quote shareFloatDate.
     * @member {string} shareFloatDate
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.shareFloatDate = '';

    /**
     * Quote sharesOutstandingDate.
     * @member {string} sharesOutstandingDate
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.sharesOutstandingDate = '';

    /**
     * Quote shareFloat.
     * @member {number|Long} shareFloat
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.shareFloat = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote updateType.
     * @member {quotestore.TickType} updateType
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.updateType = 0;

    /**
     * Stored as a list of subtypes, separated by commas.
     * - We only recognize: COMMON_SHARE, ADR, ETF, UNIT, WARRANT
     * - There are other odd subtypes, but most relevant instruments have at least the main ones above
     * @member {string} subtype
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.subtype = '';

    /**
     * Quote sessionType.
     * @member {quotestore.SessionType} sessionType
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.sessionType = 0;

    /**
     * Quote volume.
     * @member {number|Long} volume
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.volume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote changePercent1Minute.
     * @member {number} changePercent1Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent1Minute = 0;

    /**
     * Quote changePercentClose.
     * @member {number} changePercentClose
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercentClose = 0;

    /**
     * Quote changePercent5Minute.
     * @member {number} changePercent5Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent5Minute = 0;

    /**
     * Quote volume1Minute.
     * @member {number|Long} volume1Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.volume1Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote relativeVolume1Minute.
     * @member {number} relativeVolume1Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.relativeVolume1Minute = 0;

    /**
     * Quote change15Minute.
     * @member {number} change15Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.change15Minute = 0;

    /**
     * Quote changePercent15Minute.
     * @member {number} changePercent15Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent15Minute = 0;

    /**
     * Quote change30Minute.
     * @member {number} change30Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.change30Minute = 0;

    /**
     * Quote changePercent30Minute.
     * @member {number} changePercent30Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent30Minute = 0;

    /**
     * Quote change60Minute.
     * @member {number} change60Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.change60Minute = 0;

    /**
     * Quote changePercent60Minute.
     * @member {number} changePercent60Minute
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercent60Minute = 0;

    /**
     * Quote changePercentOpen.
     * @member {number} changePercentOpen
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.changePercentOpen = 0;

    /**
     * Quote gics.
     * @member {number} gics
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gics = 0;

    /**
     * Quote gicsSector.
     * @member {number} gicsSector
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsSector = 0;

    /**
     * Quote gicsSectorName.
     * @member {string} gicsSectorName
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsSectorName = '';

    /**
     * Quote gicsIndustryGroup.
     * @member {number} gicsIndustryGroup
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryGroup = 0;

    /**
     * Quote gicsIndustryGroupName.
     * @member {string} gicsIndustryGroupName
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryGroupName = '';

    /**
     * Quote gicsIndustry.
     * @member {number} gicsIndustry
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsIndustry = 0;

    /**
     * Quote gicsIndustryName.
     * @member {string} gicsIndustryName
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryName = '';

    /**
     * Quote gicsSubIndustry.
     * @member {number} gicsSubIndustry
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsSubIndustry = 0;

    /**
     * Quote gicsSubIndustryName.
     * @member {string} gicsSubIndustryName
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.gicsSubIndustryName = '';

    /**
     * Quote cik.
     * @member {number} cik
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.cik = 0;

    /**
     * Quote signalName.
     * @member {string} signalName
     * @memberof quotestore.Quote
     * @instance
     */
    Quote.prototype.signalName = '';

    /**
     * Creates a new Quote instance using the specified properties.
     * @function create
     * @memberof quotestore.Quote
     * @static
     * @param {quotestore.IQuote=} [properties] Properties to set
     * @returns {quotestore.Quote} Quote instance
     */
    Quote.create = function create(properties) {
      return new Quote(properties);
    };

    /**
     * Encodes the specified Quote message. Does not implicitly {@link quotestore.Quote.verify|verify} messages.
     * @function encode
     * @memberof quotestore.Quote
     * @static
     * @param {quotestore.IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
        writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.previousClose);
      if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
        writer.uint32(/* id 3, wireType 1 =*/ 25).double(message.close);
      if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
        writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.change);
      if (message.changePercent != null && Object.hasOwnProperty.call(message, 'changePercent'))
        writer.uint32(/* id 5, wireType 1 =*/ 41).double(message.changePercent);
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.name);
      if (message.ipoDate != null && Object.hasOwnProperty.call(message, 'ipoDate'))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.ipoDate);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.exchange);
      if (message.tradeExchange != null && Object.hasOwnProperty.call(message, 'tradeExchange'))
        writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.tradeExchange);
      if (message.marketCap != null && Object.hasOwnProperty.call(message, 'marketCap'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).int64(message.marketCap);
      if (message.rsi != null && Object.hasOwnProperty.call(message, 'rsi'))
        writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.rsi);
      if (message.atr != null && Object.hasOwnProperty.call(message, 'atr'))
        writer.uint32(/* id 12, wireType 1 =*/ 97).double(message.atr);
      if (message.pe != null && Object.hasOwnProperty.call(message, 'pe'))
        writer.uint32(/* id 13, wireType 1 =*/ 105).double(message.pe);
      if (message.averageVolume != null && Object.hasOwnProperty.call(message, 'averageVolume'))
        writer.uint32(/* id 14, wireType 0 =*/ 112).int64(message.averageVolume);
      if (message.sharesOutstanding != null && Object.hasOwnProperty.call(message, 'sharesOutstanding'))
        writer.uint32(/* id 15, wireType 0 =*/ 120).int64(message.sharesOutstanding);
      if (message.sector != null && Object.hasOwnProperty.call(message, 'sector'))
        writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.sector);
      if (message.sectorCode != null && Object.hasOwnProperty.call(message, 'sectorCode'))
        writer.uint32(/* id 17, wireType 0 =*/ 136).int32(message.sectorCode);
      if (message.industry != null && Object.hasOwnProperty.call(message, 'industry'))
        writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.industry);
      if (message.industryCode != null && Object.hasOwnProperty.call(message, 'industryCode'))
        writer.uint32(/* id 19, wireType 0 =*/ 152).int32(message.industryCode);
      if (message.forwardPERatio != null && Object.hasOwnProperty.call(message, 'forwardPERatio'))
        writer.uint32(/* id 20, wireType 1 =*/ 161).double(message.forwardPERatio);
      if (message.pricetoEBITDA != null && Object.hasOwnProperty.call(message, 'pricetoEBITDA'))
        writer.uint32(/* id 21, wireType 1 =*/ 169).double(message.pricetoEBITDA);
      if (message.trailingDividendYield != null && Object.hasOwnProperty.call(message, 'trailingDividendYield'))
        writer.uint32(/* id 22, wireType 1 =*/ 177).double(message.trailingDividendYield);
      if (message.PBRatio != null && Object.hasOwnProperty.call(message, 'PBRatio'))
        writer.uint32(/* id 23, wireType 1 =*/ 185).double(message.PBRatio);
      if (message.PSRatio != null && Object.hasOwnProperty.call(message, 'PSRatio'))
        writer.uint32(/* id 24, wireType 1 =*/ 193).double(message.PSRatio);
      if (message.FCFPerShare != null && Object.hasOwnProperty.call(message, 'FCFPerShare'))
        writer.uint32(/* id 25, wireType 1 =*/ 201).double(message.FCFPerShare);
      if (message.buyBackYield != null && Object.hasOwnProperty.call(message, 'buyBackYield'))
        writer.uint32(/* id 26, wireType 1 =*/ 209).double(message.buyBackYield);
      if (message.open != null && Object.hasOwnProperty.call(message, 'open'))
        writer.uint32(/* id 27, wireType 1 =*/ 217).double(message.open);
      if (message.price != null && Object.hasOwnProperty.call(message, 'price'))
        writer.uint32(/* id 28, wireType 1 =*/ 225).double(message.price);
      if (message.high != null && Object.hasOwnProperty.call(message, 'high'))
        writer.uint32(/* id 29, wireType 1 =*/ 233).double(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, 'low'))
        writer.uint32(/* id 30, wireType 1 =*/ 241).double(message.low);
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 31, wireType 0 =*/ 248).int64(message.time);
      if (message.size != null && Object.hasOwnProperty.call(message, 'size'))
        writer.uint32(/* id 32, wireType 0 =*/ 256).int32(message.size);
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 33, wireType 2 =*/ 266).string(message.type);
      if (message.dayVolume != null && Object.hasOwnProperty.call(message, 'dayVolume'))
        writer.uint32(/* id 34, wireType 0 =*/ 272).int64(message.dayVolume);
      if (message.askPrice != null && Object.hasOwnProperty.call(message, 'askPrice'))
        writer.uint32(/* id 35, wireType 1 =*/ 281).double(message.askPrice);
      if (message.bidPrice != null && Object.hasOwnProperty.call(message, 'bidPrice'))
        writer.uint32(/* id 36, wireType 1 =*/ 289).double(message.bidPrice);
      if (message.shareFloatDate != null && Object.hasOwnProperty.call(message, 'shareFloatDate'))
        writer.uint32(/* id 37, wireType 2 =*/ 298).string(message.shareFloatDate);
      if (message.sharesOutstandingDate != null && Object.hasOwnProperty.call(message, 'sharesOutstandingDate'))
        writer.uint32(/* id 38, wireType 2 =*/ 306).string(message.sharesOutstandingDate);
      if (message.cik != null && Object.hasOwnProperty.call(message, 'cik'))
        writer.uint32(/* id 39, wireType 0 =*/ 312).int32(message.cik);
      if (message.updateType != null && Object.hasOwnProperty.call(message, 'updateType'))
        writer.uint32(/* id 40, wireType 0 =*/ 320).int32(message.updateType);
      if (message.sessionType != null && Object.hasOwnProperty.call(message, 'sessionType'))
        writer.uint32(/* id 41, wireType 0 =*/ 328).int32(message.sessionType);
      if (message.changePercent1Minute != null && Object.hasOwnProperty.call(message, 'changePercent1Minute'))
        writer.uint32(/* id 50, wireType 1 =*/ 401).double(message.changePercent1Minute);
      if (message.changePercentClose != null && Object.hasOwnProperty.call(message, 'changePercentClose'))
        writer.uint32(/* id 51, wireType 1 =*/ 409).double(message.changePercentClose);
      if (message.changePercent5Minute != null && Object.hasOwnProperty.call(message, 'changePercent5Minute'))
        writer.uint32(/* id 52, wireType 1 =*/ 417).double(message.changePercent5Minute);
      if (message.volume1Minute != null && Object.hasOwnProperty.call(message, 'volume1Minute'))
        writer.uint32(/* id 53, wireType 0 =*/ 424).int64(message.volume1Minute);
      if (message.relativeVolume1Minute != null && Object.hasOwnProperty.call(message, 'relativeVolume1Minute'))
        writer.uint32(/* id 54, wireType 1 =*/ 433).double(message.relativeVolume1Minute);
      if (message.change15Minute != null && Object.hasOwnProperty.call(message, 'change15Minute'))
        writer.uint32(/* id 55, wireType 1 =*/ 441).double(message.change15Minute);
      if (message.changePercent15Minute != null && Object.hasOwnProperty.call(message, 'changePercent15Minute'))
        writer.uint32(/* id 56, wireType 1 =*/ 449).double(message.changePercent15Minute);
      if (message.change30Minute != null && Object.hasOwnProperty.call(message, 'change30Minute'))
        writer.uint32(/* id 57, wireType 1 =*/ 457).double(message.change30Minute);
      if (message.changePercent30Minute != null && Object.hasOwnProperty.call(message, 'changePercent30Minute'))
        writer.uint32(/* id 58, wireType 1 =*/ 465).double(message.changePercent30Minute);
      if (message.change60Minute != null && Object.hasOwnProperty.call(message, 'change60Minute'))
        writer.uint32(/* id 59, wireType 1 =*/ 473).double(message.change60Minute);
      if (message.changePercent60Minute != null && Object.hasOwnProperty.call(message, 'changePercent60Minute'))
        writer.uint32(/* id 60, wireType 1 =*/ 481).double(message.changePercent60Minute);
      if (message.changePercentOpen != null && Object.hasOwnProperty.call(message, 'changePercentOpen'))
        writer.uint32(/* id 61, wireType 1 =*/ 489).double(message.changePercentOpen);
      if (message.gics != null && Object.hasOwnProperty.call(message, 'gics'))
        writer.uint32(/* id 70, wireType 0 =*/ 560).int32(message.gics);
      if (message.gicsSector != null && Object.hasOwnProperty.call(message, 'gicsSector'))
        writer.uint32(/* id 71, wireType 0 =*/ 568).int32(message.gicsSector);
      if (message.gicsSectorName != null && Object.hasOwnProperty.call(message, 'gicsSectorName'))
        writer.uint32(/* id 72, wireType 2 =*/ 578).string(message.gicsSectorName);
      if (message.gicsIndustryGroup != null && Object.hasOwnProperty.call(message, 'gicsIndustryGroup'))
        writer.uint32(/* id 73, wireType 0 =*/ 584).int32(message.gicsIndustryGroup);
      if (message.gicsIndustryGroupName != null && Object.hasOwnProperty.call(message, 'gicsIndustryGroupName'))
        writer.uint32(/* id 74, wireType 2 =*/ 594).string(message.gicsIndustryGroupName);
      if (message.gicsIndustry != null && Object.hasOwnProperty.call(message, 'gicsIndustry'))
        writer.uint32(/* id 75, wireType 0 =*/ 600).int32(message.gicsIndustry);
      if (message.gicsIndustryName != null && Object.hasOwnProperty.call(message, 'gicsIndustryName'))
        writer.uint32(/* id 76, wireType 2 =*/ 610).string(message.gicsIndustryName);
      if (message.gicsSubIndustry != null && Object.hasOwnProperty.call(message, 'gicsSubIndustry'))
        writer.uint32(/* id 77, wireType 0 =*/ 616).int32(message.gicsSubIndustry);
      if (message.gicsSubIndustryName != null && Object.hasOwnProperty.call(message, 'gicsSubIndustryName'))
        writer.uint32(/* id 78, wireType 2 =*/ 626).string(message.gicsSubIndustryName);
      if (message.signalName != null && Object.hasOwnProperty.call(message, 'signalName'))
        writer.uint32(/* id 80, wireType 2 =*/ 642).string(message.signalName);
      if (message.shareFloat != null && Object.hasOwnProperty.call(message, 'shareFloat'))
        writer.uint32(/* id 81, wireType 0 =*/ 648).int64(message.shareFloat);
      if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
        writer.uint32(/* id 96, wireType 0 =*/ 768).int64(message.volume);
      if (message.subtype != null && Object.hasOwnProperty.call(message, 'subtype'))
        writer.uint32(/* id 101, wireType 2 =*/ 810).string(message.subtype);
      return writer;
    };

    /**
     * Encodes the specified Quote message, length delimited. Does not implicitly {@link quotestore.Quote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof quotestore.Quote
     * @static
     * @param {quotestore.IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Quote message from the specified reader or buffer.
     * @function decode
     * @memberof quotestore.Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {quotestore.Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.quotestore.Quote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.previousClose = reader.double();
            break;
          }
          case 3: {
            message.close = reader.double();
            break;
          }
          case 4: {
            message.change = reader.double();
            break;
          }
          case 5: {
            message.changePercent = reader.double();
            break;
          }
          case 6: {
            message.name = reader.string();
            break;
          }
          case 7: {
            message.ipoDate = reader.string();
            break;
          }
          case 8: {
            message.exchange = reader.string();
            break;
          }
          case 9: {
            message.tradeExchange = reader.string();
            break;
          }
          case 10: {
            message.marketCap = reader.int64();
            break;
          }
          case 11: {
            message.rsi = reader.double();
            break;
          }
          case 12: {
            message.atr = reader.double();
            break;
          }
          case 13: {
            message.pe = reader.double();
            break;
          }
          case 14: {
            message.averageVolume = reader.int64();
            break;
          }
          case 15: {
            message.sharesOutstanding = reader.int64();
            break;
          }
          case 16: {
            message.sector = reader.string();
            break;
          }
          case 17: {
            message.sectorCode = reader.int32();
            break;
          }
          case 18: {
            message.industry = reader.string();
            break;
          }
          case 19: {
            message.industryCode = reader.int32();
            break;
          }
          case 20: {
            message.forwardPERatio = reader.double();
            break;
          }
          case 21: {
            message.pricetoEBITDA = reader.double();
            break;
          }
          case 22: {
            message.trailingDividendYield = reader.double();
            break;
          }
          case 23: {
            message.PBRatio = reader.double();
            break;
          }
          case 24: {
            message.PSRatio = reader.double();
            break;
          }
          case 25: {
            message.FCFPerShare = reader.double();
            break;
          }
          case 26: {
            message.buyBackYield = reader.double();
            break;
          }
          case 27: {
            message.open = reader.double();
            break;
          }
          case 28: {
            message.price = reader.double();
            break;
          }
          case 29: {
            message.high = reader.double();
            break;
          }
          case 30: {
            message.low = reader.double();
            break;
          }
          case 31: {
            message.time = reader.int64();
            break;
          }
          case 32: {
            message.size = reader.int32();
            break;
          }
          case 33: {
            message.type = reader.string();
            break;
          }
          case 34: {
            message.dayVolume = reader.int64();
            break;
          }
          case 35: {
            message.askPrice = reader.double();
            break;
          }
          case 36: {
            message.bidPrice = reader.double();
            break;
          }
          case 37: {
            message.shareFloatDate = reader.string();
            break;
          }
          case 38: {
            message.sharesOutstandingDate = reader.string();
            break;
          }
          case 81: {
            message.shareFloat = reader.int64();
            break;
          }
          case 40: {
            message.updateType = reader.int32();
            break;
          }
          case 101: {
            message.subtype = reader.string();
            break;
          }
          case 41: {
            message.sessionType = reader.int32();
            break;
          }
          case 96: {
            message.volume = reader.int64();
            break;
          }
          case 50: {
            message.changePercent1Minute = reader.double();
            break;
          }
          case 51: {
            message.changePercentClose = reader.double();
            break;
          }
          case 52: {
            message.changePercent5Minute = reader.double();
            break;
          }
          case 53: {
            message.volume1Minute = reader.int64();
            break;
          }
          case 54: {
            message.relativeVolume1Minute = reader.double();
            break;
          }
          case 55: {
            message.change15Minute = reader.double();
            break;
          }
          case 56: {
            message.changePercent15Minute = reader.double();
            break;
          }
          case 57: {
            message.change30Minute = reader.double();
            break;
          }
          case 58: {
            message.changePercent30Minute = reader.double();
            break;
          }
          case 59: {
            message.change60Minute = reader.double();
            break;
          }
          case 60: {
            message.changePercent60Minute = reader.double();
            break;
          }
          case 61: {
            message.changePercentOpen = reader.double();
            break;
          }
          case 70: {
            message.gics = reader.int32();
            break;
          }
          case 71: {
            message.gicsSector = reader.int32();
            break;
          }
          case 72: {
            message.gicsSectorName = reader.string();
            break;
          }
          case 73: {
            message.gicsIndustryGroup = reader.int32();
            break;
          }
          case 74: {
            message.gicsIndustryGroupName = reader.string();
            break;
          }
          case 75: {
            message.gicsIndustry = reader.int32();
            break;
          }
          case 76: {
            message.gicsIndustryName = reader.string();
            break;
          }
          case 77: {
            message.gicsSubIndustry = reader.int32();
            break;
          }
          case 78: {
            message.gicsSubIndustryName = reader.string();
            break;
          }
          case 39: {
            message.cik = reader.int32();
            break;
          }
          case 80: {
            message.signalName = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Quote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof quotestore.Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {quotestore.Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Quote message.
     * @function verify
     * @memberof quotestore.Quote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Quote.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
      if (message.close != null && message.hasOwnProperty('close'))
        if (typeof message.close !== 'number') return 'close: number expected';
      if (message.change != null && message.hasOwnProperty('change'))
        if (typeof message.change !== 'number') return 'change: number expected';
      if (message.changePercent != null && message.hasOwnProperty('changePercent'))
        if (typeof message.changePercent !== 'number') return 'changePercent: number expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.ipoDate != null && message.hasOwnProperty('ipoDate'))
        if (!$util.isString(message.ipoDate)) return 'ipoDate: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.tradeExchange != null && message.hasOwnProperty('tradeExchange'))
        if (!$util.isString(message.tradeExchange)) return 'tradeExchange: string expected';
      if (message.marketCap != null && message.hasOwnProperty('marketCap'))
        if (
          !$util.isInteger(message.marketCap) &&
          !(message.marketCap && $util.isInteger(message.marketCap.low) && $util.isInteger(message.marketCap.high))
        )
          return 'marketCap: integer|Long expected';
      if (message.rsi != null && message.hasOwnProperty('rsi'))
        if (typeof message.rsi !== 'number') return 'rsi: number expected';
      if (message.atr != null && message.hasOwnProperty('atr'))
        if (typeof message.atr !== 'number') return 'atr: number expected';
      if (message.pe != null && message.hasOwnProperty('pe'))
        if (typeof message.pe !== 'number') return 'pe: number expected';
      if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
        if (
          !$util.isInteger(message.averageVolume) &&
          !(
            message.averageVolume &&
            $util.isInteger(message.averageVolume.low) &&
            $util.isInteger(message.averageVolume.high)
          )
        )
          return 'averageVolume: integer|Long expected';
      if (message.sharesOutstanding != null && message.hasOwnProperty('sharesOutstanding'))
        if (
          !$util.isInteger(message.sharesOutstanding) &&
          !(
            message.sharesOutstanding &&
            $util.isInteger(message.sharesOutstanding.low) &&
            $util.isInteger(message.sharesOutstanding.high)
          )
        )
          return 'sharesOutstanding: integer|Long expected';
      if (message.sector != null && message.hasOwnProperty('sector'))
        if (!$util.isString(message.sector)) return 'sector: string expected';
      if (message.sectorCode != null && message.hasOwnProperty('sectorCode'))
        if (!$util.isInteger(message.sectorCode)) return 'sectorCode: integer expected';
      if (message.industry != null && message.hasOwnProperty('industry'))
        if (!$util.isString(message.industry)) return 'industry: string expected';
      if (message.industryCode != null && message.hasOwnProperty('industryCode'))
        if (!$util.isInteger(message.industryCode)) return 'industryCode: integer expected';
      if (message.forwardPERatio != null && message.hasOwnProperty('forwardPERatio'))
        if (typeof message.forwardPERatio !== 'number') return 'forwardPERatio: number expected';
      if (message.pricetoEBITDA != null && message.hasOwnProperty('pricetoEBITDA'))
        if (typeof message.pricetoEBITDA !== 'number') return 'pricetoEBITDA: number expected';
      if (message.trailingDividendYield != null && message.hasOwnProperty('trailingDividendYield'))
        if (typeof message.trailingDividendYield !== 'number') return 'trailingDividendYield: number expected';
      if (message.PBRatio != null && message.hasOwnProperty('PBRatio'))
        if (typeof message.PBRatio !== 'number') return 'PBRatio: number expected';
      if (message.PSRatio != null && message.hasOwnProperty('PSRatio'))
        if (typeof message.PSRatio !== 'number') return 'PSRatio: number expected';
      if (message.FCFPerShare != null && message.hasOwnProperty('FCFPerShare'))
        if (typeof message.FCFPerShare !== 'number') return 'FCFPerShare: number expected';
      if (message.buyBackYield != null && message.hasOwnProperty('buyBackYield'))
        if (typeof message.buyBackYield !== 'number') return 'buyBackYield: number expected';
      if (message.open != null && message.hasOwnProperty('open'))
        if (typeof message.open !== 'number') return 'open: number expected';
      if (message.price != null && message.hasOwnProperty('price'))
        if (typeof message.price !== 'number') return 'price: number expected';
      if (message.high != null && message.hasOwnProperty('high'))
        if (typeof message.high !== 'number') return 'high: number expected';
      if (message.low != null && message.hasOwnProperty('low'))
        if (typeof message.low !== 'number') return 'low: number expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (
          !$util.isInteger(message.time) &&
          !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high))
        )
          return 'time: integer|Long expected';
      if (message.size != null && message.hasOwnProperty('size'))
        if (!$util.isInteger(message.size)) return 'size: integer expected';
      if (message.type != null && message.hasOwnProperty('type'))
        if (!$util.isString(message.type)) return 'type: string expected';
      if (message.dayVolume != null && message.hasOwnProperty('dayVolume'))
        if (
          !$util.isInteger(message.dayVolume) &&
          !(message.dayVolume && $util.isInteger(message.dayVolume.low) && $util.isInteger(message.dayVolume.high))
        )
          return 'dayVolume: integer|Long expected';
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        if (typeof message.askPrice !== 'number') return 'askPrice: number expected';
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        if (typeof message.bidPrice !== 'number') return 'bidPrice: number expected';
      if (message.shareFloatDate != null && message.hasOwnProperty('shareFloatDate'))
        if (!$util.isString(message.shareFloatDate)) return 'shareFloatDate: string expected';
      if (message.sharesOutstandingDate != null && message.hasOwnProperty('sharesOutstandingDate'))
        if (!$util.isString(message.sharesOutstandingDate)) return 'sharesOutstandingDate: string expected';
      if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
        if (
          !$util.isInteger(message.shareFloat) &&
          !(message.shareFloat && $util.isInteger(message.shareFloat.low) && $util.isInteger(message.shareFloat.high))
        )
          return 'shareFloat: integer|Long expected';
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        switch (message.updateType) {
          default:
            return 'updateType: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.subtype != null && message.hasOwnProperty('subtype'))
        if (!$util.isString(message.subtype)) return 'subtype: string expected';
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        switch (message.sessionType) {
          default:
            return 'sessionType: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (
          !$util.isInteger(message.volume) &&
          !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high))
        )
          return 'volume: integer|Long expected';
      if (message.changePercent1Minute != null && message.hasOwnProperty('changePercent1Minute'))
        if (typeof message.changePercent1Minute !== 'number') return 'changePercent1Minute: number expected';
      if (message.changePercentClose != null && message.hasOwnProperty('changePercentClose'))
        if (typeof message.changePercentClose !== 'number') return 'changePercentClose: number expected';
      if (message.changePercent5Minute != null && message.hasOwnProperty('changePercent5Minute'))
        if (typeof message.changePercent5Minute !== 'number') return 'changePercent5Minute: number expected';
      if (message.volume1Minute != null && message.hasOwnProperty('volume1Minute'))
        if (
          !$util.isInteger(message.volume1Minute) &&
          !(
            message.volume1Minute &&
            $util.isInteger(message.volume1Minute.low) &&
            $util.isInteger(message.volume1Minute.high)
          )
        )
          return 'volume1Minute: integer|Long expected';
      if (message.relativeVolume1Minute != null && message.hasOwnProperty('relativeVolume1Minute'))
        if (typeof message.relativeVolume1Minute !== 'number') return 'relativeVolume1Minute: number expected';
      if (message.change15Minute != null && message.hasOwnProperty('change15Minute'))
        if (typeof message.change15Minute !== 'number') return 'change15Minute: number expected';
      if (message.changePercent15Minute != null && message.hasOwnProperty('changePercent15Minute'))
        if (typeof message.changePercent15Minute !== 'number') return 'changePercent15Minute: number expected';
      if (message.change30Minute != null && message.hasOwnProperty('change30Minute'))
        if (typeof message.change30Minute !== 'number') return 'change30Minute: number expected';
      if (message.changePercent30Minute != null && message.hasOwnProperty('changePercent30Minute'))
        if (typeof message.changePercent30Minute !== 'number') return 'changePercent30Minute: number expected';
      if (message.change60Minute != null && message.hasOwnProperty('change60Minute'))
        if (typeof message.change60Minute !== 'number') return 'change60Minute: number expected';
      if (message.changePercent60Minute != null && message.hasOwnProperty('changePercent60Minute'))
        if (typeof message.changePercent60Minute !== 'number') return 'changePercent60Minute: number expected';
      if (message.changePercentOpen != null && message.hasOwnProperty('changePercentOpen'))
        if (typeof message.changePercentOpen !== 'number') return 'changePercentOpen: number expected';
      if (message.gics != null && message.hasOwnProperty('gics'))
        if (!$util.isInteger(message.gics)) return 'gics: integer expected';
      if (message.gicsSector != null && message.hasOwnProperty('gicsSector'))
        if (!$util.isInteger(message.gicsSector)) return 'gicsSector: integer expected';
      if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
        if (!$util.isString(message.gicsSectorName)) return 'gicsSectorName: string expected';
      if (message.gicsIndustryGroup != null && message.hasOwnProperty('gicsIndustryGroup'))
        if (!$util.isInteger(message.gicsIndustryGroup)) return 'gicsIndustryGroup: integer expected';
      if (message.gicsIndustryGroupName != null && message.hasOwnProperty('gicsIndustryGroupName'))
        if (!$util.isString(message.gicsIndustryGroupName)) return 'gicsIndustryGroupName: string expected';
      if (message.gicsIndustry != null && message.hasOwnProperty('gicsIndustry'))
        if (!$util.isInteger(message.gicsIndustry)) return 'gicsIndustry: integer expected';
      if (message.gicsIndustryName != null && message.hasOwnProperty('gicsIndustryName'))
        if (!$util.isString(message.gicsIndustryName)) return 'gicsIndustryName: string expected';
      if (message.gicsSubIndustry != null && message.hasOwnProperty('gicsSubIndustry'))
        if (!$util.isInteger(message.gicsSubIndustry)) return 'gicsSubIndustry: integer expected';
      if (message.gicsSubIndustryName != null && message.hasOwnProperty('gicsSubIndustryName'))
        if (!$util.isString(message.gicsSubIndustryName)) return 'gicsSubIndustryName: string expected';
      if (message.cik != null && message.hasOwnProperty('cik'))
        if (!$util.isInteger(message.cik)) return 'cik: integer expected';
      if (message.signalName != null && message.hasOwnProperty('signalName'))
        if (!$util.isString(message.signalName)) return 'signalName: string expected';
      return null;
    };

    /**
     * Creates a Quote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof quotestore.Quote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {quotestore.Quote} Quote
     */
    Quote.fromObject = function fromObject(object) {
      if (object instanceof $root.quotestore.Quote) return object;
      let message = new $root.quotestore.Quote();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.previousClose != null) message.previousClose = Number(object.previousClose);
      if (object.close != null) message.close = Number(object.close);
      if (object.change != null) message.change = Number(object.change);
      if (object.changePercent != null) message.changePercent = Number(object.changePercent);
      if (object.name != null) message.name = String(object.name);
      if (object.ipoDate != null) message.ipoDate = String(object.ipoDate);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.tradeExchange != null) message.tradeExchange = String(object.tradeExchange);
      if (object.marketCap != null)
        if ($util.Long) (message.marketCap = $util.Long.fromValue(object.marketCap)).unsigned = false;
        else if (typeof object.marketCap === 'string') message.marketCap = parseInt(object.marketCap, 10);
        else if (typeof object.marketCap === 'number') message.marketCap = object.marketCap;
        else if (typeof object.marketCap === 'object')
          message.marketCap = new $util.LongBits(object.marketCap.low >>> 0, object.marketCap.high >>> 0).toNumber();
      if (object.rsi != null) message.rsi = Number(object.rsi);
      if (object.atr != null) message.atr = Number(object.atr);
      if (object.pe != null) message.pe = Number(object.pe);
      if (object.averageVolume != null)
        if ($util.Long) (message.averageVolume = $util.Long.fromValue(object.averageVolume)).unsigned = false;
        else if (typeof object.averageVolume === 'string') message.averageVolume = parseInt(object.averageVolume, 10);
        else if (typeof object.averageVolume === 'number') message.averageVolume = object.averageVolume;
        else if (typeof object.averageVolume === 'object')
          message.averageVolume = new $util.LongBits(
            object.averageVolume.low >>> 0,
            object.averageVolume.high >>> 0,
          ).toNumber();
      if (object.sharesOutstanding != null)
        if ($util.Long) (message.sharesOutstanding = $util.Long.fromValue(object.sharesOutstanding)).unsigned = false;
        else if (typeof object.sharesOutstanding === 'string')
          message.sharesOutstanding = parseInt(object.sharesOutstanding, 10);
        else if (typeof object.sharesOutstanding === 'number') message.sharesOutstanding = object.sharesOutstanding;
        else if (typeof object.sharesOutstanding === 'object')
          message.sharesOutstanding = new $util.LongBits(
            object.sharesOutstanding.low >>> 0,
            object.sharesOutstanding.high >>> 0,
          ).toNumber();
      if (object.sector != null) message.sector = String(object.sector);
      if (object.sectorCode != null) message.sectorCode = object.sectorCode | 0;
      if (object.industry != null) message.industry = String(object.industry);
      if (object.industryCode != null) message.industryCode = object.industryCode | 0;
      if (object.forwardPERatio != null) message.forwardPERatio = Number(object.forwardPERatio);
      if (object.pricetoEBITDA != null) message.pricetoEBITDA = Number(object.pricetoEBITDA);
      if (object.trailingDividendYield != null) message.trailingDividendYield = Number(object.trailingDividendYield);
      if (object.PBRatio != null) message.PBRatio = Number(object.PBRatio);
      if (object.PSRatio != null) message.PSRatio = Number(object.PSRatio);
      if (object.FCFPerShare != null) message.FCFPerShare = Number(object.FCFPerShare);
      if (object.buyBackYield != null) message.buyBackYield = Number(object.buyBackYield);
      if (object.open != null) message.open = Number(object.open);
      if (object.price != null) message.price = Number(object.price);
      if (object.high != null) message.high = Number(object.high);
      if (object.low != null) message.low = Number(object.low);
      if (object.time != null)
        if ($util.Long) (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === 'string') message.time = parseInt(object.time, 10);
        else if (typeof object.time === 'number') message.time = object.time;
        else if (typeof object.time === 'object')
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      if (object.size != null) message.size = object.size | 0;
      if (object.type != null) message.type = String(object.type);
      if (object.dayVolume != null)
        if ($util.Long) (message.dayVolume = $util.Long.fromValue(object.dayVolume)).unsigned = false;
        else if (typeof object.dayVolume === 'string') message.dayVolume = parseInt(object.dayVolume, 10);
        else if (typeof object.dayVolume === 'number') message.dayVolume = object.dayVolume;
        else if (typeof object.dayVolume === 'object')
          message.dayVolume = new $util.LongBits(object.dayVolume.low >>> 0, object.dayVolume.high >>> 0).toNumber();
      if (object.askPrice != null) message.askPrice = Number(object.askPrice);
      if (object.bidPrice != null) message.bidPrice = Number(object.bidPrice);
      if (object.shareFloatDate != null) message.shareFloatDate = String(object.shareFloatDate);
      if (object.sharesOutstandingDate != null) message.sharesOutstandingDate = String(object.sharesOutstandingDate);
      if (object.shareFloat != null)
        if ($util.Long) (message.shareFloat = $util.Long.fromValue(object.shareFloat)).unsigned = false;
        else if (typeof object.shareFloat === 'string') message.shareFloat = parseInt(object.shareFloat, 10);
        else if (typeof object.shareFloat === 'number') message.shareFloat = object.shareFloat;
        else if (typeof object.shareFloat === 'object')
          message.shareFloat = new $util.LongBits(object.shareFloat.low >>> 0, object.shareFloat.high >>> 0).toNumber();
      switch (object.updateType) {
        default:
          if (typeof object.updateType === 'number') {
            message.updateType = object.updateType;
            break;
          }
          break;
        case 'UNKNOWN':
        case 0:
          message.updateType = 0;
          break;
        case 'VALID':
        case 1:
          message.updateType = 1;
          break;
        case 'IN_VALID':
        case 2:
          message.updateType = 2;
          break;
      }
      if (object.subtype != null) message.subtype = String(object.subtype);
      switch (object.sessionType) {
        default:
          if (typeof object.sessionType === 'number') {
            message.sessionType = object.sessionType;
            break;
          }
          break;
        case 'NA':
        case 0:
          message.sessionType = 0;
          break;
        case 'PRE_MARKET':
        case 1:
          message.sessionType = 1;
          break;
        case 'REGULAR':
        case 2:
          message.sessionType = 2;
          break;
        case 'AFTER_MARKET':
        case 3:
          message.sessionType = 3;
          break;
      }
      if (object.volume != null)
        if ($util.Long) (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
        else if (typeof object.volume === 'string') message.volume = parseInt(object.volume, 10);
        else if (typeof object.volume === 'number') message.volume = object.volume;
        else if (typeof object.volume === 'object')
          message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
      if (object.changePercent1Minute != null) message.changePercent1Minute = Number(object.changePercent1Minute);
      if (object.changePercentClose != null) message.changePercentClose = Number(object.changePercentClose);
      if (object.changePercent5Minute != null) message.changePercent5Minute = Number(object.changePercent5Minute);
      if (object.volume1Minute != null)
        if ($util.Long) (message.volume1Minute = $util.Long.fromValue(object.volume1Minute)).unsigned = false;
        else if (typeof object.volume1Minute === 'string') message.volume1Minute = parseInt(object.volume1Minute, 10);
        else if (typeof object.volume1Minute === 'number') message.volume1Minute = object.volume1Minute;
        else if (typeof object.volume1Minute === 'object')
          message.volume1Minute = new $util.LongBits(
            object.volume1Minute.low >>> 0,
            object.volume1Minute.high >>> 0,
          ).toNumber();
      if (object.relativeVolume1Minute != null) message.relativeVolume1Minute = Number(object.relativeVolume1Minute);
      if (object.change15Minute != null) message.change15Minute = Number(object.change15Minute);
      if (object.changePercent15Minute != null) message.changePercent15Minute = Number(object.changePercent15Minute);
      if (object.change30Minute != null) message.change30Minute = Number(object.change30Minute);
      if (object.changePercent30Minute != null) message.changePercent30Minute = Number(object.changePercent30Minute);
      if (object.change60Minute != null) message.change60Minute = Number(object.change60Minute);
      if (object.changePercent60Minute != null) message.changePercent60Minute = Number(object.changePercent60Minute);
      if (object.changePercentOpen != null) message.changePercentOpen = Number(object.changePercentOpen);
      if (object.gics != null) message.gics = object.gics | 0;
      if (object.gicsSector != null) message.gicsSector = object.gicsSector | 0;
      if (object.gicsSectorName != null) message.gicsSectorName = String(object.gicsSectorName);
      if (object.gicsIndustryGroup != null) message.gicsIndustryGroup = object.gicsIndustryGroup | 0;
      if (object.gicsIndustryGroupName != null) message.gicsIndustryGroupName = String(object.gicsIndustryGroupName);
      if (object.gicsIndustry != null) message.gicsIndustry = object.gicsIndustry | 0;
      if (object.gicsIndustryName != null) message.gicsIndustryName = String(object.gicsIndustryName);
      if (object.gicsSubIndustry != null) message.gicsSubIndustry = object.gicsSubIndustry | 0;
      if (object.gicsSubIndustryName != null) message.gicsSubIndustryName = String(object.gicsSubIndustryName);
      if (object.cik != null) message.cik = object.cik | 0;
      if (object.signalName != null) message.signalName = String(object.signalName);
      return message;
    };

    /**
     * Creates a plain object from a Quote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof quotestore.Quote
     * @static
     * @param {quotestore.Quote} message Quote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Quote.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.previousClose = 0;
        object.close = 0;
        object.change = 0;
        object.changePercent = 0;
        object.name = '';
        object.ipoDate = '';
        object.exchange = '';
        object.tradeExchange = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.marketCap =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.marketCap = options.longs === String ? '0' : 0;
        object.rsi = 0;
        object.atr = 0;
        object.pe = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesOutstanding =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesOutstanding = options.longs === String ? '0' : 0;
        object.sector = '';
        object.sectorCode = 0;
        object.industry = '';
        object.industryCode = 0;
        object.forwardPERatio = 0;
        object.pricetoEBITDA = 0;
        object.trailingDividendYield = 0;
        object.PBRatio = 0;
        object.PSRatio = 0;
        object.FCFPerShare = 0;
        object.buyBackYield = 0;
        object.open = 0;
        object.price = 0;
        object.high = 0;
        object.low = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.time = options.longs === String ? '0' : 0;
        object.size = 0;
        object.type = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayVolume = options.longs === String ? '0' : 0;
        object.askPrice = 0;
        object.bidPrice = 0;
        object.shareFloatDate = '';
        object.sharesOutstandingDate = '';
        object.cik = 0;
        object.updateType = options.enums === String ? 'UNKNOWN' : 0;
        object.sessionType = options.enums === String ? 'NA' : 0;
        object.changePercent1Minute = 0;
        object.changePercentClose = 0;
        object.changePercent5Minute = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume1Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume1Minute = options.longs === String ? '0' : 0;
        object.relativeVolume1Minute = 0;
        object.change15Minute = 0;
        object.changePercent15Minute = 0;
        object.change30Minute = 0;
        object.changePercent30Minute = 0;
        object.change60Minute = 0;
        object.changePercent60Minute = 0;
        object.changePercentOpen = 0;
        object.gics = 0;
        object.gicsSector = 0;
        object.gicsSectorName = '';
        object.gicsIndustryGroup = 0;
        object.gicsIndustryGroupName = '';
        object.gicsIndustry = 0;
        object.gicsIndustryName = '';
        object.gicsSubIndustry = 0;
        object.gicsSubIndustryName = '';
        object.signalName = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.shareFloat =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.shareFloat = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume = options.longs === String ? '0' : 0;
        object.subtype = '';
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        object.previousClose =
          options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
      if (message.close != null && message.hasOwnProperty('close'))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.change != null && message.hasOwnProperty('change'))
        object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
      if (message.changePercent != null && message.hasOwnProperty('changePercent'))
        object.changePercent =
          options.json && !isFinite(message.changePercent) ? String(message.changePercent) : message.changePercent;
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.ipoDate != null && message.hasOwnProperty('ipoDate')) object.ipoDate = message.ipoDate;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.tradeExchange != null && message.hasOwnProperty('tradeExchange'))
        object.tradeExchange = message.tradeExchange;
      if (message.marketCap != null && message.hasOwnProperty('marketCap'))
        if (typeof message.marketCap === 'number')
          object.marketCap = options.longs === String ? String(message.marketCap) : message.marketCap;
        else
          object.marketCap =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.marketCap)
              : options.longs === Number
                ? new $util.LongBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0).toNumber()
                : message.marketCap;
      if (message.rsi != null && message.hasOwnProperty('rsi'))
        object.rsi = options.json && !isFinite(message.rsi) ? String(message.rsi) : message.rsi;
      if (message.atr != null && message.hasOwnProperty('atr'))
        object.atr = options.json && !isFinite(message.atr) ? String(message.atr) : message.atr;
      if (message.pe != null && message.hasOwnProperty('pe'))
        object.pe = options.json && !isFinite(message.pe) ? String(message.pe) : message.pe;
      if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
        if (typeof message.averageVolume === 'number')
          object.averageVolume = options.longs === String ? String(message.averageVolume) : message.averageVolume;
        else
          object.averageVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume)
              : options.longs === Number
                ? new $util.LongBits(message.averageVolume.low >>> 0, message.averageVolume.high >>> 0).toNumber()
                : message.averageVolume;
      if (message.sharesOutstanding != null && message.hasOwnProperty('sharesOutstanding'))
        if (typeof message.sharesOutstanding === 'number')
          object.sharesOutstanding =
            options.longs === String ? String(message.sharesOutstanding) : message.sharesOutstanding;
        else
          object.sharesOutstanding =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesOutstanding)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesOutstanding.low >>> 0,
                    message.sharesOutstanding.high >>> 0,
                  ).toNumber()
                : message.sharesOutstanding;
      if (message.sector != null && message.hasOwnProperty('sector')) object.sector = message.sector;
      if (message.sectorCode != null && message.hasOwnProperty('sectorCode')) object.sectorCode = message.sectorCode;
      if (message.industry != null && message.hasOwnProperty('industry')) object.industry = message.industry;
      if (message.industryCode != null && message.hasOwnProperty('industryCode'))
        object.industryCode = message.industryCode;
      if (message.forwardPERatio != null && message.hasOwnProperty('forwardPERatio'))
        object.forwardPERatio =
          options.json && !isFinite(message.forwardPERatio) ? String(message.forwardPERatio) : message.forwardPERatio;
      if (message.pricetoEBITDA != null && message.hasOwnProperty('pricetoEBITDA'))
        object.pricetoEBITDA =
          options.json && !isFinite(message.pricetoEBITDA) ? String(message.pricetoEBITDA) : message.pricetoEBITDA;
      if (message.trailingDividendYield != null && message.hasOwnProperty('trailingDividendYield'))
        object.trailingDividendYield =
          options.json && !isFinite(message.trailingDividendYield)
            ? String(message.trailingDividendYield)
            : message.trailingDividendYield;
      if (message.PBRatio != null && message.hasOwnProperty('PBRatio'))
        object.PBRatio = options.json && !isFinite(message.PBRatio) ? String(message.PBRatio) : message.PBRatio;
      if (message.PSRatio != null && message.hasOwnProperty('PSRatio'))
        object.PSRatio = options.json && !isFinite(message.PSRatio) ? String(message.PSRatio) : message.PSRatio;
      if (message.FCFPerShare != null && message.hasOwnProperty('FCFPerShare'))
        object.FCFPerShare =
          options.json && !isFinite(message.FCFPerShare) ? String(message.FCFPerShare) : message.FCFPerShare;
      if (message.buyBackYield != null && message.hasOwnProperty('buyBackYield'))
        object.buyBackYield =
          options.json && !isFinite(message.buyBackYield) ? String(message.buyBackYield) : message.buyBackYield;
      if (message.open != null && message.hasOwnProperty('open'))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.price != null && message.hasOwnProperty('price'))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.high != null && message.hasOwnProperty('high'))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty('low'))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.time != null && message.hasOwnProperty('time'))
        if (typeof message.time === 'number')
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.time)
              : options.longs === Number
                ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber()
                : message.time;
      if (message.size != null && message.hasOwnProperty('size')) object.size = message.size;
      if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
      if (message.dayVolume != null && message.hasOwnProperty('dayVolume'))
        if (typeof message.dayVolume === 'number')
          object.dayVolume = options.longs === String ? String(message.dayVolume) : message.dayVolume;
        else
          object.dayVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayVolume)
              : options.longs === Number
                ? new $util.LongBits(message.dayVolume.low >>> 0, message.dayVolume.high >>> 0).toNumber()
                : message.dayVolume;
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        object.askPrice = options.json && !isFinite(message.askPrice) ? String(message.askPrice) : message.askPrice;
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        object.bidPrice = options.json && !isFinite(message.bidPrice) ? String(message.bidPrice) : message.bidPrice;
      if (message.shareFloatDate != null && message.hasOwnProperty('shareFloatDate'))
        object.shareFloatDate = message.shareFloatDate;
      if (message.sharesOutstandingDate != null && message.hasOwnProperty('sharesOutstandingDate'))
        object.sharesOutstandingDate = message.sharesOutstandingDate;
      if (message.cik != null && message.hasOwnProperty('cik')) object.cik = message.cik;
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        object.updateType =
          options.enums === String
            ? $root.quotestore.TickType[message.updateType] === undefined
              ? message.updateType
              : $root.quotestore.TickType[message.updateType]
            : message.updateType;
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        object.sessionType =
          options.enums === String
            ? $root.quotestore.SessionType[message.sessionType] === undefined
              ? message.sessionType
              : $root.quotestore.SessionType[message.sessionType]
            : message.sessionType;
      if (message.changePercent1Minute != null && message.hasOwnProperty('changePercent1Minute'))
        object.changePercent1Minute =
          options.json && !isFinite(message.changePercent1Minute)
            ? String(message.changePercent1Minute)
            : message.changePercent1Minute;
      if (message.changePercentClose != null && message.hasOwnProperty('changePercentClose'))
        object.changePercentClose =
          options.json && !isFinite(message.changePercentClose)
            ? String(message.changePercentClose)
            : message.changePercentClose;
      if (message.changePercent5Minute != null && message.hasOwnProperty('changePercent5Minute'))
        object.changePercent5Minute =
          options.json && !isFinite(message.changePercent5Minute)
            ? String(message.changePercent5Minute)
            : message.changePercent5Minute;
      if (message.volume1Minute != null && message.hasOwnProperty('volume1Minute'))
        if (typeof message.volume1Minute === 'number')
          object.volume1Minute = options.longs === String ? String(message.volume1Minute) : message.volume1Minute;
        else
          object.volume1Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume1Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume1Minute.low >>> 0, message.volume1Minute.high >>> 0).toNumber()
                : message.volume1Minute;
      if (message.relativeVolume1Minute != null && message.hasOwnProperty('relativeVolume1Minute'))
        object.relativeVolume1Minute =
          options.json && !isFinite(message.relativeVolume1Minute)
            ? String(message.relativeVolume1Minute)
            : message.relativeVolume1Minute;
      if (message.change15Minute != null && message.hasOwnProperty('change15Minute'))
        object.change15Minute =
          options.json && !isFinite(message.change15Minute) ? String(message.change15Minute) : message.change15Minute;
      if (message.changePercent15Minute != null && message.hasOwnProperty('changePercent15Minute'))
        object.changePercent15Minute =
          options.json && !isFinite(message.changePercent15Minute)
            ? String(message.changePercent15Minute)
            : message.changePercent15Minute;
      if (message.change30Minute != null && message.hasOwnProperty('change30Minute'))
        object.change30Minute =
          options.json && !isFinite(message.change30Minute) ? String(message.change30Minute) : message.change30Minute;
      if (message.changePercent30Minute != null && message.hasOwnProperty('changePercent30Minute'))
        object.changePercent30Minute =
          options.json && !isFinite(message.changePercent30Minute)
            ? String(message.changePercent30Minute)
            : message.changePercent30Minute;
      if (message.change60Minute != null && message.hasOwnProperty('change60Minute'))
        object.change60Minute =
          options.json && !isFinite(message.change60Minute) ? String(message.change60Minute) : message.change60Minute;
      if (message.changePercent60Minute != null && message.hasOwnProperty('changePercent60Minute'))
        object.changePercent60Minute =
          options.json && !isFinite(message.changePercent60Minute)
            ? String(message.changePercent60Minute)
            : message.changePercent60Minute;
      if (message.changePercentOpen != null && message.hasOwnProperty('changePercentOpen'))
        object.changePercentOpen =
          options.json && !isFinite(message.changePercentOpen)
            ? String(message.changePercentOpen)
            : message.changePercentOpen;
      if (message.gics != null && message.hasOwnProperty('gics')) object.gics = message.gics;
      if (message.gicsSector != null && message.hasOwnProperty('gicsSector')) object.gicsSector = message.gicsSector;
      if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
        object.gicsSectorName = message.gicsSectorName;
      if (message.gicsIndustryGroup != null && message.hasOwnProperty('gicsIndustryGroup'))
        object.gicsIndustryGroup = message.gicsIndustryGroup;
      if (message.gicsIndustryGroupName != null && message.hasOwnProperty('gicsIndustryGroupName'))
        object.gicsIndustryGroupName = message.gicsIndustryGroupName;
      if (message.gicsIndustry != null && message.hasOwnProperty('gicsIndustry'))
        object.gicsIndustry = message.gicsIndustry;
      if (message.gicsIndustryName != null && message.hasOwnProperty('gicsIndustryName'))
        object.gicsIndustryName = message.gicsIndustryName;
      if (message.gicsSubIndustry != null && message.hasOwnProperty('gicsSubIndustry'))
        object.gicsSubIndustry = message.gicsSubIndustry;
      if (message.gicsSubIndustryName != null && message.hasOwnProperty('gicsSubIndustryName'))
        object.gicsSubIndustryName = message.gicsSubIndustryName;
      if (message.signalName != null && message.hasOwnProperty('signalName')) object.signalName = message.signalName;
      if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
        if (typeof message.shareFloat === 'number')
          object.shareFloat = options.longs === String ? String(message.shareFloat) : message.shareFloat;
        else
          object.shareFloat =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.shareFloat)
              : options.longs === Number
                ? new $util.LongBits(message.shareFloat.low >>> 0, message.shareFloat.high >>> 0).toNumber()
                : message.shareFloat;
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (typeof message.volume === 'number')
          object.volume = options.longs === String ? String(message.volume) : message.volume;
        else
          object.volume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume)
              : options.longs === Number
                ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber()
                : message.volume;
      if (message.subtype != null && message.hasOwnProperty('subtype')) object.subtype = message.subtype;
      return object;
    };

    /**
     * Converts this Quote to JSON.
     * @function toJSON
     * @memberof quotestore.Quote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Quote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Quote;
  })();

  return quotestore;
})());

export { $root as default };
